var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      (!_vm.isProd() || _vm.activeFrontV2) && _vm.state !== "edit-posted"
        ? _c(
            "p",
            {
              staticClass: "switchOldVersion",
              staticStyle: {
                color: "rgb(107, 31, 77)",
                "font-size": "15px",
                "font-weight": "500",
                cursor: "pointer",
                "margin-bottom": "17px",
                float: "right",
              },
              on: { click: _vm.switchInterface },
            },
            [_vm._v("Testez notre nouvelle interface (beta)")]
          )
        : _vm._e(),
      _vm.showLoader
        ? _c("component-loader", {
            attrs: { progress: 90, unlimitedProgress: true, activeClose: true },
            on: {
              close: function ($event) {
                _vm.showLoader = false
              },
            },
          })
        : _vm._e(),
      _vm.validated !== true
        ? _c("div", { staticClass: "form-wrapper" }, [
            _vm.state != "reshare" &&
            _vm.state != "retweet" &&
            _vm.state !== "edit-posted"
              ? _c(
                  "div",
                  { class: `typePost-wrapper ${false && "hide-div"}` },
                  [
                    _vm.standardPostEnabled()
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost",
                            class: { active: _vm.typePost === "standard" },
                            on: {
                              click: function ($event) {
                                return _vm.confirmReset("standard")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "typePost-content" }, [
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("dash.posts.standard"))),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.activeImage
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost",
                            class: { active: _vm.typePost === "image" },
                            on: {
                              click: function ($event) {
                                return _vm.confirmReset("image")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "typePost-content" }, [
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("dash.posts.image"))),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.activeVideo
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost",
                            class: { active: _vm.typePost === "video" },
                            on: {
                              click: function ($event) {
                                return _vm.confirmReset("video")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "typePost-content" }, [
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("dash.posts.video"))),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    !_vm.activeInstagramStories && _vm.onlyInstagramSelected()
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost disabled",
                            class: [{ active: _vm.typePost === "story" }],
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "typePost-content",
                                on: {
                                  click: function ($event) {
                                    _vm.changePlanConciergerie = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      text: _vm.$t(
                                        "dash.plan.change_to_get_features"
                                      ),
                                      position: "top",
                                    },
                                  },
                                  [
                                    _c("p", [_vm._v("Story")]),
                                    _vm._v("\n               \n          "),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : (_vm.activeInstagramStories &&
                          _vm.onlyInstagramSelected() &&
                          _vm.getPageInfoByBot(_vm.bot[0])
                            .instagram_username) ||
                        (_vm.bot.length === 0 &&
                          _vm.getPageInfo &&
                          _vm.getPageInfo.network === "instagram" &&
                          _vm.getPageInfo.instagram_username) ||
                        _vm.credentialsKnown
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost",
                            class: [
                              {
                                active: _vm.typePost === "story",
                                disabled: !_vm.hasStoryConfig && _vm.hasIsGroup,
                              },
                            ],
                            on: {
                              click: function ($event) {
                                _vm.hasStoryConfig || !_vm.hasIsGroup
                                  ? _vm.confirmReset("story")
                                  : null
                              },
                            },
                          },
                          [
                            !_vm.hasStoryConfig && _vm.hasIsGroup
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "typePost-content",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showConciergerieForm()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: _vm.$t(
                                            "dash.bots.status_proxy"
                                          ),
                                          position: "top",
                                        },
                                      },
                                      [
                                        _c("p", [_vm._v("Story")]),
                                        _vm._v("\n               \n          "),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c("div", { staticClass: "typePost-content" }, [
                                  _c("p", [_vm._v("Story")]),
                                ]),
                          ]
                        )
                      : (_vm.activeInstagramStories &&
                          _vm.onlyInstagramSelected()) ||
                        (_vm.bot.length === 0 &&
                          _vm.getPageInfo &&
                          _vm.getPageInfo.network === "instagram")
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost",
                            class: [
                              {
                                active: _vm.typePost === "story",
                                disabled: !_vm.hasStoryConfig && _vm.hasIsGroup,
                              },
                            ],
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.typePost,
                                  expression: "typePost",
                                },
                              ],
                              attrs: {
                                type: "radio",
                                name: "content",
                                value: "story",
                                disabled: !_vm.hasStoryConfig,
                              },
                              domProps: {
                                checked: _vm._q(_vm.typePost, "story"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showConciergerieForm()
                                },
                                change: function ($event) {
                                  _vm.typePost = "story"
                                },
                              },
                            }),
                            !_vm.hasStoryConfig && _vm.hasIsGroup
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "typePost-content",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showConciergerieForm()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: _vm.$t(
                                            "dash.bots.status_proxy"
                                          ),
                                          position: "top",
                                        },
                                      },
                                      [
                                        _c("p", [_vm._v("Story")]),
                                        _vm._v("\n               \n          "),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c("div", { staticClass: "typePost-content" }, [
                                  _c("p", [_vm._v("Story")]),
                                ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.onlyLinkedinSelected() &&
                    !_vm.activeLinkedinConciergerie
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost disabled",
                            class: { active: _vm.typePost === "document" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "typePost-content",
                                on: {
                                  click: function ($event) {
                                    _vm.changePlanConciergerie = true
                                  },
                                },
                              },
                              [
                                !_vm.hasStoryConfig
                                  ? _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: _vm.$t(
                                            "dash.plan.change_to_get_features"
                                          ),
                                          position: "top",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.posts.document")
                                            )
                                          ),
                                        ]),
                                        _vm._v("\n             \n          "),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.onlyLinkedinSelected() && _vm.activeLinkedinConciergerie
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost",
                            class: {
                              active: _vm.typePost === "document",
                              disabled: !_vm.hasStoryConfig,
                            },
                            on: {
                              click: function ($event) {
                                _vm.hasStoryConfig
                                  ? _vm.confirmReset("document")
                                  : null
                              },
                            },
                          },
                          [
                            !_vm.hasStoryConfig
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "typePost-content",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showConciergerieForm()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: _vm.$t(
                                            "dash.bots.status_proxy"
                                          ),
                                          position: "top",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.posts.document")
                                            )
                                          ),
                                        ]),
                                        _vm._v("\n               \n          "),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c("div", { staticClass: "typePost-content" }, [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("dash.posts.document"))
                                    ),
                                  ]),
                                ]),
                          ]
                        )
                      : _vm._e(),
                    _vm.onlyLinkedinSelected() &&
                    !_vm.activeLinkedinConciergerie
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost disabled",
                            class: { active: _vm.typePost === "poll" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "typePost-content",
                                on: {
                                  click: function ($event) {
                                    _vm.changePlanConciergerie = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      text: _vm.$t(
                                        "dash.plan.change_to_get_features"
                                      ),
                                      position: "top",
                                    },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.$t("dash.posts.poll"))),
                                    ]),
                                    _vm._v("\n             \n          "),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : (_vm.onlyLinkedinSelected() &&
                          _vm.activeLinkedinConciergerie) ||
                        _vm.onlyWhatsappSelected()
                      ? _c(
                          "div",
                          {
                            staticClass: "typePost",
                            class: {
                              active: _vm.typePost === "poll",
                              disabled:
                                !_vm.hasStoryConfig &&
                                !_vm.onlyWhatsappSelected(),
                            },
                            on: {
                              click: function ($event) {
                                _vm.hasStoryConfig || _vm.onlyWhatsappSelected()
                                  ? _vm.confirmReset("poll")
                                  : null
                              },
                            },
                          },
                          [
                            !_vm.hasStoryConfig && !_vm.onlyWhatsappSelected()
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "typePost-content",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showConciergerieForm()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: _vm.$t(
                                            "dash.bots.status_proxy"
                                          ),
                                          position: "top",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.$t("dash.posts.poll"))
                                          ),
                                        ]),
                                        _vm._v("\n               \n          "),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c("div", { staticClass: "typePost-content" }, [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.$t("dash.posts.poll"))),
                                  ]),
                                ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "vs-prompt",
                      {
                        staticClass: "popup-credentials",
                        attrs: {
                          title: "Identifiants Instagram",
                          color: "info",
                          "is-valid":
                            _vm.instagramUsername.length > 0 &&
                            _vm.instagramPassword.length > 0,
                          active: _vm.instagramCredentialsPopup,
                        },
                        on: {
                          cancel: () => {
                            _vm.instagramCredentialsPopup = false
                            this.typePost = "standard"
                          },
                          accept: _vm.sendInstagramCredentials,
                          close: () => {
                            _vm.instagramCredentialsPopup = false
                            this.typePost = "standard"
                          },
                          "update:active": function ($event) {
                            _vm.instagramCredentialsPopup = $event
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "con-exemple-prompt" },
                          [
                            _c("p", [
                              _vm._v(
                                "Aucun identifiants renseignés pour cette page, ajoutez les : "
                              ),
                            ]),
                            _c("vs-input", {
                              attrs: {
                                label: "Nom d'utilisateur ou Email",
                                placeholder: "",
                              },
                              model: {
                                value: _vm.instagramUsername,
                                callback: function ($$v) {
                                  _vm.instagramUsername = $$v
                                },
                                expression: "instagramUsername",
                              },
                            }),
                            _c("vs-input", {
                              attrs: {
                                type: "password",
                                label: "Mot de passe",
                                placeholder: "",
                              },
                              model: {
                                value: _vm.instagramPassword,
                                callback: function ($$v) {
                                  _vm.instagramPassword = $$v
                                },
                                expression: "instagramPassword",
                              },
                            }),
                            _c(
                              "vs-alert",
                              {
                                attrs: {
                                  active:
                                    _vm.instagramUsername.length === 0 ||
                                    _vm.instagramPassword.length === 0,
                                  color: "danger",
                                  icon: "new_releases",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Les champs ne peuvent pas être vide.\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.typePost == "story"
              ? _c(
                  "div",
                  { staticClass: "stories-tabs" },
                  [
                    _c(
                      "draggable",
                      {
                        staticClass: "stories-tabs drag-tabs",
                        model: {
                          value: _vm.storyMultiple,
                          callback: function ($$v) {
                            _vm.storyMultiple = $$v
                          },
                          expression: "storyMultiple",
                        },
                      },
                      _vm._l(_vm.storyMultiple, function (story, idx) {
                        return _c(
                          "span",
                          {
                            key: story.id,
                            class: `stories-tab ${story.isActive && "active"}`,
                            on: {
                              click: function ($event) {
                                return _vm.selectMultipleStory(idx)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(`Story ${idx + 1}`) +
                                " \n          "
                            ),
                            _vm.storyMultiple.length > 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "stories-tab-remove",
                                    on: {
                                      click: (e) =>
                                        _vm.removeMultipleStory(e, idx),
                                    },
                                  },
                                  [_c("i", { staticClass: "fa-solid fa-plus" })]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm.storyMultiple.length < 10
                      ? _c(
                          "span",
                          {
                            staticClass: "stories-tab stories-tab-add",
                            on: { click: _vm.addMultipleStory },
                          },
                          [_vm._v("\n        +\n      ")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "form",
              {
                attrs: { "data-vv-scope": "posts" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.confirmPost.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "form-inputs" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pages-sidebar",
                        class: { contract: _vm.tabsIsMinimize },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "table-title",
                            on: { click: _vm.toggleExpandTabs },
                          },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("dash.posts.title"))),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "show-setting" }, [
                          !_vm.tabsIsMinimize
                            ? _c(
                                "i",
                                {
                                  staticClass:
                                    "material-icons expand-btn minimize",
                                  on: { click: _vm.toggleExpandTabs },
                                },
                                [_vm._v("navigate_before")]
                              )
                            : _vm._e(),
                          _vm.tabsIsMinimize
                            ? _c(
                                "i",
                                {
                                  staticClass:
                                    "material-icons expand-btn maximize",
                                  on: { click: _vm.toggleExpandTabs },
                                },
                                [_vm._v("navigate_next")]
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          { staticClass: "search-page" },
                          [
                            _c("vs-input", {
                              staticClass: "inputx",
                              class: { input: true },
                              attrs: {
                                color: "#B20564",
                                "icon-after": "true",
                                icon: "search",
                                placeholder: _vm.$t(
                                  "dash.settings.user.label.page_filter"
                                ),
                              },
                              model: {
                                value: _vm.pageFilter,
                                callback: function ($$v) {
                                  _vm.pageFilter = $$v
                                },
                                expression: "pageFilter",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "filter-selected" },
                          [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.filterSelected = !_vm.filterSelected
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      !_vm.filterSelected
                                        ? `dash.pages-sidebar.filter-selected${
                                            _vm.bot.length > 1 ? "-multi" : ""
                                          }`
                                        : "dash.pages-sidebar.filter-all"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  text: _vm.$t(
                                    !_vm.selectAllPages
                                      ? `dash.pages-sidebar.cta-select-all`
                                      : "dash.pages-sidebar.cta-unselect-all"
                                  ),
                                  position: "top",
                                },
                              },
                              [
                                !_vm.selectAllPages
                                  ? _c("img", {
                                      attrs: {
                                        alt: "Select all pages",
                                        src: require("../../../assets/img/select_all_icon.svg"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.selectAllPages =
                                            !_vm.selectAllPages
                                        },
                                      },
                                    })
                                  : _c("img", {
                                      attrs: {
                                        alt: "Unselect pages",
                                        src: require("../../../assets/img/unselect_icon.svg"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.selectAllPages =
                                            !_vm.selectAllPages
                                        },
                                      },
                                    }),
                                _vm._v("\n               \n            "),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "ul",
                          { class: [{ "selected-pages": _vm.filterSelected }] },
                          [
                            _vm._l(
                              _vm.groups.filter(
                                (f) =>
                                  (!_vm.checkPagesInGroup(f) ||
                                    _vm.checkGroupFilter(f)) == false
                              ),
                              function (group) {
                                return _c(
                                  "li",
                                  {
                                    key: group.id,
                                    staticClass: "group",
                                    class: [
                                      {
                                        show: group.show,
                                        hide:
                                          !_vm.checkPagesInGroup(group) ||
                                          _vm.checkGroupFilter(group),
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "group-wrapper" },
                                      [
                                        !group.show
                                          ? _c("img", {
                                              staticClass: "show-group",
                                              attrs: {
                                                alt: "show group",
                                                src: require("../../../assets/img/icon-show-group.svg"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleShowGroup(
                                                    group
                                                  )
                                                },
                                              },
                                            })
                                          : _c("img", {
                                              staticClass: "hide-group",
                                              attrs: {
                                                alt: "hide group",
                                                src: require("../../../assets/img/icon-hide-group.svg"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleShowGroup(
                                                    group
                                                  )
                                                },
                                              },
                                            }),
                                        _c(
                                          "div",
                                          { staticClass: "group-content" },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: group.name,
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group-name messagedefilant",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          "data-text":
                                                            group.name,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(group.name)
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                     \n                  "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "checkbox" }, [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.selectedGroups,
                                                expression: "selectedGroups",
                                              },
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: `group-${group.id}`,
                                              name: "groups[]",
                                              disabled:
                                                !_vm.isUserPremiumActive &&
                                                !_vm.isUserPartner,
                                            },
                                            domProps: {
                                              value: group.id,
                                              checked: Array.isArray(
                                                _vm.selectedGroups
                                              )
                                                ? _vm._i(
                                                    _vm.selectedGroups,
                                                    group.id
                                                  ) > -1
                                                : _vm.selectedGroups,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a = _vm.selectedGroups,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = group.id,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.selectedGroups =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.selectedGroups =
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                    }
                                                  } else {
                                                    _vm.selectedGroups = $$c
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.checkGroup(group)
                                                },
                                              ],
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "checkmark",
                                              class: [
                                                {
                                                  deselect:
                                                    _vm.checkAllPagesGroupSelected(
                                                      group
                                                    ),
                                                },
                                              ],
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  alt: "checkup",
                                                  src: require("../../../assets/img/icon-checkup.svg"),
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("remove")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "ul",
                                      _vm._l(
                                        group.pages.filter(
                                          (f) =>
                                            _vm.findPage(f) &&
                                            (!_vm.checkPageFilter(
                                              _vm.findPage(f).page
                                            ) ||
                                              !_vm.checkSelected(
                                                _vm.findPage(f).page
                                              )) == false
                                        ),
                                        function (item) {
                                          return _c("div", { key: item }, [
                                            _vm.findPage(item)
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass: "page",
                                                    class: [
                                                      {
                                                        disabled:
                                                          !_vm.checkLock(
                                                            _vm.findPage(item)
                                                              .page.network
                                                          ),
                                                      },
                                                    ],
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "page-wrapper",
                                                        class: {
                                                          disabled:
                                                            !_vm.checkLock(
                                                              _vm.findPage(item)
                                                                .page.network
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "checkbox",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.bot,
                                                                  expression:
                                                                    "bot",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                                id: `pages-${
                                                                  _vm.findPage(
                                                                    item
                                                                  ).id
                                                                }`,
                                                                name: "pages[]",
                                                                disabled:
                                                                  !_vm.checkLock(
                                                                    _vm.findPage(
                                                                      item
                                                                    ).page
                                                                      .network
                                                                  ) ||
                                                                  (_vm.findPage(
                                                                    item
                                                                  ).page
                                                                    .network ==
                                                                    "pinterest" &&
                                                                    _vm.getBoardPagePinterest &&
                                                                    _vm.getBoardPagePinterest !=
                                                                      _vm.findPage(
                                                                        item
                                                                      ).id) ||
                                                                  (!_vm.findPage(
                                                                    item
                                                                  ).status &&
                                                                    [
                                                                      "linkedin",
                                                                      "instagram",
                                                                    ].includes(
                                                                      _vm.findPage(
                                                                        item
                                                                      ).page
                                                                        .network
                                                                    ) &&
                                                                    !_vm.isConciergerie(
                                                                      _vm.findPage(
                                                                        item
                                                                      ).page
                                                                    )),
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.findPage(
                                                                    item
                                                                  ).id,
                                                                checked:
                                                                  Array.isArray(
                                                                    _vm.bot
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm.bot,
                                                                        _vm.findPage(
                                                                          item
                                                                        ).id
                                                                      ) > -1
                                                                    : _vm.bot,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm.bot,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          _vm.findPage(
                                                                            item
                                                                          ).id,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          (_vm.bot =
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            ))
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          (_vm.bot =
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              ))
                                                                      }
                                                                    } else {
                                                                      _vm.bot =
                                                                        $$c
                                                                    }
                                                                  },
                                                              },
                                                            }),
                                                            _vm._m(0, true),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "page-content",
                                                          },
                                                          [
                                                            _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text:
                                                                    !_vm.checkLock(
                                                                      _vm.findPage(
                                                                        item
                                                                      ).page
                                                                        .network
                                                                    ) ||
                                                                    (_vm.findPage(
                                                                      item
                                                                    ).page
                                                                      .network ==
                                                                      "pinterest" &&
                                                                      _vm.getBoardPagePinterest &&
                                                                      _vm.getBoardPagePinterest !=
                                                                        _vm.findPage(
                                                                          item
                                                                        ).id) ||
                                                                    (!_vm.findPage(
                                                                      item
                                                                    ).status &&
                                                                      [
                                                                        "linkedin",
                                                                        "instagram",
                                                                      ].includes(
                                                                        _vm.findPage(
                                                                          item
                                                                        ).page
                                                                          .network
                                                                      ) &&
                                                                      !_vm.isConciergerie(
                                                                        _vm.findPage(
                                                                          item
                                                                        ).page
                                                                      ))
                                                                      ? `${
                                                                          _vm.findPage(
                                                                            item
                                                                          ).page
                                                                            .name
                                                                        } ${_vm.$t(
                                                                          "dash.bots.status_ko"
                                                                        )}`
                                                                      : _vm.findPage(
                                                                          item
                                                                        ).page
                                                                          .name,
                                                                  position:
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "page-image-avatar",
                                                                  {
                                                                    attrs: {
                                                                      page: _vm.findPage(
                                                                        item
                                                                      ).page,
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "page-name messagedefilant",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        attrs: {
                                                                          "data-text":
                                                                            _vm.findPage(
                                                                              item
                                                                            )
                                                                              .page
                                                                              .name,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.findPage(
                                                                                  item
                                                                                )
                                                                                  .page
                                                                                  .name
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                           \n                        "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            (_vm.activeLinkedinConciergerie ||
                                                              _vm.activeInstagramConciergerie) &&
                                                            [
                                                              "linkedin",
                                                              "instagram",
                                                            ].includes(
                                                              _vm.findPage(item)
                                                                .page.network
                                                            )
                                                              ? _c(
                                                                  "component-conciergerie",
                                                                  {
                                                                    attrs: {
                                                                      page: _vm.findPage(
                                                                        item
                                                                      ).page,
                                                                    },
                                                                    on: {
                                                                      getPagesEvent:
                                                                        _vm.getPagesEvent,
                                                                      closeActiveConciergerie:
                                                                        _vm.closeActiveConciergerie,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._l(
                              _vm.listPages.filter(
                                (f) =>
                                  (!_vm.checkPageFilter(f.page) ||
                                    _vm.pageInGroup(f.page) ||
                                    !_vm.checkSelected(f.page)) == false
                              ),
                              function (item, index) {
                                return _c(
                                  "li",
                                  {
                                    key: item.id,
                                    staticClass: "page",
                                    class: [
                                      {
                                        disabled: !_vm.checkLock(
                                          item.page.network
                                        ),
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "page-wrapper",
                                        class: {
                                          disabled:
                                            !_vm.checkLock(item.page.network) ||
                                            (!_vm.isUserPremiumActive &&
                                              index != 0 &&
                                              !_vm.isUserPartner),
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("navigate_next")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "page-content" },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text:
                                                    !_vm.checkLock(
                                                      item.page.network
                                                    ) ||
                                                    (item.page.network ==
                                                      "pinterest" &&
                                                      _vm.getBoardPagePinterest &&
                                                      _vm.getBoardPagePinterest !=
                                                        item.id) ||
                                                    (!item.status &&
                                                      [
                                                        "linkedin",
                                                        "instagram",
                                                      ].includes(
                                                        item.page.network
                                                      ) &&
                                                      !_vm.isConciergerie(
                                                        item.page
                                                      ))
                                                      ? `${
                                                          item.page.name
                                                        } - ${_vm.$t(
                                                          "dash.bots.status_ko"
                                                        )}`
                                                      : item.page.name,
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("page-image-avatar", {
                                                  attrs: { page: item.page },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "page-name messagedefilant",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          "data-text":
                                                            item.page.name,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.page.name
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                     \n                  "
                                                ),
                                              ],
                                              1
                                            ),
                                            (_vm.activeLinkedinConciergerie ||
                                              _vm.activeInstagramConciergerie) &&
                                            ["linkedin", "instagram"].includes(
                                              item.page.network
                                            )
                                              ? _c("component-conciergerie", {
                                                  attrs: { page: item.page },
                                                  on: {
                                                    getPagesEvent:
                                                      _vm.getPagesEvent,
                                                    closeActiveConciergerie:
                                                      _vm.closeActiveConciergerie,
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "checkbox" }, [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.bot,
                                                expression: "bot",
                                              },
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: `pages-${item.id}`,
                                              name: "pages[]",
                                              disabled:
                                                !_vm.checkLock(
                                                  item.page.network
                                                ) ||
                                                (!_vm.isUserPremiumActive &&
                                                  index != 0 &&
                                                  !_vm.isUserPartner) ||
                                                (item.page.network ==
                                                  "pinterest" &&
                                                  _vm.getBoardPagePinterest &&
                                                  _vm.getBoardPagePinterest !=
                                                    item.id) ||
                                                (!item.status &&
                                                  [
                                                    "linkedin",
                                                    "instagram",
                                                  ].includes(
                                                    item.page.network
                                                  ) &&
                                                  !_vm.isConciergerie(
                                                    item.page
                                                  )),
                                            },
                                            domProps: {
                                              value: item.id,
                                              checked: Array.isArray(_vm.bot)
                                                ? _vm._i(_vm.bot, item.id) > -1
                                                : _vm.bot,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.bot,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = item.id,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.bot = $$a.concat([
                                                        $$v,
                                                      ]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.bot = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.bot = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._m(1, true),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                    (_vm.typePost !== "story" ||
                      _vm.isPremiumInstagramAccount) &&
                    !_vm.onlyTiktokSelected() &&
                    !(
                      _vm.typePost === "video" &&
                      _vm.onlyInstagramSelected() &&
                      !_vm.shareAfterPost
                    )
                      ? _c("div", { staticClass: "input-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass: "disable-story-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return (() => {
                                    _vm.typePost === "story" &&
                                      !_vm.onlyInstagramConciergerieSelected() &&
                                      _vm.showConciergerieForm()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "Tooltip",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    active:
                                      _vm.typePost === "story" &&
                                      !_vm.onlyInstagramConciergerieSelected(),
                                    text: _vm.$t("dash.bots.status_proxy"),
                                  },
                                },
                                [
                                  _c("vs-input", {
                                    staticClass: "inputx lower-input",
                                    class: {
                                      input: true,
                                      "is-danger":
                                        (_vm.errors.has("posts.url") ||
                                          !_vm.validURL(_vm.form.url)) &&
                                        !(
                                          _vm.typePost === "story" &&
                                          !_vm.onlyInstagramConciergerieSelected()
                                        ),
                                    },
                                    attrs: {
                                      "nope.v-validate": "'required'",
                                      "vs-size": "large",
                                      color: "#B20564",
                                      type: "text",
                                      name: "url",
                                      placeholder: _vm.$t(
                                        "dash.posts.overlay.link_placeholder"
                                      ),
                                      disabled:
                                        _vm.state == "reshare" ||
                                        _vm.state == "retweet" ||
                                        (_vm.typePost === "story" &&
                                          !_vm.onlyInstagramConciergerieSelected()),
                                      "data-qa": "form-post-url",
                                    },
                                    on: {
                                      input: () =>
                                        _vm.$store.commit(
                                          `updateStorificationLink`,
                                          { active: true }
                                        ),
                                    },
                                    model: {
                                      value: _vm.form.url,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "url", $$v)
                                      },
                                      expression: "form.url",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          !_vm.validURL(_vm.form.url) &&
                          !(
                            _vm.typePost === "story" &&
                            !_vm.onlyInstagramConciergerieSelected()
                          )
                            ? _c("span", { staticClass: "not-valid-url" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("dash.posts.overlay.invalid_url")
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm.typePost === "story" && _vm.form.url
                      ? _c(
                          "div",
                          { staticClass: "input-wrapper" },
                          [
                            _c("vs-input", {
                              attrs: {
                                value:
                                  (_vm.$store.getters.storification &&
                                    _vm.$store.getters.storification.link &&
                                    _vm.$store.getters.storification.link
                                      .text) ||
                                  _vm.storyLinkText,
                                label: "Lien personnalisé (optionnel) : ",
                                placeholder: "Texte du lien",
                              },
                              on: {
                                input: (e) =>
                                  _vm.$store.commit(`updateStorificationLink`, {
                                    text: e,
                                  }),
                                keypress: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "options-wrapper" }, [
                      !_vm.showOptionsWrapper &&
                      (_vm.bots.find(
                        (b) =>
                          _vm.bot.includes(b.id) &&
                          (b.hashtagPrefix || b.hashtag)
                      ) ||
                        _vm.bots.find(
                          (b) =>
                            _vm.bot.includes(b.id) &&
                            b.mentions &&
                            Object.keys(b.mentions).length !== 0
                        ) ||
                        _vm.bots.find(
                          (b) =>
                            _vm.bot.includes(b.id) &&
                            b.hashtagsAuto &&
                            Object.keys(b.hashtagsAuto).length !== 0
                        ))
                        ? _c(
                            "div",
                            {
                              staticClass: "advanced",
                              on: {
                                click: function ($event) {
                                  _vm.showOptionsWrapper = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("dash.posts.advanced-options"))
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.showOptionsWrapper && _vm.state != "retweet"
                        ? _c("ul", [
                            _vm.bots.find(
                              (b) =>
                                _vm.bot.includes(b.id) &&
                                (b.hashtagPrefix || b.hashtag)
                            )
                              ? _c("li", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.activePrefixSuffix,
                                        expression: "activePrefixSuffix",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      name: "content",
                                      value: "false",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.activePrefixSuffix
                                      )
                                        ? _vm._i(
                                            _vm.activePrefixSuffix,
                                            "false"
                                          ) > -1
                                        : _vm.activePrefixSuffix,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.activePrefixSuffix,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "false",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.activePrefixSuffix =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.activePrefixSuffix = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.activePrefixSuffix = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._m(2),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.posts.active_prefix_suffix"
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.bots.find(
                              (b) =>
                                _vm.bot.includes(b.id) &&
                                b.mentions &&
                                Object.keys(b.mentions).length !== 0
                            )
                              ? _c("li", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.activeMentionsAutoReplace,
                                        expression: "activeMentionsAutoReplace",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      name: "content",
                                      value: "false",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.activeMentionsAutoReplace
                                      )
                                        ? _vm._i(
                                            _vm.activeMentionsAutoReplace,
                                            "false"
                                          ) > -1
                                        : _vm.activeMentionsAutoReplace,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.activeMentionsAutoReplace,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "false",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.activeMentionsAutoReplace =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.activeMentionsAutoReplace =
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.activeMentionsAutoReplace = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._m(3),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.posts.active_mentions_auto_replace"
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.bots.find(
                              (b) =>
                                _vm.bot.includes(b.id) &&
                                b.hashtagsAuto &&
                                Object.keys(b.hashtagsAuto).length !== 0
                            )
                              ? _c("li", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.activeHashtagsAutoAdd,
                                        expression: "activeHashtagsAutoAdd",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      name: "content",
                                      value: "false",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.activeHashtagsAutoAdd
                                      )
                                        ? _vm._i(
                                            _vm.activeHashtagsAutoAdd,
                                            "false"
                                          ) > -1
                                        : _vm.activeHashtagsAutoAdd,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.activeHashtagsAutoAdd,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "false",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.activeHashtagsAutoAdd =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.activeHashtagsAutoAdd = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.activeHashtagsAutoAdd = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._m(4),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.posts.active_hashtags_auto_add"
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.typePost === "story" && _vm.templateDefault
                              ? _c("li", [
                                  _c("input", {
                                    attrs: {
                                      type: "checkbox",
                                      name: "template",
                                    },
                                    domProps: {
                                      checked:
                                        _vm.templateManual ===
                                        _vm.templateDefault,
                                    },
                                    on: {
                                      change: () => {
                                        _vm.templateManual
                                          ? (_vm.templateManual = null)
                                          : (_vm.templateManual =
                                              _vm.templateDefault)
                                      },
                                    },
                                  }),
                                  _vm._m(5),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.posts.active_template_story"
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm.shareAfterPost &&
                      _vm.form.url &&
                      _vm.typePost !== "story"
                        ? _c(
                            "div",
                            { staticClass: "input-wrapper" },
                            [
                              _c("vs-input", {
                                attrs: {
                                  value:
                                    _vm.$store.getters.storificationLinkText,
                                  label: _vm.$t("dash.template.custom_link"),
                                },
                                on: {
                                  keypress: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                  },
                                  input: (e) =>
                                    _vm.$store.commit(
                                      `updateStorificationLink`,
                                      { text: e }
                                    ),
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      ["image", "standard", "video"].includes(_vm.typePost) &&
                      _vm.atLeastInstagramConciergerieSelected() &&
                      _vm.state !== "edit-posted"
                        ? _c(
                            "div",
                            { staticClass: "share-story" },
                            [
                              _c(
                                "vs-checkbox",
                                {
                                  staticClass: "share-story-box",
                                  on: {
                                    change: (e) =>
                                      e.target.checked &&
                                      (!_vm.$store.getters.storification ||
                                        _vm.$store.getters.storification
                                          .link === null) &&
                                      _vm.$store.commit(
                                        `updateStorificationLink`,
                                        { active: true }
                                      ),
                                  },
                                  model: {
                                    value: _vm.shareAfterPost,
                                    callback: function ($$v) {
                                      _vm.shareAfterPost = $$v
                                    },
                                    expression: "shareAfterPost",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("dash.bots.shared_story"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    (_vm.typePost === "story" ||
                      (_vm.shareAfterPost &&
                        _vm.state !== "edit-posted" &&
                        ["image", "standard", "video"].includes(_vm.typePost) &&
                        _vm.onlyInstagramConciergerieSelected())) &&
                    !_vm.atLeastInstagramFullConciergerieSelected()
                      ? _c("div", { staticClass: "share-story story-fb" }, [
                          _c(
                            "div",
                            {
                              staticClass: "disable-story-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return (() => {
                                    _vm.typePost === "story" &&
                                      !_vm.onlyInstagramConciergerieSelected() &&
                                      _vm.showConciergerieForm()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    active:
                                      _vm.typePost === "story" &&
                                      !_vm.onlyInstagramConciergerieSelected(),
                                    text: _vm.$t("dash.bots.status_proxy"),
                                  },
                                },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticClass: "share-story-box",
                                      attrs: {
                                        disabled:
                                          _vm.typePost === "story" &&
                                          !_vm.onlyInstagramConciergerieSelected(),
                                      },
                                      model: {
                                        value: _vm.storyShareToFacebook,
                                        callback: function ($$v) {
                                          _vm.storyShareToFacebook = $$v
                                        },
                                        expression: "storyShareToFacebook",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.bots.shared_story_fb")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.shareAfterPost &&
                    _vm.form.url &&
                    _vm.typePost !== "story" &&
                    ["image", "standard"].includes(_vm.typePost) &&
                    _vm.atLeastInstagramConciergerieSelected()
                      ? _c(
                          "div",
                          { staticClass: "share-story story-fb" },
                          [
                            _c(
                              "vs-checkbox",
                              {
                                staticClass: "share-story-box",
                                attrs: {
                                  checked:
                                    _vm.$store.getters
                                      .storificationLinkIsActive,
                                },
                                on: {
                                  change: (e) =>
                                    _vm.$store.commit(
                                      `updateStorificationLink`,
                                      { active: e.target.checked }
                                    ),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("dash.bots.shared_story_link_active")
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.typePost !== "story" &&
                    ["image", "video"].includes(_vm.typePost) &&
                    _vm.shareAfterPost &&
                    _vm.atLeastInstagramConciergerieSelected() &&
                    (_vm.url || _vm.form.url || _vm.form.video)
                      ? _c("div", { staticClass: "layer-background" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("dash.posts.background.colors.label")
                              ) +
                              "\n            "
                          ),
                          _c("input", {
                            attrs: { type: "color" },
                            domProps: {
                              value:
                                _vm.$store.getters.storificationBackgroundColor,
                            },
                            on: {
                              change: (e) =>
                                _vm.$store.commit(
                                  `updateStorificationBackgroundColor`,
                                  e.target.value
                                ),
                            },
                          }),
                          _c(
                            "button",
                            {
                              staticClass: "btn-add",
                              attrs: { type: "button" },
                              on: {
                                click: (e) =>
                                  _vm.$store.commit(
                                    `updateStorificationBackgroundColor`,
                                    null
                                  ),
                              },
                            },
                            [_vm._v("\n              Reset\n            ")]
                          ),
                        ])
                      : _vm._e(),
                    _vm.typePost !== "story" &&
                    ["image", "standard", "video"].includes(_vm.typePost) &&
                    _vm.shareAfterPost &&
                    _vm.atLeastInstagramConciergerieSelected()
                      ? _c(
                          "div",
                          { staticClass: "poll-story" },
                          [
                            _c(
                              "vs-checkbox",
                              {
                                staticClass: "poll-story-check",
                                attrs: {
                                  checked: _vm.$store.getters.storificationPoll,
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.$store.getters.storificationPoll
                                      ? _vm.$store.commit(
                                          "updateStorificationPoll",
                                          null
                                        )
                                      : _vm.$store.commit(
                                          "updateStorificationPoll",
                                          { question: "", options: [] }
                                        )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("dash.posts.poll")))]
                            ),
                            _vm.$store.getters.storificationPoll
                              ? _c(
                                  "div",
                                  { staticClass: "poll-story-inputs" },
                                  [
                                    _c("vs-input", {
                                      staticClass: "poll-story-question",
                                      attrs: {
                                        maxlength: "50",
                                        label: _vm.$t(
                                          "dash.post.poll.question.label"
                                        ),
                                        placeholder: "Question ?",
                                        value:
                                          _vm.$store.getters.storificationPoll
                                            .question,
                                      },
                                      on: {
                                        input: (e) =>
                                          _vm.$store.commit(
                                            "updateStorificationPoll",
                                            { question: e }
                                          ),
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "poll-story-options" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "poll-story-option",
                                          attrs: {
                                            maxlength: "40",
                                            label:
                                              _vm.$t(
                                                "dash.post.poll.option.label"
                                              ) + " 1",
                                            value:
                                              _vm.$store.getters
                                                .storificationPoll.options[0] ||
                                              "",
                                            placeholder: "Oui",
                                          },
                                          on: {
                                            input: (e) =>
                                              _vm.$store.commit(
                                                "updateStorificationPollOption",
                                                { index: 0, option: e }
                                              ),
                                          },
                                        }),
                                        _c("vs-input", {
                                          staticClass: "poll-story-option",
                                          attrs: {
                                            maxlength: "40",
                                            label:
                                              _vm.$t(
                                                "dash.post.poll.option.label"
                                              ) + " 2",
                                            value:
                                              _vm.$store.getters
                                                .storificationPoll.options[1] ||
                                              "",
                                            placeholder: "Non",
                                          },
                                          on: {
                                            input: (e) =>
                                              _vm.$store.commit(
                                                "updateStorificationPollOption",
                                                { index: 1, option: e }
                                              ),
                                          },
                                        }),
                                        _c("vs-input", {
                                          staticClass: "poll-story-option",
                                          attrs: {
                                            maxlength: "40",
                                            label:
                                              _vm.$t(
                                                "dash.post.poll.option.label"
                                              ) + " 3",
                                            value:
                                              _vm.$store.getters
                                                .storificationPoll.options[2] ||
                                              "",
                                            placeholder: "Optional",
                                          },
                                          on: {
                                            input: (e) =>
                                              _vm.$store.commit(
                                                "updateStorificationPollOption",
                                                { index: 2, option: e }
                                              ),
                                          },
                                        }),
                                        _c("vs-input", {
                                          staticClass: "poll-story-option",
                                          attrs: {
                                            maxlength: "40",
                                            label:
                                              _vm.$t(
                                                "dash.post.poll.option.label"
                                              ) + " 4",
                                            value:
                                              _vm.$store.getters
                                                .storificationPoll.options[3] ||
                                              "",
                                            placeholder: "Optional",
                                          },
                                          on: {
                                            input: (e) =>
                                              _vm.$store.commit(
                                                "updateStorificationPollOption",
                                                { index: 3, option: e }
                                              ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.typePost !== "story" &&
                    ["image", "standard", "video"].includes(_vm.typePost) &&
                    _vm.shareAfterPost &&
                    _vm.atLeastInstagramConciergerieSelected()
                      ? _c(
                          "div",
                          { staticClass: "poll-story" },
                          [
                            _c(
                              "vs-checkbox",
                              {
                                staticClass: "poll-story-check",
                                attrs: {
                                  checked:
                                    _vm.$store.getters.storificationSlider,
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.$store.getters.storificationSlider
                                      ? _vm.$store.commit(
                                          "updateStorificationSlider",
                                          null
                                        )
                                      : _vm.$store.commit(
                                          "updateStorificationSlider",
                                          {
                                            question: "",
                                            emoji: "😍",
                                            color: 0,
                                          }
                                        )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("dash.posts.slider")))]
                            ),
                            _vm.$store.getters.storificationSlider
                              ? _c(
                                  "div",
                                  { staticClass: "slider-story-params" },
                                  [
                                    _c("vs-input", {
                                      staticClass: "poll-story-question",
                                      attrs: {
                                        maxlength: "45",
                                        label: _vm.$t(
                                          "dash.post.poll.question.label"
                                        ),
                                        placeholder: "(Optionnel)",
                                        value:
                                          _vm.$store.getters.storificationSlider
                                            .question,
                                      },
                                      on: {
                                        input: (e) =>
                                          _vm.$store.commit(
                                            "updateStorificationSlider",
                                            { question: e }
                                          ),
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "click-outside",
                                            rawName: "v-click-outside",
                                            value: () =>
                                              (_vm.sliderEmojiPicker = false),
                                            expression:
                                              "() => sliderEmojiPicker = false",
                                          },
                                        ],
                                        staticClass: "textarea-emoji-picker",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "emoji",
                                            on: {
                                              click: () =>
                                                (_vm.sliderEmojiPicker =
                                                  !_vm.sliderEmojiPicker),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$store.getters
                                                  .storificationSlider.emoji
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("picker", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.sliderEmojiPicker,
                                              expression: "sliderEmojiPicker",
                                            },
                                          ],
                                          staticClass: "emoji-picker-slider",
                                          attrs: {
                                            data: _vm.emojiIndex,
                                            title: "Pick your emoji...",
                                            emoji: "point_up",
                                          },
                                          on: {
                                            select: (e) =>
                                              _vm.$store.commit(
                                                "updateStorificationSlider",
                                                { emoji: e.native }
                                              ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.typePost !== "story" &&
                    ["image", "standard", "video"].includes(_vm.typePost) &&
                    _vm.shareAfterPost &&
                    _vm.atLeastInstagramConciergerieSelected()
                      ? _c(
                          "div",
                          { staticClass: "poll-story" },
                          [
                            _c(
                              "vs-checkbox",
                              {
                                staticClass: "poll-story-check",
                                attrs: {
                                  checked:
                                    _vm.$store.getters.storificationQuestion,
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.$store.getters.storificationQuestion
                                      ? _vm.$store.commit(
                                          "updateStorificationQuestion",
                                          null
                                        )
                                      : _vm.$store.commit(
                                          "updateStorificationQuestion",
                                          { text: "", avatar: "", color: 0 }
                                        )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "dash.detail.history.difference.pollStory.question"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm.$store.getters.storificationQuestion
                              ? _c(
                                  "div",
                                  { staticClass: "slider-story-params" },
                                  [
                                    _c("vs-input", {
                                      staticClass: "poll-story-question",
                                      attrs: {
                                        maxlength: "45",
                                        label: _vm.$t(
                                          "dash.post.poll.question.label"
                                        ),
                                        placeholder: "Posez-moi une question",
                                        value:
                                          _vm.$store.getters
                                            .storificationQuestion.text,
                                      },
                                      on: {
                                        input: (e) =>
                                          _vm.$store.commit(
                                            "updateStorificationQuestion",
                                            { text: e }
                                          ),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.typePost !== "story" &&
                    ["image", "standard", "video"].includes(_vm.typePost) &&
                    _vm.shareAfterPost &&
                    _vm.atLeastInstagramConciergerieSelected()
                      ? _c("div", { staticClass: "mentions-story" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn-add",
                              attrs: { type: "button" },
                              on: { click: () => _vm.openMentionWidget() },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("dash.bots.mention_name_placeholder")
                                )
                              ),
                            ]
                          ),
                          _vm.$store.getters.storificationMentions &&
                          _vm.$store.getters.storificationMentions.length
                            ? _c(
                                "p",
                                [
                                  _vm._v("Mentions :\n              "),
                                  _vm._l(
                                    _vm.$store.getters.storificationMentions,
                                    function (mention, idx) {
                                      return _c(
                                        "span",
                                        {
                                          key: mention.pk,
                                          staticClass: "location-string",
                                        },
                                        [
                                          mention.hide
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidder material-icons",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$store.commit(
                                                        "updateStorificationMention",
                                                        {
                                                          index: idx,
                                                          hide: false,
                                                        }
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("visibility")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidder material-icons",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$store.commit(
                                                        "updateStorificationMention",
                                                        {
                                                          index: idx,
                                                          hide: true,
                                                        }
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("visibility_off")]
                                              ),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(mention.id) +
                                              " \n                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "remove-location",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$store.commit(
                                                    "removeStorificationMention",
                                                    idx
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("x")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "dialog",
                            {
                              ref: "searchMentionWidget",
                              staticClass: "searchTag",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "auto-mentions",
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addMentionWidget()
                                        },
                                      },
                                    },
                                    [_vm._v("OK")]
                                  ),
                                  _vm.searchMention[_vm.selectedBotMention]
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ].search,
                                            expression:
                                              "searchMention[selectedBotMention].search",
                                          },
                                        ],
                                        ref: "inputSearchMentionTag",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            `dash.posts.overlay.search_mention_placeholder_instagram_direct`
                                          ),
                                        },
                                        domProps: {
                                          value:
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ].search,
                                        },
                                        on: {
                                          keyup: function ($event) {
                                            return _vm.searchMentions("Mention")
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ],
                                              "search",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.searchMention[_vm.selectedBotMention] &&
                                  _vm.searchMention[_vm.selectedBotMention]
                                    .results &&
                                  _vm.searchMention[_vm.selectedBotMention]
                                    .results.length
                                    ? _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        _vm._l(
                                          _vm.searchMention[
                                            _vm.selectedBotMention
                                          ].results.filter(
                                            (e) =>
                                              !_vm.userTags.list
                                                .map((ee) => ee.id)
                                                .includes(e.pk)
                                          ),
                                          function (mention, index) {
                                            return _c("div", { key: index }, [
                                              _vm.mentionIsSelected(
                                                "Mention",
                                                mention
                                              )
                                                ? _c(
                                                    "li",
                                                    {
                                                      class: {
                                                        select:
                                                          _vm.mentionIsSelected(
                                                            "Mention",
                                                            mention
                                                          ) == true,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectMention(
                                                            "Mention",
                                                            mention
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class:
                                                            _vm.searchMention[
                                                              _vm
                                                                .selectedBotMention
                                                            ].bot.page.network,
                                                        },
                                                        [
                                                          mention.image
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "image",
                                                                attrs: {
                                                                  alt: mention.name,
                                                                  src: mention.image,
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "content",
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "name",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      mention.name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "screen_name id",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "@" +
                                                                      _vm._s(
                                                                        mention.id
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                              mention.subtitle
                                                                ? _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "screen_name",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          mention.subtitle
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.mentionIsSelected(
                                                                  "Mention",
                                                                  mention
                                                                ) == true,
                                                              expression:
                                                                "mentionIsSelected('Mention', mention) == true",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "checkmark",
                                                        },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "material-icons",
                                                            },
                                                            [_vm._v("check")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm.searchMention[
                                        _vm.selectedBotMention
                                      ] &&
                                      _vm.searchMention[_vm.selectedBotMention]
                                        .results
                                    ? _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        [_vm._m(6)]
                                      )
                                    : _c("ul", {
                                        staticClass: "empty",
                                        attrs: {
                                          id: "loadableContent-list-mentions",
                                        },
                                      }),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.typePost !== "story" &&
                    ["image", "standard", "video"].includes(_vm.typePost) &&
                    _vm.shareAfterPost &&
                    _vm.atLeastInstagramConciergerieSelected()
                      ? _c("div", { staticClass: "mentions-story" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn-add",
                              attrs: { type: "button" },
                              on: { click: () => _vm.openHashtagWidget() },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("dash.bots.hashtags_name_placeholder")
                                )
                              ),
                            ]
                          ),
                          _vm.$store.getters.storificationHashtags &&
                          _vm.$store.getters.storificationHashtags.length
                            ? _c(
                                "p",
                                [
                                  _vm._v("Hashtags :\n              "),
                                  _vm._l(
                                    _vm.$store.getters.storificationHashtags,
                                    function (mention, idx) {
                                      return _c(
                                        "span",
                                        {
                                          key: mention.pk,
                                          staticClass: "location-string",
                                        },
                                        [
                                          mention.hide
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidder material-icons",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$store.commit(
                                                        "updateStorificationHashtag",
                                                        {
                                                          index: idx,
                                                          hide: false,
                                                        }
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("visibility")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidder material-icons",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$store.commit(
                                                        "updateStorificationHashtag",
                                                        {
                                                          index: idx,
                                                          hide: true,
                                                        }
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("visibility_off")]
                                              ),
                                          _vm._v(
                                            "\n                #" +
                                              _vm._s(mention.hashtag) +
                                              " \n                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "remove-location",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$store.commit(
                                                    "removeStorificationHashtag",
                                                    idx
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("x")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "dialog",
                            {
                              ref: "searchHashtagWidget",
                              staticClass: "searchTag",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "auto-mentions",
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addHashtagWidget()
                                        },
                                      },
                                    },
                                    [_vm._v("OK")]
                                  ),
                                  _vm.searchHashtag[_vm.selectedBotHashtag]
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.searchHashtag[
                                                _vm.selectedBotHashtag
                                              ].search,
                                            expression:
                                              "searchHashtag[selectedBotHashtag].search",
                                          },
                                        ],
                                        ref: "inputSearchMentionTag",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            `dash.posts.overlay.search_hashtag_placeholder`
                                          ),
                                        },
                                        domProps: {
                                          value:
                                            _vm.searchHashtag[
                                              _vm.selectedBotHashtag
                                            ].search,
                                        },
                                        on: {
                                          keyup: function ($event) {
                                            return _vm.searchMentions("Hashtag")
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.searchHashtag[
                                                _vm.selectedBotHashtag
                                              ],
                                              "search",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.searchHashtag[_vm.selectedBotHashtag] &&
                                  _vm.searchHashtag[_vm.selectedBotHashtag]
                                    .results &&
                                  _vm.searchHashtag[_vm.selectedBotHashtag]
                                    .results.length
                                    ? _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        _vm._l(
                                          _vm.searchHashtag[
                                            _vm.selectedBotHashtag
                                          ].results,
                                          function (mention, index) {
                                            return _c("div", { key: index }, [
                                              _c(
                                                "li",
                                                {
                                                  class: {
                                                    select:
                                                      _vm.mentionIsSelected(
                                                        "Hashtag",
                                                        mention
                                                      ) == true,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectMention(
                                                        "Hashtag",
                                                        mention
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      class:
                                                        _vm.searchHashtag[
                                                          _vm.selectedBotHashtag
                                                        ].bot.page.network,
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "content",
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  `#${mention.hashtag}`
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "count",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  `${
                                                                    mention.count
                                                                  } ${"Post"}${
                                                                    mention.count >
                                                                    1
                                                                      ? "s"
                                                                      : ""
                                                                  }`
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.mentionIsSelected(
                                                              "Hashtag",
                                                              mention
                                                            ) == true,
                                                          expression:
                                                            "mentionIsSelected('Hashtag', mention) == true",
                                                        },
                                                      ],
                                                      staticClass: "checkmark",
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("check")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm.searchHashtag[
                                        _vm.selectedBotHashtag
                                      ] &&
                                      _vm.searchHashtag[_vm.selectedBotHashtag]
                                        .results
                                    ? _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        [_vm._m(7)]
                                      )
                                    : _c("ul", {
                                        staticClass: "empty",
                                        attrs: {
                                          id: "loadableContent-list-mentions",
                                        },
                                      }),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.typePost !== "story" &&
                    ["image", "standard", "video"].includes(_vm.typePost) &&
                    _vm.shareAfterPost &&
                    _vm.atLeastInstagramConciergerieSelected()
                      ? _c("ShopSticker", {
                          staticClass: "music-btn",
                          attrs: {
                            pageId: _vm.bots.find(
                              (e) =>
                                _vm.bot.includes(e.id) &&
                                e.page &&
                                e.page.story_config &&
                                e.page.network === "instagram"
                            )
                              ? _vm.bots.find(
                                  (e) =>
                                    _vm.bot.includes(e.id) &&
                                    e.page &&
                                    e.page.story_config &&
                                    e.page.network === "instagram"
                                ).page.id
                              : null,
                            isConciergerie:
                              _vm.atLeastInstagramConciergerieSelected(),
                            products: _vm.$store.getters.storificationProduct
                              ? _vm.$store.getters.storificationProduct.items
                              : [],
                          },
                          on: {
                            reconnect: _vm.showConciergerieForm,
                            insertShop: (shop) =>
                              _vm.$store.commit("updateStorificationProduct", {
                                items: shop,
                              }),
                          },
                        })
                      : _vm._e(),
                    _vm.typePost !== "story" &&
                    ["image", "standard", "video"].includes(_vm.typePost) &&
                    _vm.shareAfterPost &&
                    _vm.atLeastInstagramConciergerieSelected() &&
                    _vm.$store.getters.storificationProduct
                      ? _c(
                          "div",
                          { staticClass: "layers-preview" },
                          _vm._l(
                            _vm.$store.getters.storificationProduct.items,
                            function (product) {
                              return _c(
                                "div",
                                {
                                  key: product.id,
                                  staticClass: "layer-preview",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "remove-layer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeProduct(product.id)
                                        },
                                      },
                                    },
                                    [_vm._v("x")]
                                  ),
                                  _c("img", {
                                    attrs: {
                                      src: product.image,
                                      alt: product.text,
                                    },
                                  }),
                                  _c("p", [_vm._v(_vm._s(product.text))]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "input-wrapper" }, [
                      _vm.typePost === "story" && !_vm.storyShare
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.hideEmojiPicker,
                                  expression: "hideEmojiPicker",
                                },
                              ],
                            },
                            _vm._l(
                              _vm.$store.getters.storificationTexts,
                              function (txt, idx) {
                                return _c(
                                  "div",
                                  {
                                    key: idx,
                                    staticClass: "textarea-emoji-picker",
                                  },
                                  [
                                    _vm.state != "retweet"
                                      ? _c("picker", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.showEmojiPickerInstagram ===
                                                idx,
                                              expression:
                                                "showEmojiPickerInstagram === idx",
                                            },
                                          ],
                                          attrs: {
                                            data: _vm.emojiIndex,
                                            title: "Pick your emoji...",
                                            emoji: "point_up",
                                          },
                                          on: {
                                            select: (e) => _vm.addEmoji(e, idx),
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.state != "retweet" &&
                                    (txt.content.trim().length > 0 ||
                                      (_vm.instagramTexts.filter(
                                        (e) => e.content !== ""
                                      ).length === 0 &&
                                        idx === 0))
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "emoji-trigger tooltip",
                                            class: {
                                              triggered:
                                                _vm.showEmojiPickerInstagram ===
                                                idx,
                                            },
                                            on: {
                                              click: (e) =>
                                                _vm.toggleEmojiPicker(e, idx),
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticStyle: {
                                                  width: "20px",
                                                  height: "20px",
                                                },
                                                attrs: { viewBox: "0 0 24 24" },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    fill: "#888888",
                                                    d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "tooltip-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.add-emoji.title"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    txt.content.trim().length > 0 ||
                                    (_vm.instagramTexts.filter(
                                      (e) => e.content !== ""
                                    ).length === 0 &&
                                      idx === 0)
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "add-mention tooltip",
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleShowMentions(
                                                  "Mention",
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                @\n                "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "tooltip-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.add-mention.title"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    txt.content.trim().length > 0 ||
                                    (_vm.instagramTexts.filter(
                                      (e) => e.content !== ""
                                    ).length === 0 &&
                                      idx === 0 &&
                                      _vm.activeSearchHashtags)
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "add-mention add-hashtag tooltip",
                                            class: {
                                              disabled:
                                                !_vm.activeSearchHashtags,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleShowMentions(
                                                  "Hashtag",
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                #\n                "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "tooltip-text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.add-hashtag.title"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        ref: "ailoadableButton",
                                        refInFor: true,
                                        staticClass:
                                          "add-mention ai-generate tooltip",
                                        on: {
                                          click: function ($event) {
                                            return _vm.getAccrochesByAI()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [_vm._v("lightbulb_outline")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "tooltip-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.auto-generate-text.title"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    txt.content.trim().length > 0 ||
                                    (_vm.instagramTexts.filter(
                                      (e) => e.content !== ""
                                    ).length === 0 &&
                                      idx === 0)
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "add-mention tooltip hide-txt",
                                            on: {
                                              click: function ($event) {
                                                return _vm.$store.commit(
                                                  `updateStorificationText`,
                                                  {
                                                    visible: !txt.visible,
                                                    index: idx,
                                                  }
                                                )
                                              },
                                            },
                                          },
                                          [
                                            !txt.visible
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("visibility")]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("visibility_off")]
                                                ),
                                            !txt.visible
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "tooltip-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.show-text.title"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass: "tooltip-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.hide-text.title"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        )
                                      : _vm._e(),
                                    txt.content.trim().length > 0 ||
                                    (_vm.instagramTexts.filter(
                                      (e) => e.content !== ""
                                    ).length === 0 &&
                                      idx === 0)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "vs-con-textarea inputx",
                                            staticStyle: {
                                              border:
                                                "1px solid rgba(0, 0, 0, 0.08)",
                                            },
                                          },
                                          [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: txt.content,
                                                  expression: "txt.content",
                                                },
                                              ],
                                              ref: "inputTitle",
                                              refInFor: true,
                                              staticClass: "vs-textarea",
                                              attrs: {
                                                disabled:
                                                  _vm.state == "retweet",
                                                name: "title",
                                                placeholder: _vm.$t(
                                                  "dash.posts.overlay.description_placeholder"
                                                ),
                                                id: `title-post${idx}`,
                                              },
                                              domProps: { value: txt.content },
                                              on: {
                                                change: (e) =>
                                                  _vm.$store.commit(
                                                    `updateStorificationText`,
                                                    { content: e.target.value }
                                                  ),
                                                click: function ($event) {
                                                  ;[
                                                    _vm.closeAutoMentions(),
                                                    _vm.checkAddMention(idx),
                                                  ]
                                                },
                                                keyup: function ($event) {
                                                  ;[
                                                    _vm.checkAddMention(idx),
                                                    _vm.textAreaAdjust(
                                                      `title-post${idx}`
                                                    ),
                                                  ]
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    txt,
                                                    "content",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.checkActiveMentionsSearch &&
                                    ((typeof _vm.openAutoMentions ==
                                      "boolean" &&
                                      _vm.openAutoMentions) ||
                                      _vm.openAutoMentions === idx) &&
                                    _vm.searchMention.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "auto-mentions row box",
                                            on: {
                                              keydown: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "connected-pages",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "selected-page",
                                                  },
                                                  _vm._l(
                                                    _vm.searchMention,
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticClass: "page",
                                                        },
                                                        [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: item.bot
                                                                  .page.network,
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.selectedBotMention,
                                                                    expression:
                                                                      "selectedBotMention",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "radio",
                                                                  id: `bot-index-${index}`,
                                                                  name: "page",
                                                                },
                                                                domProps: {
                                                                  value: index,
                                                                  checked:
                                                                    _vm._q(
                                                                      _vm.selectedBotMention,
                                                                      index
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.changeMentionNetwork(
                                                                        "Mention",
                                                                        index
                                                                      )
                                                                    },
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectedBotMention =
                                                                        index
                                                                    },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "page-wrapper",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "page-content",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "vertical-align",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "page-img-wrapper",
                                                                            },
                                                                            [
                                                                              item
                                                                                .bot
                                                                                .page
                                                                                .network ===
                                                                              "facebook"
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          size: "25px",
                                                                                          src: require("../../../assets/img/icon_fb.png"),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : item
                                                                                    .bot
                                                                                    .page
                                                                                    .network ===
                                                                                  "twitter"
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          size: "25px",
                                                                                          src: require("../../../assets/img/icon_tw.png"),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : item
                                                                                    .bot
                                                                                    .page
                                                                                    .network ===
                                                                                  "linkedin"
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          size: "25px",
                                                                                          src: require("../../../assets/img/icon_linkedin.png"),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : item
                                                                                    .bot
                                                                                    .page
                                                                                    .network ===
                                                                                  "instagram"
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          size: "25px",
                                                                                          src: require("../../../assets/img/icon_instagram.png"),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : item
                                                                                    .bot
                                                                                    .page
                                                                                    .network ===
                                                                                  "bluesky"
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          size: "25px",
                                                                                          src: require("../../../assets/img/icon_bluesky.png"),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "page-name",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item
                                                                                    .bot
                                                                                    .page
                                                                                    .network
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm.isAddOrEditMentions(
                                                  "Mention",
                                                  idx
                                                ) == "edit" ||
                                                (_vm.previewEdited &&
                                                  _vm.previewEdited.mention &&
                                                  _vm.previewEdited.mention
                                                    .edit)
                                                  ? _c(
                                                      "Tooltip",
                                                      {
                                                        staticClass: "cancel",
                                                        staticStyle: {
                                                          position: "absolute",
                                                          top: "0",
                                                          right: "70px",
                                                          "text-align":
                                                            "center",
                                                        },
                                                        attrs: {
                                                          text: _vm.$t(
                                                            "dash.tooltip.remove_mentions"
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-button", {
                                                          staticClass: "btnx",
                                                          attrs: {
                                                            type: "flat",
                                                            icon: "delete",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeMentions(
                                                                "Mention",
                                                                idx
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(
                                                          "\n                     \n                  "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass: "page-btn",
                                                    attrs: {
                                                      "vs-type": "filled",
                                                      color: "#6a1f4c",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.validateMentions(
                                                          "Mention",
                                                          idx
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("OK")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("vs-input", {
                                              ref: "inputSearchMentionStory",
                                              refInFor: true,
                                              staticClass: "inputx",
                                              attrs: {
                                                color: "#B20564",
                                                type: "text",
                                                name: "search-mention",
                                                id: "storyMentionsInput",
                                                placeholder: _vm.$t(
                                                  `dash.posts.overlay.search_mention_placeholder_${
                                                    _vm.searchMention[
                                                      _vm.selectedBotMention
                                                    ].bot.page.network
                                                  }${
                                                    _vm.searchMention[
                                                      _vm.selectedBotMention
                                                    ].bot.page.story_config &&
                                                    _vm.searchMention[
                                                      _vm.selectedBotMention
                                                    ].bot.page.story_config
                                                      .created &&
                                                    (!_vm.searchMention[
                                                      _vm.selectedBotMention
                                                    ].bot.page.story_config
                                                      .lock ||
                                                      _vm.searchMention[
                                                        _vm.selectedBotMention
                                                      ].bot.page.story_config
                                                        .lock < Date.now())
                                                      ? "_direct"
                                                      : ""
                                                  }`
                                                ),
                                                autocomplete: "off",
                                              },
                                              on: {
                                                keyup: function ($event) {
                                                  return _vm.searchMentions(
                                                    "Mention"
                                                  )
                                                },
                                                click: function ($event) {
                                                  return _vm.searchMentions(
                                                    "Mention"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.searchMention[
                                                    _vm.selectedBotMention
                                                  ].search,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searchMention[
                                                      _vm.selectedBotMention
                                                    ],
                                                    "search",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchMention[selectedBotMention].search",
                                              },
                                            }),
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ].results &&
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ].results.length
                                              ? _c(
                                                  "ul",
                                                  {
                                                    attrs: {
                                                      id: "loadableContent-list-mentions",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.searchMention[
                                                      _vm.selectedBotMention
                                                    ].results,
                                                    function (mention, index) {
                                                      return _c(
                                                        "div",
                                                        { key: index },
                                                        [
                                                          _vm.mentionIsSelected(
                                                            "Mention",
                                                            mention
                                                          )
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  class: {
                                                                    select:
                                                                      _vm.mentionIsSelected(
                                                                        "Mention",
                                                                        mention
                                                                      ) == true,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectMention(
                                                                          "Mention",
                                                                          mention
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class:
                                                                        _vm
                                                                          .searchMention[
                                                                          _vm
                                                                            .selectedBotMention
                                                                        ].bot
                                                                          .page
                                                                          .network,
                                                                    },
                                                                    [
                                                                      mention.image
                                                                        ? _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "image",
                                                                              attrs:
                                                                                {
                                                                                  alt: mention.name,
                                                                                  src: mention.image,
                                                                                },
                                                                            }
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "image",
                                                                            }
                                                                          ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "content",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "name",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  mention.name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm
                                                                            .searchMention[
                                                                            _vm
                                                                              .selectedBotMention
                                                                          ].bot
                                                                            .page
                                                                            .network ==
                                                                          "twitter"
                                                                            ? _c(
                                                                                "img",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      alt: "verified account",
                                                                                      src: require("../../../assets/img/validated-twitter.png"),
                                                                                    },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm
                                                                            .searchMention[
                                                                            _vm
                                                                              .selectedBotMention
                                                                          ].bot
                                                                            .page
                                                                            .network ==
                                                                          "facebook"
                                                                            ? _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "screen_name id",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      mention.id
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm
                                                                                .searchMention[
                                                                                _vm
                                                                                  .selectedBotMention
                                                                              ]
                                                                                .bot
                                                                                .page
                                                                                .network ==
                                                                              "bluesky"
                                                                            ? _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "screen_name",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "@" +
                                                                                      _vm._s(
                                                                                        mention.subtitle
                                                                                      )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "screen_name",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "@" +
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .searchMention[
                                                                                          _vm
                                                                                            .selectedBotMention
                                                                                        ]
                                                                                          .bot
                                                                                          .page
                                                                                          .network ==
                                                                                          "twitter"
                                                                                          ? mention.screen_name
                                                                                          : _vm
                                                                                              .searchMention[
                                                                                              _vm
                                                                                                .selectedBotMention
                                                                                            ]
                                                                                              .bot
                                                                                              .page
                                                                                              .network ==
                                                                                              "instagram" &&
                                                                                            mention.id
                                                                                          ? mention.id
                                                                                          : mention.name
                                                                                      )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                          _vm
                                                                            .searchMention[
                                                                            _vm
                                                                              .selectedBotMention
                                                                          ].bot
                                                                            .page
                                                                            .network ==
                                                                          "twitter"
                                                                            ? _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "description",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      mention.description
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          mention.subtitle &&
                                                                          _vm
                                                                            .searchMention[
                                                                            _vm
                                                                              .selectedBotMention
                                                                          ].bot
                                                                            .page
                                                                            .network !=
                                                                            "bluesky"
                                                                            ? _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "screen_name",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      mention.subtitle
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              _vm.mentionIsSelected(
                                                                                "Mention",
                                                                                mention
                                                                              ) ==
                                                                              true,
                                                                            expression:
                                                                              "mentionIsSelected('Mention', mention) == true",
                                                                          },
                                                                        ],
                                                                      staticClass:
                                                                        "checkmark",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "material-icons",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "check"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm.searchMention[
                                                  _vm.selectedBotMention
                                                ].results
                                              ? _c(
                                                  "ul",
                                                  {
                                                    attrs: {
                                                      id: "loadableContent-list-mentions",
                                                    },
                                                  },
                                                  [_vm._m(8, true)]
                                                )
                                              : _c("ul", {
                                                  staticClass: "empty",
                                                  attrs: {
                                                    id: "loadableContent-list-mentions",
                                                  },
                                                }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.checkActiveHashtagsSearch &&
                                    ((typeof _vm.openAutoHashtags ==
                                      "boolean" &&
                                      _vm.openAutoHashtags) ||
                                      _vm.openAutoHashtags === idx) &&
                                    _vm.searchHashtag.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "auto-mentions auto-hashtags row box",
                                            on: {
                                              keydown: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "connected-pages",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "selected-page",
                                                  },
                                                  _vm._l(
                                                    _vm.searchHashtag,
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticClass: "page",
                                                        },
                                                        [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: item.bot
                                                                  .page.network,
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.selectedBotHashtag,
                                                                    expression:
                                                                      "selectedBotHashtag",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "radio",
                                                                  id: `bot-index-${index}`,
                                                                  name: "page",
                                                                },
                                                                domProps: {
                                                                  value: index,
                                                                  checked:
                                                                    _vm._q(
                                                                      _vm.selectedBotHashtag,
                                                                      index
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.changeMentionNetwork(
                                                                        "Hashtag",
                                                                        index
                                                                      )
                                                                    },
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectedBotHashtag =
                                                                        index
                                                                    },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "page-wrapper",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "page-content",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "vertical-align",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "page-img-wrapper",
                                                                            },
                                                                            [
                                                                              item
                                                                                .bot
                                                                                .page
                                                                                .network ===
                                                                              "facebook"
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          size: "25px",
                                                                                          src: require("../../../assets/img/icon_fb.png"),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : item
                                                                                    .bot
                                                                                    .page
                                                                                    .network ===
                                                                                  "twitter"
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          size: "25px",
                                                                                          src: require("../../../assets/img/icon_tw.png"),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : item
                                                                                    .bot
                                                                                    .page
                                                                                    .network ===
                                                                                  "linkedin"
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          size: "25px",
                                                                                          src: require("../../../assets/img/icon_linkedin.png"),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : item
                                                                                    .bot
                                                                                    .page
                                                                                    .network ===
                                                                                  "instagram"
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          size: "25px",
                                                                                          src: require("../../../assets/img/icon_instagram.png"),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "page-name",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item
                                                                                    .bot
                                                                                    .page
                                                                                    .network
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass: "page-btn",
                                                    attrs: {
                                                      "vs-type": "filled",
                                                      color: "#6a1f4c",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.validateMentions(
                                                          "Hashtag",
                                                          idx
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("OK")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("vs-input", {
                                              ref: "inputSearchMentionStory",
                                              refInFor: true,
                                              staticClass: "inputx",
                                              attrs: {
                                                color: "#B20564",
                                                type: "text",
                                                name: "search-mention",
                                                placeholder: _vm.$t(
                                                  `dash.posts.overlay.search_hashtag_placeholder`
                                                ),
                                                autocomplete: "off",
                                              },
                                              on: {
                                                keyup: function ($event) {
                                                  return _vm.searchMentions(
                                                    "Hashtag"
                                                  )
                                                },
                                                click: function ($event) {
                                                  return _vm.searchMentions(
                                                    "Hashtag"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.searchHashtag[
                                                    _vm.selectedBotHashtag
                                                  ].search,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searchHashtag[
                                                      _vm.selectedBotHashtag
                                                    ],
                                                    "search",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchHashtag[selectedBotHashtag].search",
                                              },
                                            }),
                                            _c(
                                              "ul",
                                              {
                                                attrs: {
                                                  id: "loadableContent-list-mentions",
                                                },
                                              },
                                              _vm._l(
                                                _vm.searchHashtag[
                                                  _vm.selectedBotHashtag
                                                ].results,
                                                function (mention, index) {
                                                  return _c(
                                                    "div",
                                                    { key: index },
                                                    [
                                                      mention.hashtag
                                                        ? _c(
                                                            "li",
                                                            {
                                                              class: {
                                                                select:
                                                                  _vm.mentionIsSelected(
                                                                    "Hashtag",
                                                                    mention
                                                                  ) == true,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.selectMention(
                                                                      "Hashtag",
                                                                      mention
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    _vm
                                                                      .searchHashtag[
                                                                      _vm
                                                                        .selectedBotHashtag
                                                                    ].bot.page
                                                                      .network,
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "content",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "name",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              `#${mention.hashtag}`
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "count",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              `${
                                                                                mention.count
                                                                              } ${
                                                                                _vm
                                                                                  .searchHashtag[
                                                                                  _vm
                                                                                    .selectedBotHashtag
                                                                                ]
                                                                                  .bot
                                                                                  .page
                                                                                  .network ===
                                                                                "twitter"
                                                                                  ? "Tweet"
                                                                                  : "Post"
                                                                              }${
                                                                                mention.count >
                                                                                1
                                                                                  ? "s"
                                                                                  : ""
                                                                              }`
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        _vm.mentionIsSelected(
                                                                          "Hashtag",
                                                                          mention
                                                                        ) ==
                                                                        true,
                                                                      expression:
                                                                        "mentionIsSelected('Hashtag', mention) == true",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "checkmark",
                                                                },
                                                                [
                                                                  _c(
                                                                    "i",
                                                                    {
                                                                      staticClass:
                                                                        "material-icons",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "check"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm.isAddOrEditMentions(
                                              "Hashtag",
                                              idx
                                            ) == "edit"
                                              ? _c(
                                                  "vs-button",
                                                  {
                                                    staticClass: "cancel",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeMentions(
                                                          "Hashtag",
                                                          idx
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.button.cancel"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm.typePost !== "story"
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.hideEmojiPicker,
                                  expression: "hideEmojiPicker",
                                },
                              ],
                              staticClass: "textarea-emoji-picker",
                            },
                            [
                              !_vm.atLeastNetworkSelected("bluesky")
                                ? _c(
                                    "div",
                                    { staticClass: "styles-text-buttons" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "emoji-trigger tooltip",
                                          class: {
                                            triggered: _vm
                                              .styledText()
                                              .includes("bold"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.styleSelection("bold")
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 20 20",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "#888888",
                                                  d: "M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "tooltip-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dash.bold.title")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "emoji-trigger tooltip",
                                          class: {
                                            triggered: _vm
                                              .styledText()
                                              .includes("italic"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.styleSelection(
                                                "italic"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                viewBox: "0 0 20 20",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "#888888",
                                                  d: "M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z ",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "tooltip-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dash.italic.title")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.state != "retweet" &&
                              !_vm.atLeastNetworkSelected("bluesky")
                                ? _c("picker", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showEmojiPicker,
                                        expression: "showEmojiPicker",
                                      },
                                    ],
                                    attrs: {
                                      data: _vm.emojiIndex,
                                      title: "Pick your emoji...",
                                      emoji: "point_up",
                                    },
                                    on: { select: _vm.addEmoji },
                                  })
                                : _vm._e(),
                              _vm.state != "retweet" &&
                              !_vm.atLeastNetworkSelected("bluesky")
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "emoji-trigger tooltip",
                                      class: { triggered: _vm.showEmojiPicker },
                                      on: { click: _vm.toggleEmojiPicker },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticStyle: {
                                            width: "20px",
                                            height: "20px",
                                          },
                                          attrs: { viewBox: "0 0 24 24" },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              fill: "#888888",
                                              d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "tooltip-text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.add-emoji.title")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass: "add-mention tooltip",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleShowMentions("Mention")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                @\n                "
                                  ),
                                  _c("span", { staticClass: "tooltip-text" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("dash.add-mention.title"))
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.checkActiveLocationSearch
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "add-mention add-location tooltip",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleShowMentions(
                                            "Location"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            "enable-background":
                                              "new 0 0 32 32",
                                            height: "20px",
                                            id: "Layer_1",
                                            version: "1.1",
                                            viewBox: "0 0 32 32",
                                            width: "20px",
                                            "xml:space": "preserve",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "xmlns:xlink":
                                              "http://www.w3.org/1999/xlink",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            { attrs: { id: "location" } },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  "clip-rule": "evenodd",
                                                  d: "M16.002,17.746c3.309,0,6-2.692,6-6s-2.691-6-6-6   c-3.309,0-6,2.691-6,6S12.693,17.746,16.002,17.746z M16.002,6.746c2.758,0,5,2.242,5,5s-2.242,5-5,5c-2.758,0-5-2.242-5-5   S13.244,6.746,16.002,6.746z",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  "clip-rule": "evenodd",
                                                  d: "M16,0C9.382,0,4,5.316,4,12.001c0,7,6.001,14.161,10.376,19.194   C14.392,31.215,15.094,32,15.962,32c0.002,0,0.073,0,0.077,0c0.867,0,1.57-0.785,1.586-0.805   c4.377-5.033,10.377-12.193,10.377-19.194C28.002,5.316,22.619,0,16,0z M16.117,29.883c-0.021,0.02-0.082,0.064-0.135,0.098   c-0.01-0.027-0.084-0.086-0.129-0.133C12.188,25.631,6,18.514,6,12.001C6,6.487,10.487,2,16,2c5.516,0,10.002,4.487,10.002,10.002   C26.002,18.514,19.814,25.631,16.117,29.883z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "tooltip-text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.add-location.title")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.activeSearchHashtags
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "add-mention add-hashtag tooltip",
                                      class: {
                                        disabled: !_vm.activeSearchHashtags,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleShowMentions(
                                            "Hashtag"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                #\n                "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "tooltip-text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.add-hashtag.title")
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  ref: "ailoadableButton",
                                  staticClass:
                                    "add-mention ai-generate tooltip",
                                  on: {
                                    click: function ($event) {
                                      return _vm.getAccrochesByAI()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("lightbulb_outline")]
                                  ),
                                  _c("span", { staticClass: "tooltip-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.auto-generate-text.title")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.typePost !== "story"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "vs-con-textarea inputx",
                                      staticStyle: {
                                        border: "1px solid rgba(0, 0, 0, 0.08)",
                                      },
                                    },
                                    [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.title,
                                            expression: "form.title",
                                          },
                                        ],
                                        ref: "inputTitle",
                                        staticClass: "vs-textarea",
                                        attrs: {
                                          disabled: _vm.state == "retweet",
                                          name: "title",
                                          placeholder: _vm.inputTitleText,
                                          id: "title-post",
                                          "data-qa": "form-post-message",
                                        },
                                        domProps: { value: _vm.form.title },
                                        on: {
                                          click: function ($event) {
                                            ;[
                                              _vm.closeAutoMentions(),
                                              _vm.checkAddMention(),
                                            ]
                                          },
                                          keyup: function ($event) {
                                            ;[
                                              _vm.checkAddMention(),
                                              _vm.textAreaAdjust("title-post"),
                                            ]
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.form,
                                              "title",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.limitText
                                ? _c(
                                    "div",
                                    { staticClass: "vs-textarea--count" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.sizeCurrentMessageByRsLimit
                                          ) +
                                          " / " +
                                          _vm._s(_vm.limitText) +
                                          " (" +
                                          _vm._s(_vm.rsLimit) +
                                          ")\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.checkActiveMentionsSearch &&
                              typeof _vm.openAutoMentions == "boolean" &&
                              _vm.openAutoMentions &&
                              _vm.searchMention.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "auto-mentions row box",
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "pos-relative" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "connected-pages" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "selected-page",
                                                },
                                                _vm._l(
                                                  _vm.searchMention,
                                                  function (item, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass: "page",
                                                      },
                                                      [
                                                        _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: item.bot
                                                                .page.network,
                                                              position: "top",
                                                            },
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.selectedBotMention,
                                                                  expression:
                                                                    "selectedBotMention",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "radio",
                                                                id: `bot-index-${index}`,
                                                                name: "page",
                                                              },
                                                              domProps: {
                                                                value: index,
                                                                checked: _vm._q(
                                                                  _vm.selectedBotMention,
                                                                  index
                                                                ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.changeMentionNetwork(
                                                                      "Mention",
                                                                      index
                                                                    )
                                                                  },
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.selectedBotMention =
                                                                      index
                                                                  },
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "page-wrapper",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "page-content",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "vertical-align",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "page-img-wrapper",
                                                                          },
                                                                          [
                                                                            item
                                                                              .bot
                                                                              .page
                                                                              .network ===
                                                                            "facebook"
                                                                              ? _c(
                                                                                  "img",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        size: "25px",
                                                                                        src: require("../../../assets/img/icon_fb.png"),
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : item
                                                                                  .bot
                                                                                  .page
                                                                                  .network ===
                                                                                "twitter"
                                                                              ? _c(
                                                                                  "img",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        size: "25px",
                                                                                        src: require("../../../assets/img/icon_tw.png"),
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : item
                                                                                  .bot
                                                                                  .page
                                                                                  .network ===
                                                                                "linkedin"
                                                                              ? _c(
                                                                                  "img",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        size: "25px",
                                                                                        src: require("../../../assets/img/icon_linkedin.png"),
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : item
                                                                                  .bot
                                                                                  .page
                                                                                  .network ===
                                                                                "instagram"
                                                                              ? _c(
                                                                                  "img",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        size: "25px",
                                                                                        src: require("../../../assets/img/icon_instagram.png"),
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : item
                                                                                  .bot
                                                                                  .page
                                                                                  .network ===
                                                                                "bluesky"
                                                                              ? _c(
                                                                                  "img",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        size: "25px",
                                                                                        src: require("../../../assets/img/icon_bluesky.png"),
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "page-name",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item
                                                                                  .bot
                                                                                  .page
                                                                                  .network
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                              _vm.isAddOrEditMentions(
                                                "Mention"
                                              ) == "edit" ||
                                              (_vm.previewEdited &&
                                                _vm.previewEdited.mention &&
                                                _vm.previewEdited.mention.edit)
                                                ? _c(
                                                    "Tooltip",
                                                    {
                                                      staticClass: "cancel",
                                                      staticStyle: {
                                                        position: "absolute",
                                                        top: "0",
                                                        right: "70px",
                                                        "text-align": "center",
                                                      },
                                                      attrs: {
                                                        text: _vm.$t(
                                                          "dash.tooltip.remove_mentions"
                                                        ),
                                                        position: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("vs-button", {
                                                        staticClass: "btnx",
                                                        attrs: {
                                                          type: "flat",
                                                          icon: "delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeMentions(
                                                              "Mention"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                     \n                  "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "vs-button",
                                                {
                                                  staticClass: "page-btn",
                                                  attrs: {
                                                    "vs-type": "filled",
                                                    color: "#6a1f4c",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.validateMentions(
                                                        "Mention"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("OK")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c("vs-input", {
                                        ref: "inputSearchMention",
                                        staticClass: "inputx",
                                        attrs: {
                                          color: "#B20564",
                                          type: "text",
                                          name: "search-mention",
                                          placeholder: _vm.$t(
                                            `dash.posts.overlay.search_mention_placeholder_${
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ].bot.page.network
                                            }${
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ].bot.page.story_config &&
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ].bot.page.story_config.created &&
                                              (!_vm.searchMention[
                                                _vm.selectedBotMention
                                              ].bot.page.story_config.lock ||
                                                _vm.searchMention[
                                                  _vm.selectedBotMention
                                                ].bot.page.story_config.lock <
                                                  Date.now())
                                                ? "_direct"
                                                : ""
                                            }`
                                          ),
                                          autocomplete: "off",
                                        },
                                        on: {
                                          keyup: function ($event) {
                                            return _vm.searchMentions("Mention")
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ].search,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ],
                                              "search",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchMention[selectedBotMention].search",
                                        },
                                      }),
                                      _vm.searchMention[_vm.selectedBotMention]
                                        .results &&
                                      _vm.searchMention[_vm.selectedBotMention]
                                        .results.length
                                        ? _c(
                                            "ul",
                                            {
                                              attrs: {
                                                id: "loadableContent-list-mentions laaa",
                                              },
                                            },
                                            _vm._l(
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ].results,
                                              function (mention, index) {
                                                return _c(
                                                  "div",
                                                  { key: index },
                                                  [
                                                    _vm.mentionIsSelected(
                                                      "Mention",
                                                      mention
                                                    )
                                                      ? _c(
                                                          "li",
                                                          {
                                                            class: {
                                                              select:
                                                                _vm.mentionIsSelected(
                                                                  "Mention",
                                                                  mention
                                                                ) == true,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectMention(
                                                                  "Mention",
                                                                  mention
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                class:
                                                                  _vm
                                                                    .searchMention[
                                                                    _vm
                                                                      .selectedBotMention
                                                                  ].bot.page
                                                                    .network,
                                                              },
                                                              [
                                                                mention.image
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "image",
                                                                      attrs: {
                                                                        alt: mention.name,
                                                                        src: mention.image,
                                                                      },
                                                                    })
                                                                  : _c("span", {
                                                                      staticClass:
                                                                        "image",
                                                                    }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "content",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            mention.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm
                                                                      .searchMention[
                                                                      _vm
                                                                        .selectedBotMention
                                                                    ].bot.page
                                                                      .network ==
                                                                    "twitter"
                                                                      ? _c(
                                                                          "img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                alt: "verified account",
                                                                                src: require("../../../assets/img/validated-twitter.png"),
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm
                                                                      .searchMention[
                                                                      _vm
                                                                        .selectedBotMention
                                                                    ].bot.page
                                                                      .network ==
                                                                    "facebook"
                                                                      ? _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "screen_name id",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                mention.id
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm
                                                                          .searchMention[
                                                                          _vm
                                                                            .selectedBotMention
                                                                        ].bot
                                                                          .page
                                                                          .network ==
                                                                        "bluesky"
                                                                      ? _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "screen_name",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "@" +
                                                                                _vm._s(
                                                                                  mention.subtitle
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "screen_name",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "@" +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .searchMention[
                                                                                    _vm
                                                                                      .selectedBotMention
                                                                                  ]
                                                                                    .bot
                                                                                    .page
                                                                                    .network ==
                                                                                    "twitter"
                                                                                    ? mention.screen_name
                                                                                    : _vm
                                                                                        .searchMention[
                                                                                        _vm
                                                                                          .selectedBotMention
                                                                                      ]
                                                                                        .bot
                                                                                        .page
                                                                                        .network ==
                                                                                        "instagram" &&
                                                                                      mention.id
                                                                                    ? mention.id
                                                                                    : mention.name
                                                                                )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                    _vm
                                                                      .searchMention[
                                                                      _vm
                                                                        .selectedBotMention
                                                                    ].bot.page
                                                                      .network ==
                                                                    "twitter"
                                                                      ? _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "description",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                mention.description
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    mention.subtitle &&
                                                                    _vm
                                                                      .searchMention[
                                                                      _vm
                                                                        .selectedBotMention
                                                                    ].bot.page
                                                                      .network !=
                                                                      "bluesky"
                                                                      ? _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "screen_name",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                mention.subtitle
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm.mentionIsSelected(
                                                                        "Mention",
                                                                        mention
                                                                      ) == true,
                                                                    expression:
                                                                      "mentionIsSelected('Mention', mention) == true",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "checkmark",
                                                              },
                                                              [
                                                                _c(
                                                                  "i",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "check"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm.searchMention[
                                            _vm.selectedBotMention
                                          ].results
                                        ? _c(
                                            "ul",
                                            {
                                              staticClass: "empty",
                                              attrs: {
                                                id: "loadableContent-list-mentions",
                                              },
                                            },
                                            [_vm._m(9)]
                                          )
                                        : _c("ul", {
                                            attrs: {
                                              id: "loadableContent-list-mentions",
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.checkActiveHashtagsSearch &&
                              _vm.openAutoHashtags &&
                              _vm.searchHashtag.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "auto-mentions auto-hashtags row box",
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "connected-pages" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "selected-page" },
                                            _vm._l(
                                              _vm.searchHashtag,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "page",
                                                  },
                                                  [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: item.bot.page
                                                            .network,
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.selectedBotHashtag,
                                                              expression:
                                                                "selectedBotHashtag",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            id: `bot-index-${index}`,
                                                            name: "page",
                                                          },
                                                          domProps: {
                                                            value: index,
                                                            checked: _vm._q(
                                                              _vm.selectedBotHashtag,
                                                              index
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.changeMentionNetwork(
                                                                "Hashtag",
                                                                index
                                                              )
                                                            },
                                                            change: function (
                                                              $event
                                                            ) {
                                                              _vm.selectedBotHashtag =
                                                                index
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "page-wrapper",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "page-content",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "vertical-align",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "page-img-wrapper",
                                                                      },
                                                                      [
                                                                        item.bot
                                                                          .page
                                                                          .network ===
                                                                        "facebook"
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "25px",
                                                                                    src: require("../../../assets/img/icon_fb.png"),
                                                                                  },
                                                                              }
                                                                            )
                                                                          : item
                                                                              .bot
                                                                              .page
                                                                              .network ===
                                                                            "twitter"
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "25px",
                                                                                    src: require("../../../assets/img/icon_tw.png"),
                                                                                  },
                                                                              }
                                                                            )
                                                                          : item
                                                                              .bot
                                                                              .page
                                                                              .network ===
                                                                            "linkedin"
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "25px",
                                                                                    src: require("../../../assets/img/icon_linkedin.png"),
                                                                                  },
                                                                              }
                                                                            )
                                                                          : item
                                                                              .bot
                                                                              .page
                                                                              .network ===
                                                                            "instagram"
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "25px",
                                                                                    src: require("../../../assets/img/icon_instagram.png"),
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "page-name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item
                                                                              .bot
                                                                              .page
                                                                              .network
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm.isAddOrEditMentions("Hashtag") ==
                                            "edit" ||
                                          (_vm.previewEdited &&
                                            _vm.previewEdited.hashtag &&
                                            _vm.previewEdited.hashtag.edit)
                                            ? _c(
                                                "Tooltip",
                                                {
                                                  staticClass: "cancel",
                                                  staticStyle: {
                                                    position: "absolute",
                                                    top: "0",
                                                    right: "70px",
                                                    "text-align": "center",
                                                  },
                                                  attrs: {
                                                    text: _vm.$t(
                                                      "dash.tooltip.remove_mentions"
                                                    ),
                                                    position: "top",
                                                  },
                                                },
                                                [
                                                  _c("vs-button", {
                                                    staticClass: "btnx",
                                                    attrs: {
                                                      type: "flat",
                                                      icon: "delete",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeMentions(
                                                          "Hashtag"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                   \n                "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "vs-button",
                                            {
                                              staticClass: "page-btn",
                                              attrs: {
                                                "vs-type": "filled",
                                                color: "#6a1f4c",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.validateMentions(
                                                    "Hashtag"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("OK")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("vs-input", {
                                        ref: "inputSearchMention",
                                        staticClass: "inputx",
                                        attrs: {
                                          color: "#B20564",
                                          type: "text",
                                          name: "search-mention",
                                          placeholder: _vm.$t(
                                            `dash.posts.overlay.search_hashtag_placeholder`
                                          ),
                                          autocomplete: "off",
                                        },
                                        on: {
                                          keyup: function ($event) {
                                            return _vm.searchMentions("Hashtag")
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.searchHashtag[
                                              _vm.selectedBotHashtag
                                            ].search,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.searchHashtag[
                                                _vm.selectedBotHashtag
                                              ],
                                              "search",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchHashtag[selectedBotHashtag].search",
                                        },
                                      }),
                                      _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        _vm._l(
                                          _vm.searchHashtag[
                                            _vm.selectedBotHashtag
                                          ].results,
                                          function (mention, index) {
                                            return _c("div", { key: index }, [
                                              mention.hashtag
                                                ? _c(
                                                    "li",
                                                    {
                                                      class: {
                                                        select:
                                                          _vm.mentionIsSelected(
                                                            "Hashtag",
                                                            mention
                                                          ) == true,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectMention(
                                                            "Hashtag",
                                                            mention
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class:
                                                            _vm.searchHashtag[
                                                              _vm
                                                                .selectedBotHashtag
                                                            ].bot.page.network,
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "content",
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "name",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      `#${mention.hashtag}`
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "count",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      `${
                                                                        mention.count
                                                                      } ${
                                                                        _vm
                                                                          .searchHashtag[
                                                                          _vm
                                                                            .selectedBotHashtag
                                                                        ].bot
                                                                          .page
                                                                          .network ===
                                                                        "twitter"
                                                                          ? "Tweet"
                                                                          : "Post"
                                                                      }${
                                                                        mention.count >
                                                                        1
                                                                          ? "s"
                                                                          : ""
                                                                      }`
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.mentionIsSelected(
                                                                  "Hashtag",
                                                                  mention
                                                                ) == true,
                                                              expression:
                                                                "mentionIsSelected('Hashtag', mention) == true",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "checkmark",
                                                        },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "material-icons",
                                                            },
                                                            [_vm._v("check")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.checkActiveLocationSearch &&
                              _vm.openAutoLocations &&
                              _vm.searchLocation.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "auto-mentions row box",
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "connected-pages" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "selected-page" },
                                            _vm._l(
                                              _vm.searchLocation,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "page",
                                                  },
                                                  [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: item.bot.page
                                                            .network,
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.selectedBotLocation,
                                                              expression:
                                                                "selectedBotLocation",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            id: `bot-index-${index}`,
                                                            name: "page",
                                                          },
                                                          domProps: {
                                                            value: index,
                                                            checked: _vm._q(
                                                              _vm.selectedBotLocation,
                                                              index
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.changeMentionNetwork(
                                                                "Location",
                                                                index
                                                              )
                                                            },
                                                            change: function (
                                                              $event
                                                            ) {
                                                              _vm.selectedBotLocation =
                                                                index
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "page-wrapper",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "page-content",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "vertical-align",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "page-img-wrapper",
                                                                      },
                                                                      [
                                                                        item.bot
                                                                          .page
                                                                          .network ===
                                                                        "facebook"
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "25px",
                                                                                    src: require("../../../assets/img/icon_fb.png"),
                                                                                  },
                                                                              }
                                                                            )
                                                                          : item
                                                                              .bot
                                                                              .page
                                                                              .network ===
                                                                            "twitter"
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "25px",
                                                                                    src: require("../../../assets/img/icon_tw.png"),
                                                                                  },
                                                                              }
                                                                            )
                                                                          : item
                                                                              .bot
                                                                              .page
                                                                              .network ===
                                                                            "linkedin"
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "25px",
                                                                                    src: require("../../../assets/img/icon_linkedin.png"),
                                                                                  },
                                                                              }
                                                                            )
                                                                          : item
                                                                              .bot
                                                                              .page
                                                                              .network ===
                                                                            "instagram"
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "25px",
                                                                                    src: require("../../../assets/img/icon_instagram.png"),
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "page-name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item
                                                                              .bot
                                                                              .page
                                                                              .network
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _c(
                                            "vs-button",
                                            {
                                              staticClass: "page-btn",
                                              attrs: {
                                                "vs-type": "filled",
                                                color: "#6a1f4c",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.selectLocation(
                                                    _vm.searchLocation[
                                                      _vm.selectedBotLocation
                                                    ].selected
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("OK")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("vs-input", {
                                        ref: "inputSearchMentionStory",
                                        staticClass: "inputx",
                                        attrs: {
                                          color: "#B20564",
                                          type: "text",
                                          name: "search-mention",
                                          placeholder: _vm.$t(
                                            `dash.posts.overlay.search_location_placeholder`
                                          ),
                                          autocomplete: "off",
                                        },
                                        on: {
                                          keyup: function ($event) {
                                            return _vm.searchMentions(
                                              "Location"
                                            )
                                          },
                                          click: function ($event) {
                                            return _vm.searchMentions(
                                              "Location"
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.searchLocation[
                                              _vm.selectedBotLocation
                                            ].search,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.searchLocation[
                                                _vm.selectedBotLocation
                                              ],
                                              "search",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchLocation[selectedBotLocation].search",
                                        },
                                      }),
                                      _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        _vm._l(
                                          _vm.searchLocation[
                                            _vm.selectedBotLocation
                                          ].results,
                                          function (mention, index) {
                                            return _c("div", { key: index }, [
                                              _c(
                                                "li",
                                                {
                                                  class: {
                                                    select:
                                                      _vm.mentionIsSelected(
                                                        "Location",
                                                        mention
                                                      ) == true,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectMention(
                                                        "Location",
                                                        mention
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      class:
                                                        _vm.searchLocation[
                                                          _vm
                                                            .selectedBotLocation
                                                        ].bot.page.network,
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "content",
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "locations",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  mention.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          mention.location
                                                            ? _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "locations infos",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      mention
                                                                        .location
                                                                        .street
                                                                    ) +
                                                                      _vm._s(
                                                                        mention
                                                                          .location
                                                                          .street &&
                                                                          ","
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        mention
                                                                          .location
                                                                          .zip
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        mention
                                                                          .location
                                                                          .city
                                                                      ) +
                                                                      _vm._s(
                                                                        mention
                                                                          .location
                                                                          .city &&
                                                                          ","
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        mention
                                                                          .location
                                                                          .country
                                                                      )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.mentionIsSelected(
                                                              "Location",
                                                              mention
                                                            ) == true,
                                                          expression:
                                                            "mentionIsSelected('Location', mention) == true",
                                                        },
                                                      ],
                                                      staticClass: "checkmark",
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("check")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm.isAddOrEditMentions("Location") ==
                                      "edit"
                                        ? _c(
                                            "vs-button",
                                            {
                                              staticClass: "cancel",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeMentions(
                                                    "Location"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("dash.button.cancel")
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "vs-prompt",
                                {
                                  staticClass: "auto-generate-text",
                                  attrs: {
                                    title: _vm.$t(
                                      "dash.auto-generate-text.title"
                                    ),
                                    color: "info",
                                    "accept-text": _vm.$t("dash.confirm"),
                                    "cancel-text": _vm.$t("dash.cancel"),
                                    active: _vm.openAccrochesAI,
                                  },
                                  on: {
                                    cancel: () => {
                                      _vm.openAccrochesAI = false
                                      _vm.accrochesAI = null
                                    },
                                    accept: function ($event) {
                                      return _vm.changeTextByGenerated()
                                    },
                                    close: () => {
                                      _vm.openAccrochesAI = false
                                      _vm.accrochesAI = null
                                    },
                                    "update:active": function ($event) {
                                      _vm.openAccrochesAI = $event
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "con-exemple-prompt" },
                                    [
                                      _c("vs-textarea", {
                                        staticClass: "inputx",
                                        attrs: {
                                          "vs-size": "large",
                                          color: "#B20564",
                                          name: "title",
                                          placeholder: _vm.inputTitleText,
                                        },
                                        model: {
                                          value: _vm.editPromptAccroches,
                                          callback: function ($$v) {
                                            _vm.editPromptAccroches = $$v
                                          },
                                          expression: "editPromptAccroches",
                                        },
                                      }),
                                      _c(
                                        "vs-button",
                                        {
                                          staticClass: "generate",
                                          on: {
                                            click: function ($event) {
                                              return _vm.getAccrochesByAI(true)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("dash.generate")) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "ul",
                                        _vm._l(
                                          _vm.accrochesAI,
                                          function (opt, idx) {
                                            return _c("li", { key: idx }, [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.selectedAccroches,
                                                    expression:
                                                      "selectedAccroches",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id: `accroche-${idx}`,
                                                  name: "accroches[]",
                                                },
                                                domProps: {
                                                  value: opt,
                                                  checked: Array.isArray(
                                                    _vm.selectedAccroches
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectedAccroches,
                                                        opt
                                                      ) > -1
                                                    : _vm.selectedAccroches,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.selectedAccroches,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = opt,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.selectedAccroches =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.selectedAccroches =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.selectedAccroches =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(
                                                "  \n                    " +
                                                  _vm._s(opt) +
                                                  "\n                  "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm.showPromptLoader
                                        ? _c("component-loader", {
                                            attrs: {
                                              progress: 90,
                                              unlimitedProgress: true,
                                              activeClose: true,
                                            },
                                            on: {
                                              close: function ($event) {
                                                _vm.showPromptLoader = false
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.getBoardPagePinterest ||
                      _vm.atLeastWonderpushSelected() ||
                      _vm.atLeastNetworkSelected("youtube")
                        ? _c(
                            "div",
                            { staticStyle: { "margin-top": "20px" } },
                            [
                              _vm.typePost !== "story"
                                ? _c("vs-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "",
                                        expression: "''",
                                      },
                                    ],
                                    staticClass: "inputx",
                                    class: {
                                      input: true,
                                      "is-danger":
                                        _vm.errors.has("posts.title"),
                                    },
                                    attrs: {
                                      disabled: _vm.state == "retweet",
                                      "vs-size": "large",
                                      color: "#B20564",
                                      name: "title",
                                      placeholder: _vm.inputDescriptionText,
                                      id: "description-post",
                                      "data-qa": "form-post-message",
                                    },
                                    on: {
                                      click: function ($event) {
                                        ;[
                                          _vm.closeAutoMentions(),
                                          _vm.checkAddMention(),
                                        ]
                                      },
                                      keyup: function ($event) {
                                        ;[
                                          _vm.checkAddMention(),
                                          _vm.textAreaAdjust(
                                            "description-post"
                                          ),
                                        ]
                                      },
                                    },
                                    model: {
                                      value: _vm.form.description,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "description", $$v)
                                      },
                                      expression: "form.description",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isThreadable()
                        ? _c(
                            "div",
                            {
                              staticClass: "comments",
                              class: [
                                {
                                  "disable-section": _vm.state == "edit-posted",
                                },
                              ],
                            },
                            [
                              _vm._l(
                                _vm.form.comments,
                                function (comment, commentIdx) {
                                  return _c(
                                    "div",
                                    {
                                      key: commentIdx,
                                      staticClass: "textarea-emoji-picker",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "remove-comment",
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeComment(
                                                commentIdx
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.post.remove-comment"
                                                ),
                                                position: "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("close")]
                                              ),
                                              _vm._v(" \n                "),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      !_vm.atLeastNetworkSelected("bluesky")
                                        ? _c("picker", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.showEmojiPickerComment ===
                                                  commentIdx,
                                                expression:
                                                  "showEmojiPickerComment === commentIdx",
                                              },
                                            ],
                                            attrs: {
                                              data: _vm.emojiIndex,
                                              title: "Pick your emoji...",
                                              emoji: "point_up",
                                            },
                                            on: {
                                              select: (e) =>
                                                _vm.addEmoji(
                                                  e,
                                                  null,
                                                  commentIdx
                                                ),
                                            },
                                          })
                                        : _vm._e(),
                                      !_vm.atLeastNetworkSelected("bluesky")
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "emoji-trigger tooltip",
                                              class: {
                                                triggered:
                                                  _vm.showEmojiPickerComment ===
                                                  commentIdx,
                                              },
                                              on: {
                                                click: (e) =>
                                                  _vm.toggleEmojiPicker(
                                                    e,
                                                    null,
                                                    commentIdx
                                                  ),
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticStyle: {
                                                    width: "20px",
                                                    height: "20px",
                                                  },
                                                  attrs: {
                                                    viewBox: "0 0 24 24",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "#888888",
                                                      d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "tooltip-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.add-emoji.title"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "add-mention tooltip",
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleShowMentions(
                                                "Mention",
                                                null,
                                                commentIdx
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                @\n                "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "tooltip-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.add-mention.title"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.activeSearchHashtags
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "add-mention add-hashtag tooltip",
                                              class: {
                                                disabled:
                                                  !_vm.activeSearchHashtags,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleShowMentions(
                                                    "Hashtag",
                                                    null,
                                                    commentIdx
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                #\n                "
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "tooltip-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.add-hashtag.title"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "vs-con-textarea inputx",
                                          staticStyle: {
                                            border:
                                              "1px solid rgba(0, 0, 0, 0.08)",
                                          },
                                        },
                                        [
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.form.comments[commentIdx],
                                                expression:
                                                  "form.comments[commentIdx]",
                                              },
                                            ],
                                            staticClass: "vs-textarea",
                                            attrs: {
                                              name: "title",
                                              placeholder: _vm.$t(
                                                "dash.posts.overlay.new_comment_placeholder"
                                              ),
                                              id: `comment-post-${commentIdx}`,
                                            },
                                            domProps: {
                                              value:
                                                _vm.form.comments[commentIdx],
                                            },
                                            on: {
                                              click: function ($event) {
                                                ;[
                                                  _vm.closeAutoMentions(),
                                                  _vm.checkAddMention(
                                                    null,
                                                    commentIdx
                                                  ),
                                                ]
                                              },
                                              keyup: function ($event) {
                                                ;[
                                                  _vm.checkAddMention(
                                                    null,
                                                    commentIdx
                                                  ),
                                                  _vm.textAreaAdjust(
                                                    `comment-post-${commentIdx}`
                                                  ),
                                                ]
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.form.comments,
                                                  commentIdx,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm.checkActiveMentionsSearch &&
                                      _vm.openAutoMentions === commentIdx &&
                                      _vm.searchMention.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "auto-mentions row box",
                                              on: {
                                                keydown: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  )
                                                    return null
                                                  $event.preventDefault()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "connected-pages",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "selected-page",
                                                    },
                                                    _vm._l(
                                                      _vm.searchMention,
                                                      function (item, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass: "page",
                                                          },
                                                          [
                                                            _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: item.bot
                                                                    .page
                                                                    .network,
                                                                  position:
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.selectedBotMention,
                                                                      expression:
                                                                        "selectedBotMention",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "radio",
                                                                    id: `bot-index-${index}`,
                                                                    name: "page",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      index,
                                                                    checked:
                                                                      _vm._q(
                                                                        _vm.selectedBotMention,
                                                                        index
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.changeMentionNetwork(
                                                                          "Mention",
                                                                          index
                                                                        )
                                                                      },
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.selectedBotMention =
                                                                          index
                                                                      },
                                                                  },
                                                                }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "page-wrapper",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "page-content",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "vertical-align",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "page-img-wrapper",
                                                                              },
                                                                              [
                                                                                item
                                                                                  .bot
                                                                                  .page
                                                                                  .network ===
                                                                                "facebook"
                                                                                  ? _c(
                                                                                      "img",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            size: "25px",
                                                                                            src: require("../../../assets/img/icon_fb.png"),
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : item
                                                                                      .bot
                                                                                      .page
                                                                                      .network ===
                                                                                    "twitter"
                                                                                  ? _c(
                                                                                      "img",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            size: "25px",
                                                                                            src: require("../../../assets/img/icon_tw.png"),
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : item
                                                                                      .bot
                                                                                      .page
                                                                                      .network ===
                                                                                    "linkedin"
                                                                                  ? _c(
                                                                                      "img",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            size: "25px",
                                                                                            src: require("../../../assets/img/icon_linkedin.png"),
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : item
                                                                                      .bot
                                                                                      .page
                                                                                      .network ===
                                                                                    "instagram"
                                                                                  ? _c(
                                                                                      "img",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            size: "25px",
                                                                                            src: require("../../../assets/img/icon_instagram.png"),
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "page-name",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item
                                                                                      .bot
                                                                                      .page
                                                                                      .network
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _vm.isAddOrEditMentions(
                                                    "Mention",
                                                    null,
                                                    commentIdx
                                                  ) == "edit" ||
                                                  (_vm.previewEdited &&
                                                    _vm.previewEdited.mention &&
                                                    _vm.previewEdited.mention
                                                      .edit)
                                                    ? _c(
                                                        "Tooltip",
                                                        {
                                                          staticClass: "cancel",
                                                          staticStyle: {
                                                            position:
                                                              "absolute",
                                                            top: "0",
                                                            right: "70px",
                                                            "text-align":
                                                              "center",
                                                          },
                                                          attrs: {
                                                            text: _vm.$t(
                                                              "dash.tooltip.remove_mentions"
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("vs-button", {
                                                            staticClass: "btnx",
                                                            attrs: {
                                                              type: "flat",
                                                              icon: "delete",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeMentions(
                                                                  "Mention",
                                                                  null,
                                                                  commentIdx
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                     \n                  "
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "vs-button",
                                                    {
                                                      staticClass: "page-btn",
                                                      attrs: {
                                                        "vs-type": "filled",
                                                        color: "#6a1f4c",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.validateMentions(
                                                            "Mention",
                                                            null,
                                                            commentIdx
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("OK")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("vs-input", {
                                                ref: "inputSearchMentionStory",
                                                refInFor: true,
                                                staticClass: "inputx",
                                                attrs: {
                                                  color: "#B20564",
                                                  type: "text",
                                                  name: "search-mention",
                                                  id: "storyMentionsInput",
                                                  placeholder: _vm.$t(
                                                    `dash.posts.overlay.search_mention_placeholder_${
                                                      _vm.searchMention[
                                                        _vm.selectedBotMention
                                                      ].bot.page.network
                                                    }${
                                                      _vm.searchMention[
                                                        _vm.selectedBotMention
                                                      ].bot.page.story_config &&
                                                      _vm.searchMention[
                                                        _vm.selectedBotMention
                                                      ].bot.page.story_config
                                                        .created &&
                                                      (!_vm.searchMention[
                                                        _vm.selectedBotMention
                                                      ].bot.page.story_config
                                                        .lock ||
                                                        _vm.searchMention[
                                                          _vm.selectedBotMention
                                                        ].bot.page.story_config
                                                          .lock < Date.now())
                                                        ? "_direct"
                                                        : ""
                                                    }`
                                                  ),
                                                  autocomplete: "off",
                                                },
                                                on: {
                                                  keyup: function ($event) {
                                                    return _vm.searchMentions(
                                                      "Mention"
                                                    )
                                                  },
                                                  click: function ($event) {
                                                    return _vm.searchMentions(
                                                      "Mention"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.searchMention[
                                                      _vm.selectedBotMention
                                                    ].search,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.searchMention[
                                                        _vm.selectedBotMention
                                                      ],
                                                      "search",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchMention[selectedBotMention].search",
                                                },
                                              }),
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ].results &&
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ].results.length
                                                ? _c(
                                                    "ul",
                                                    {
                                                      attrs: {
                                                        id: "loadableContent-list-mentions",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.searchMention[
                                                        _vm.selectedBotMention
                                                      ].results,
                                                      function (
                                                        mention,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          { key: index },
                                                          [
                                                            _vm.mentionIsSelected(
                                                              "Mention",
                                                              mention
                                                            )
                                                              ? _c(
                                                                  "li",
                                                                  {
                                                                    class: {
                                                                      select:
                                                                        _vm.mentionIsSelected(
                                                                          "Mention",
                                                                          mention
                                                                        ) ==
                                                                        true,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.selectMention(
                                                                            "Mention",
                                                                            mention
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        class:
                                                                          _vm
                                                                            .searchMention[
                                                                            _vm
                                                                              .selectedBotMention
                                                                          ].bot
                                                                            .page
                                                                            .network,
                                                                      },
                                                                      [
                                                                        mention.image
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "image",
                                                                                attrs:
                                                                                  {
                                                                                    alt: mention.name,
                                                                                    src: mention.image,
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "image",
                                                                              }
                                                                            ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "content",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "name",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    mention.name
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm
                                                                              .searchMention[
                                                                              _vm
                                                                                .selectedBotMention
                                                                            ]
                                                                              .bot
                                                                              .page
                                                                              .network ==
                                                                            "twitter"
                                                                              ? _c(
                                                                                  "img",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        alt: "verified account",
                                                                                        src: require("../../../assets/img/validated-twitter.png"),
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm
                                                                              .searchMention[
                                                                              _vm
                                                                                .selectedBotMention
                                                                            ]
                                                                              .bot
                                                                              .page
                                                                              .network ==
                                                                            "facebook"
                                                                              ? _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "screen_name id",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        mention.id
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm
                                                                                  .searchMention[
                                                                                  _vm
                                                                                    .selectedBotMention
                                                                                ]
                                                                                  .bot
                                                                                  .page
                                                                                  .network ==
                                                                                "bluesky"
                                                                              ? _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "screen_name",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "@" +
                                                                                        _vm._s(
                                                                                          mention.subtitle
                                                                                        )
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "screen_name",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "@" +
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .searchMention[
                                                                                            _vm
                                                                                              .selectedBotMention
                                                                                          ]
                                                                                            .bot
                                                                                            .page
                                                                                            .network ==
                                                                                            "twitter"
                                                                                            ? mention.screen_name
                                                                                            : _vm
                                                                                                .searchMention[
                                                                                                _vm
                                                                                                  .selectedBotMention
                                                                                              ]
                                                                                                .bot
                                                                                                .page
                                                                                                .network ==
                                                                                                "instagram" &&
                                                                                              mention.id
                                                                                            ? mention.id
                                                                                            : mention.name
                                                                                        )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                            _vm
                                                                              .searchMention[
                                                                              _vm
                                                                                .selectedBotMention
                                                                            ]
                                                                              .bot
                                                                              .page
                                                                              .network ==
                                                                            "twitter"
                                                                              ? _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "description",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        mention.description
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            mention.subtitle &&
                                                                            _vm
                                                                              .searchMention[
                                                                              _vm
                                                                                .selectedBotMention
                                                                            ]
                                                                              .bot
                                                                              .page
                                                                              .network !=
                                                                              "bluesky"
                                                                              ? _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "screen_name",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        mention.subtitle
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                _vm.mentionIsSelected(
                                                                                  "Mention",
                                                                                  mention
                                                                                ) ==
                                                                                true,
                                                                              expression:
                                                                                "mentionIsSelected('Mention', mention) == true",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "checkmark",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "material-icons",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "check"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm.searchMention[
                                                    _vm.selectedBotMention
                                                  ].results
                                                ? _c(
                                                    "ul",
                                                    {
                                                      attrs: {
                                                        id: "loadableContent-list-mentions",
                                                      },
                                                    },
                                                    [_vm._m(10, true)]
                                                  )
                                                : _c("ul", {
                                                    staticClass: "empty",
                                                    attrs: {
                                                      id: "loadableContent-list-mentions",
                                                    },
                                                  }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkActiveHashtagsSearch &&
                                      ((typeof _vm.openAutoHashtags ==
                                        "boolean" &&
                                        _vm.openAutoHashtags) ||
                                        _vm.openAutoHashtags === commentIdx) &&
                                      _vm.searchHashtag.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "auto-mentions auto-hashtags row box",
                                              on: {
                                                keydown: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  )
                                                    return null
                                                  $event.preventDefault()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "connected-pages",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "selected-page",
                                                    },
                                                    _vm._l(
                                                      _vm.searchHashtag,
                                                      function (item, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass: "page",
                                                          },
                                                          [
                                                            _c(
                                                              "Tooltip",
                                                              {
                                                                attrs: {
                                                                  text: item.bot
                                                                    .page
                                                                    .network,
                                                                  position:
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.selectedBotHashtag,
                                                                      expression:
                                                                        "selectedBotHashtag",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "radio",
                                                                    id: `bot-index-${index}`,
                                                                    name: "page",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      index,
                                                                    checked:
                                                                      _vm._q(
                                                                        _vm.selectedBotHashtag,
                                                                        index
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.changeMentionNetwork(
                                                                          "Hashtag",
                                                                          index
                                                                        )
                                                                      },
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.selectedBotHashtag =
                                                                          index
                                                                      },
                                                                  },
                                                                }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "page-wrapper",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "page-content",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "vertical-align",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "page-img-wrapper",
                                                                              },
                                                                              [
                                                                                item
                                                                                  .bot
                                                                                  .page
                                                                                  .network ===
                                                                                "facebook"
                                                                                  ? _c(
                                                                                      "img",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            size: "25px",
                                                                                            src: require("../../../assets/img/icon_fb.png"),
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : item
                                                                                      .bot
                                                                                      .page
                                                                                      .network ===
                                                                                    "twitter"
                                                                                  ? _c(
                                                                                      "img",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            size: "25px",
                                                                                            src: require("../../../assets/img/icon_tw.png"),
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : item
                                                                                      .bot
                                                                                      .page
                                                                                      .network ===
                                                                                    "linkedin"
                                                                                  ? _c(
                                                                                      "img",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            size: "25px",
                                                                                            src: require("../../../assets/img/icon_linkedin.png"),
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : item
                                                                                      .bot
                                                                                      .page
                                                                                      .network ===
                                                                                    "instagram"
                                                                                  ? _c(
                                                                                      "img",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            size: "25px",
                                                                                            src: require("../../../assets/img/icon_instagram.png"),
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "page-name",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item
                                                                                      .bot
                                                                                      .page
                                                                                      .network
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _c(
                                                    "vs-button",
                                                    {
                                                      staticClass: "page-btn",
                                                      attrs: {
                                                        "vs-type": "filled",
                                                        color: "#6a1f4c",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.validateMentions(
                                                            "Hashtag",
                                                            null,
                                                            commentIdx
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("OK")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("vs-input", {
                                                ref: "inputSearchMentionStory",
                                                refInFor: true,
                                                staticClass: "inputx",
                                                attrs: {
                                                  color: "#B20564",
                                                  type: "text",
                                                  name: "search-mention",
                                                  placeholder: _vm.$t(
                                                    `dash.posts.overlay.search_hashtag_placeholder`
                                                  ),
                                                  autocomplete: "off",
                                                },
                                                on: {
                                                  keyup: function ($event) {
                                                    return _vm.searchMentions(
                                                      "Hashtag"
                                                    )
                                                  },
                                                  click: function ($event) {
                                                    return _vm.searchMentions(
                                                      "Hashtag"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.searchHashtag[
                                                      _vm.selectedBotHashtag
                                                    ].search,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.searchHashtag[
                                                        _vm.selectedBotHashtag
                                                      ],
                                                      "search",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchHashtag[selectedBotHashtag].search",
                                                },
                                              }),
                                              _c(
                                                "ul",
                                                {
                                                  attrs: {
                                                    id: "loadableContent-list-mentions",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.searchHashtag[
                                                    _vm.selectedBotHashtag
                                                  ].results,
                                                  function (mention, index) {
                                                    return _c(
                                                      "div",
                                                      { key: index },
                                                      [
                                                        mention.hashtag
                                                          ? _c(
                                                              "li",
                                                              {
                                                                class: {
                                                                  select:
                                                                    _vm.mentionIsSelected(
                                                                      "Hashtag",
                                                                      mention
                                                                    ) == true,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.selectMention(
                                                                        "Hashtag",
                                                                        mention
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    class:
                                                                      _vm
                                                                        .searchHashtag[
                                                                        _vm
                                                                          .selectedBotHashtag
                                                                      ].bot.page
                                                                        .network,
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "content",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "name",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                `#${mention.hashtag}`
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "count",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                `${
                                                                                  mention.count
                                                                                } ${
                                                                                  _vm
                                                                                    .searchHashtag[
                                                                                    _vm
                                                                                      .selectedBotHashtag
                                                                                  ]
                                                                                    .bot
                                                                                    .page
                                                                                    .network ===
                                                                                  "twitter"
                                                                                    ? "Tweet"
                                                                                    : "Post"
                                                                                }${
                                                                                  mention.count >
                                                                                  1
                                                                                    ? "s"
                                                                                    : ""
                                                                                }`
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            _vm.mentionIsSelected(
                                                                              "Hashtag",
                                                                              mention
                                                                            ) ==
                                                                            true,
                                                                          expression:
                                                                            "mentionIsSelected('Hashtag', mention) == true",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "checkmark",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "i",
                                                                      {
                                                                        staticClass:
                                                                          "material-icons",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "check"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                              _vm.isAddOrEditMentions(
                                                "Hashtag",
                                                null,
                                                commentIdx
                                              ) == "edit"
                                                ? _c(
                                                    "vs-button",
                                                    {
                                                      staticClass: "cancel",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.removeMentions(
                                                            "Hashtag",
                                                            null,
                                                            commentIdx
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "dash.button.cancel"
                                                            )
                                                          ) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "add-comment",
                                  on: { click: _vm.addComment },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("dash.posts.form.add-comment")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                    _vm.typePost == "image" &&
                    _vm.state !== "edit-posted" &&
                    ((_vm.onlyListNetworkSelected(["instagram"]) &&
                      _vm.checkPlanOptions(["conciergerie"])) ||
                      _vm.onlyListNetworkSelected(["threads"]))
                      ? _c("div", { staticClass: "input-wrapper" }, [
                          _c("ul", { staticClass: "mix-carrousel" }, [
                            _c("li", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isCarrouselMix,
                                    expression: "isCarrouselMix",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: `carrousel-mix`,
                                  name: "carrouselMix[]",
                                },
                                domProps: {
                                  value: true,
                                  checked: Array.isArray(_vm.isCarrouselMix)
                                    ? _vm._i(_vm.isCarrouselMix, true) > -1
                                    : _vm.isCarrouselMix,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.isCarrouselMix,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = true,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isCarrouselMix = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isCarrouselMix = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isCarrouselMix = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "  \n              " +
                                  _vm._s(_vm.$t("dash.posts.form.video.mix")) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.typePost == "video"
                      ? _c(
                          "div",
                          { staticClass: "input-wrapper" },
                          [
                            _vm.messageUpload &&
                            _vm.onUpload &&
                            !_vm.isThumbUpload
                              ? _c("p", [
                                  _vm.percentUpload < 101
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(Math.ceil(_vm.percentUpload)) +
                                            "%"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" " + _vm._s(_vm.messageUpload)),
                                ])
                              : _vm._e(),
                            _vm.onUpload &&
                            _vm.percentUpload < 98 &&
                            !_vm.isThumbUpload
                              ? _c(
                                  "vs-progress",
                                  {
                                    attrs: {
                                      percent: _vm.percentUpload,
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("primary")]
                                )
                              : _vm._e(),
                            _vm.onUpload &&
                            _vm.percentUpload >= 98 &&
                            !_vm.isThumbUpload
                              ? _c(
                                  "vs-progress",
                                  {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("primary")]
                                )
                              : _vm._e(),
                            (_vm.onlyListNetworkSelected(["instagram"]) &&
                              _vm.state !== "edit-posted" &&
                              _vm.checkPlanOptions(["conciergerie"])) ||
                            _vm.onlyListNetworkSelected(["threads"])
                              ? _c("ul", { staticClass: "mix-carrousel" }, [
                                  _c("li", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isCarrouselMix,
                                          expression: "isCarrouselMix",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        id: `carrousel-mix`,
                                        name: "carrouselMix[]",
                                      },
                                      domProps: {
                                        value: true,
                                        checked: Array.isArray(
                                          _vm.isCarrouselMix
                                        )
                                          ? _vm._i(_vm.isCarrouselMix, true) >
                                            -1
                                          : _vm.isCarrouselMix,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.isCarrouselMix,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = true,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.isCarrouselMix =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.isCarrouselMix = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.isCarrouselMix = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "  \n              " +
                                        _vm._s(
                                          _vm.$t("dash.posts.form.video.mix")
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.state !== "edit-posted"
                              ? _c(
                                  "div",
                                  { staticClass: "custom-file-input" },
                                  [
                                    _c("div", { staticClass: "file-input" }, [
                                      _c("div", { staticClass: "file-btn" }, [
                                        _c("div", { staticClass: "vertical" }, [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../assets/img/video-icon.svg"),
                                              alt: "media",
                                            },
                                          }),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  `dash.posts.form.video${
                                                    _vm.onlyListNetworkSelected(
                                                      ["instagram", "threads"]
                                                    )
                                                      ? _vm.isCarrouselMix
                                                        ? "s_images"
                                                        : "s"
                                                      : ""
                                                  }`
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "",
                                                expression: "''",
                                              },
                                            ],
                                            ref: "myVideo",
                                            class: {
                                              input: true,
                                              "is-danger":
                                                _vm.errors.has("posts.file"),
                                            },
                                            attrs: {
                                              name: "file",
                                              type: "file",
                                              id: "file",
                                              multiple:
                                                _vm.onlyListNetworkSelected([
                                                  "instagram",
                                                  "threads",
                                                ]),
                                              disabled: _vm.onUpload,
                                              accept: `video/*${
                                                _vm.onlyListNetworkSelected([
                                                  "instagram",
                                                  "threads",
                                                ]) && _vm.isCarrouselMix
                                                  ? ", image/*"
                                                  : ""
                                              }`,
                                            },
                                            on: {
                                              change: _vm.selectVideo,
                                              click: _vm.initInputFile,
                                            },
                                          }),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "file-name" }, [
                                        _c("div", { staticClass: "vertical" }, [
                                          _vm.videoname &&
                                          _vm.multipleMedias.length <= 1
                                            ? _c("p", [
                                                _vm._v(_vm._s(this.videoname)),
                                              ])
                                            : _vm._e(),
                                          _vm.videoname &&
                                          _vm.multipleMedias.length <= 1 &&
                                          !_vm.onUpload &&
                                          _vm.videoname !==
                                            this.$t("dash.message.no.video")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "delete-video-thumb",
                                                  on: {
                                                    click: _vm.removeVideo,
                                                  },
                                                },
                                                [_vm._v("𝗫")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "help-limit-video" },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  attrs: {
                                                    text: _vm.$t(
                                                      "dash.posts.form.media.video.limit.header"
                                                    ),
                                                    position: "top",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "telegram-help",
                                                    attrs: {
                                                      src: require("../../../assets/img/icon_help.svg"),
                                                      alt: "?",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.openHelpLimitVideo = true
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                       \n                    "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "vs-popup",
                                                {
                                                  staticClass:
                                                    "posts-overlay-limit-video",
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "dash.posts.form.media.video.limit.header"
                                                    ),
                                                    active:
                                                      _vm.openHelpLimitVideo,
                                                  },
                                                  on: {
                                                    "update:active": function (
                                                      $event
                                                    ) {
                                                      _vm.openHelpLimitVideo =
                                                        $event
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("table", [
                                                    _c("th"),
                                                    _c("th", [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "dash.posts.form.media.video.limit.during"
                                                            )
                                                          ) +
                                                          "\n                          "
                                                      ),
                                                    ]),
                                                    _c("th", [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "dash.posts.form.media.video.limit.size"
                                                            )
                                                          ) +
                                                          "\n                          "
                                                      ),
                                                    ]),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Facebook"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("20 min"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("1 Go"),
                                                      ]),
                                                    ]),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Facebook reel"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("90 sec"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("1 Go"),
                                                      ]),
                                                    ]),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Twitter"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("140 sec"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("512 Mo"),
                                                      ]),
                                                    ]),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Linkedin"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("30 min"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("200 Mo"),
                                                      ]),
                                                    ]),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v(
                                                          "Linkedin conciergerie"
                                                        ),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("30 min"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("5 Go"),
                                                      ]),
                                                    ]),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v(
                                                          "Instagram video"
                                                        ),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("60 sec"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("1 Go"),
                                                      ]),
                                                    ]),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v(
                                                          "Instagram reel"
                                                        ),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("15 min"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v("1 Go"),
                                                      ]),
                                                    ]),
                                                    _vm.atLeastTiktokSelected() &&
                                                    _vm.tiktokRequirements
                                                      ? _c("tr", [
                                                          _c("td", [
                                                            _vm._v("Tiktok"),
                                                          ]),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .tiktokRequirements
                                                                  .max_video_post_duration_sec
                                                              ) + " sec"
                                                            ),
                                                          ]),
                                                          _c("td", [
                                                            _vm._v("X"),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.typePost === "standard"
                      ? _c(
                          "div",
                          [
                            _vm.typePost === "standard" &&
                            _vm.messageUpload &&
                            _vm.onUpload
                              ? _c("p", [
                                  _vm.percentUpload < 101
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              Math.ceil(_vm.percentUpload)
                                            ) +
                                            "%"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.messageUpload) +
                                      "\n          "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.typePost === "standard" &&
                            _vm.onUpload &&
                            _vm.percentUpload < 98
                              ? _c(
                                  "vs-progress",
                                  {
                                    attrs: {
                                      percent: _vm.percentUpload,
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("primary")]
                                )
                              : _vm._e(),
                            _vm.typePost === "standard" &&
                            _vm.onUpload &&
                            _vm.percentUpload >= 98
                              ? _c(
                                  "vs-progress",
                                  {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("primary")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.storyShare &&
                    (_vm.typePost == "image" ||
                      (_vm.typePost == "video" && _vm.thumbPossible()) ||
                      _vm.typePost === "story" ||
                      _vm.typePost === "document")
                      ? _c(
                          "div",
                          { staticClass: "input-wrapper" },
                          [
                            _vm.messageUpload &&
                            _vm.onUpload &&
                            (_vm.typePost !== "video" || _vm.isThumbUpload)
                              ? _c("p", [
                                  _vm.multipleImages &&
                                  _vm.multipleImages.length > 1
                                    ? _c("span", [
                                        _vm._v(
                                          "Image " +
                                            _vm._s(
                                              `${
                                                _vm.compressedImages.length + 1
                                              }/${_vm.multipleImages.length}`
                                            ) +
                                            " : "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.percentUpload < 101
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              Math.ceil(_vm.percentUpload)
                                            ) +
                                            "%"
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.messageUpload) +
                                      "\n          "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.onUpload &&
                            _vm.percentUpload < 98 &&
                            (_vm.typePost !== "video" || _vm.isThumbUpload)
                              ? _c(
                                  "vs-progress",
                                  {
                                    attrs: {
                                      percent: _vm.percentUpload,
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("primary")]
                                )
                              : _vm._e(),
                            _vm.onUpload &&
                            _vm.percentUpload >= 98 &&
                            (_vm.typePost !== "video" || _vm.isThumbUpload)
                              ? _c(
                                  "vs-progress",
                                  {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                    },
                                  },
                                  [_vm._v("primary")]
                                )
                              : _vm._e(),
                            _vm.multipleMedias.length <= 1 &&
                            _vm.state !== "edit-posted"
                              ? _c(
                                  "div",
                                  { staticClass: "custom-file-input" },
                                  [
                                    _c("div", { staticClass: "file-input" }, [
                                      _c("div", { staticClass: "file-btn" }, [
                                        _c("div", { staticClass: "vertical" }, [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../assets/img/icon_media.png"),
                                              alt: "media",
                                            },
                                          }),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.typePost == "video"
                                                    ? "dash.posts.form.thumb"
                                                    : _vm.typePost ===
                                                      "document"
                                                    ? "dash.posts.form.document"
                                                    : _vm.typePost === "story"
                                                    ? "dash.posts.form.media.multiple"
                                                    : "dash.posts.form.media"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm.typePost === "story"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "",
                                                    expression: "''",
                                                  },
                                                ],
                                                ref: "storyFile",
                                                class: {
                                                  input: true,
                                                  "is-danger":
                                                    _vm.errors.has(
                                                      "posts.file"
                                                    ),
                                                },
                                                attrs: {
                                                  name: "file",
                                                  type: "file",
                                                  id: "file",
                                                  multiple: false,
                                                  disabled: _vm.onUpload,
                                                  accept: `image/*, video/*`,
                                                },
                                                on: {
                                                  change: () =>
                                                    _vm.selectStoryFile(),
                                                  click: _vm.initInputFile,
                                                },
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "",
                                                    expression: "''",
                                                  },
                                                ],
                                                ref: "myFiles",
                                                class: {
                                                  input: true,
                                                  "is-danger":
                                                    _vm.errors.has(
                                                      "posts.file"
                                                    ),
                                                },
                                                attrs: {
                                                  name: "file",
                                                  type: "file",
                                                  id: "file",
                                                  multiple:
                                                    _vm.carouselPossible()
                                                      ? true
                                                      : false,
                                                  accept:
                                                    _vm.typePost === "document"
                                                      ? "application/pdf"
                                                      : `image/*`,
                                                },
                                                on: {
                                                  change: () =>
                                                    _vm.select(
                                                      _vm.typePost == "video" &&
                                                        _vm.thumbPossible()
                                                    ),
                                                  click: _vm.initInputFile,
                                                },
                                              }),
                                        ]),
                                      ]),
                                      _vm.multipleImages.length <= 1 ||
                                      _vm.form.enclosure
                                        ? _c(
                                            "div",
                                            { staticClass: "file-name" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "verti" },
                                                [
                                                  _vm.videoname &&
                                                  _vm.storyVideo &&
                                                  !_vm.videoReel
                                                    ? _c("p", [
                                                        _vm._v(
                                                          _vm._s(_vm.videoname)
                                                        ),
                                                      ])
                                                    : _vm.filename &&
                                                      !_vm.form.enclosure
                                                    ? _c("p", [
                                                        _vm._v(
                                                          _vm._s(_vm.filename)
                                                        ),
                                                      ])
                                                    : _vm.filename &&
                                                      _vm.filename.includes(
                                                        ".gif"
                                                      )
                                                    ? _c("p", [
                                                        _vm._v(
                                                          _vm._s(_vm.filename)
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.videoname &&
                                                  _vm.storyVideo &&
                                                  !_vm.videoReel &&
                                                  !_vm.onUpload &&
                                                  _vm.videoname !==
                                                    this.$t(
                                                      "dash.message.no.video"
                                                    )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "delete-video-thumb",
                                                          on: {
                                                            click:
                                                              _vm.removeVideo,
                                                          },
                                                        },
                                                        [_vm._v("𝗫")]
                                                      )
                                                    : _vm._e(),
                                                  _vm.url &&
                                                  !_vm.storyVideo &&
                                                  !(
                                                    _vm.typePost == "image" &&
                                                    _vm.carouselPossible() &&
                                                    _vm.multipleImages.length >
                                                      1
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "del-img-wrapper",
                                                        },
                                                        [
                                                          !_vm.storyShare &&
                                                          _vm.url &&
                                                          _vm.typePost !==
                                                            "document"
                                                            ? _c("img", {
                                                                class: `${
                                                                  _vm.typePost ===
                                                                    "story" &&
                                                                  "story-thumb"
                                                                } carousel-thumb`,
                                                                attrs: {
                                                                  src: _vm.url,
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          _vm.url
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "delete-img-thumb",
                                                                  on: {
                                                                    click:
                                                                      _vm.removeImage,
                                                                  },
                                                                },
                                                                [_vm._v("𝗫")]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.typePost == "image"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "help-limit-video",
                                                        },
                                                        [
                                                          _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "dash.posts.form.media.image.limit.header"
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "telegram-help",
                                                                attrs: {
                                                                  src: require("../../../assets/img/icon_help.svg"),
                                                                  alt: "?",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.openHelpLimitImage = true
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(
                                                                "\n                       \n                    "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "vs-popup",
                                                            {
                                                              staticClass:
                                                                "posts-overlay-limit-video",
                                                              attrs: {
                                                                title: _vm.$t(
                                                                  "dash.posts.form.media.image.limit.header"
                                                                ),
                                                                active:
                                                                  _vm.openHelpLimitImage,
                                                              },
                                                              on: {
                                                                "update:active":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.openHelpLimitImage =
                                                                      $event
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("table", [
                                                                _c("th"),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "dash.posts.form.media.image.limit.number"
                                                                        )
                                                                      ) +
                                                                      "\n                          "
                                                                  ),
                                                                ]),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "dash.posts.form.media.video.limit.size"
                                                                        )
                                                                      ) +
                                                                      " max\n                          "
                                                                  ),
                                                                ]),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n                            Dimension max\n                          "
                                                                  ),
                                                                ]),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n                            Dimension min\n                          "
                                                                  ),
                                                                ]),
                                                                _c("th", [
                                                                  _vm._v(
                                                                    "\n                            GIF\n                          "
                                                                  ),
                                                                ]),
                                                                _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Facebook"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "80 images"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "< 4 Mo"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v("-"),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v("-"),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "N/A"
                                                                    ),
                                                                  ]),
                                                                ]),
                                                                _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Twitter"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "4 images"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "< 5 Mo"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "8192x8192"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "4x4"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "350 frames max"
                                                                    ),
                                                                  ]),
                                                                ]),
                                                                _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Linkedin"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "20 images"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v("-"),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "36152320 pixels "
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v("-"),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "250 frames max"
                                                                    ),
                                                                  ]),
                                                                ]),
                                                                _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Instagram"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "20 images"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "< 8 Mo"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "1.91:1"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "4:5"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "N/A"
                                                                    ),
                                                                  ]),
                                                                ]),
                                                                _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Google Business Profile"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "1 image"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "< 5 Mo"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v("-"),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "250x250"
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "N/A"
                                                                    ),
                                                                  ]),
                                                                ]),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("posts.file"),
                                  expression: "errors.has('posts.file')",
                                },
                              ],
                              staticClass: "fa fa-warning",
                            }),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("posts.file"),
                                    expression: "errors.has('posts.file')",
                                  },
                                ],
                                staticClass: "help is-danger",
                              },
                              [_vm._v(_vm._s(_vm.errors.first("posts.file")))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.atLeastNetworkSelected("twitter")
                      ? _c("div", { staticClass: "input-wrapper" }, [
                          _c("div", [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "options-wrapper type-video" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "options-wrapper-tilte" },
                                    [
                                      _c("vs-avatar", {
                                        attrs: {
                                          color: "transparent",
                                          size: "18px",
                                          src: require("../../../assets/img/icon_tw.png"),
                                        },
                                      }),
                                      _vm._v(
                                        "\n                  Twitter\n                "
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("ul", [
                                    _c("li", { staticClass: "clearBoth" }, [
                                      _c(
                                        "span",
                                        { staticClass: "select-title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                `dash.post.twitter_options.reply_settings.title`
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.twitterOptions
                                                  .reply_settings,
                                              expression:
                                                "twitterOptions.reply_settings",
                                            },
                                          ],
                                          staticClass: "reply_settings-input",
                                          attrs: {
                                            disabled:
                                              _vm.state === "edit-posted",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.twitterOptions,
                                                "reply_settings",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    `dash.post.twitter_options.reply_settings.none`
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "following" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    `dash.post.twitter_options.reply_settings.following`
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "mentionedUsers",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    `dash.post.twitter_options.reply_settings.mentionedUsers`
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "subscribers" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    `dash.post.twitter_options.reply_settings.subscribers`
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "verified" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    `dash.post.twitter_options.reply_settings.verified`
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.typePost == "video"
                      ? _c("div", { staticClass: "input-wrapper" }, [
                          _c("div", [
                            _c("div", [
                              _vm.atLeastNetworkSelected("youtube")
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "options-wrapper type-video",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "options-wrapper-tilte",
                                        },
                                        [
                                          _c("vs-avatar", {
                                            attrs: {
                                              color: "transparent",
                                              size: "18px",
                                              src: require("../../../assets/img/logo-youtube.svg"),
                                            },
                                          }),
                                          _vm._v(
                                            "\n                  Youtube\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("ul", [
                                        _c("li", [
                                          _c(
                                            "div",
                                            { staticClass: "checkboxes" },
                                            [
                                              _c("ul", [
                                                _c(
                                                  "li",
                                                  {
                                                    class: [
                                                      {
                                                        active:
                                                          _vm.youtubeOptions
                                                            .notifySubscribers,
                                                      },
                                                      "w50",
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.youtubeOptions.notifySubscribers =
                                                          !_vm.youtubeOptions
                                                            .notifySubscribers
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            "dash.posts.youtube_options.notify_subscribers"
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.posts.youtube_options.notify_subscribers.enabled"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          "\n                             \n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "li",
                                                  {
                                                    class: [
                                                      {
                                                        active:
                                                          !_vm.youtubeOptions
                                                            .madeForKids,
                                                      },
                                                      "w50",
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.youtubeOptions.madeForKids =
                                                          !_vm.youtubeOptions
                                                            .madeForKids
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.posts.youtube_options.made_for_kids"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _c("li", { staticClass: "clearBoth" }, [
                                          _c(
                                            "span",
                                            { staticClass: "select-title" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    `dash.post.youtube_options.privacy_level.title`
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.youtubeOptions
                                                      .privacy_level,
                                                  expression:
                                                    "youtubeOptions.privacy_level",
                                                },
                                              ],
                                              staticClass:
                                                "privacy-level-input",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    _vm.youtubeOptions,
                                                    "privacy_level",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "private" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        `dash.post.youtube_options.privacy-level.private`
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "option",
                                                { attrs: { value: "public" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        `dash.post.youtube_options.privacy-level.public`
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "option",
                                                {
                                                  attrs: { value: "unlisted" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        `dash.post.youtube_options.privacy-level.unlisted`
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm.youtubeCategories &&
                                        _vm.youtubeCategories.length
                                          ? _c(
                                              "li",
                                              { staticClass: "clearBoth" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "select-title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          `dash.post.youtube_options.categories.opt.title`
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.youtubeOptions
                                                            .category,
                                                        expression:
                                                          "youtubeOptions.category",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "privacy-level-input",
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.$set(
                                                          _vm.youtubeOptions,
                                                          "category",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      },
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.youtubeCategories.filter(
                                                      (c) =>
                                                        c.snippet.assignable
                                                    ),
                                                    function (opt, idx) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: idx,
                                                          domProps: {
                                                            value: opt.id,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              opt.snippet.title
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "li",
                                          { staticClass: "clearBoth" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "vue-tags-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      `dash.post.youtube_options.tags.title`
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("vue-tags-input", {
                                              attrs: {
                                                tags: _vm.youtubeOptions.tags,
                                                placeholder: _vm.$t(
                                                  "dash.post.youtube_options.tags.placeholder"
                                                ),
                                              },
                                              on: {
                                                "tags-changed": (newTags) =>
                                                  (_vm.youtubeOptions.tags =
                                                    newTags),
                                              },
                                              model: {
                                                value: _vm.youtubeOptions.tag,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.youtubeOptions,
                                                    "tag",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "youtubeOptions.tag",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm.youtubePlaylists &&
                                        _vm.youtubePlaylists.length
                                          ? _c(
                                              "li",
                                              { staticClass: "clearBoth" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "select-title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          `dash.post.youtube_options.playlist.opt.title`
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.youtubeOptions
                                                            .playlist,
                                                        expression:
                                                          "youtubeOptions.playlist",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "playlist-input privacy-level-input",
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.$set(
                                                          _vm.youtubeOptions,
                                                          "playlist",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value: null,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `dash.post.youtube_options.playlist.opt.none`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._l(
                                                      _vm.youtubePlaylists,
                                                      function (opt, idx) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: idx,
                                                            domProps: {
                                                              value: opt.id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                opt.snippet
                                                                  .title
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.atLeastTiktokSelected()
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "options-wrapper type-video",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "options-wrapper-tilte",
                                        },
                                        [
                                          _c("vs-avatar", {
                                            attrs: {
                                              color: "transparent",
                                              size: "18px",
                                              src: require("../../../assets/img/icon_tiktok.png"),
                                            },
                                          }),
                                          _vm._v(
                                            "\n                  TikTok\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("ul", [
                                        _c("li", [
                                          _c(
                                            "div",
                                            { staticClass: "checkboxes" },
                                            [
                                              _c("ul", [
                                                _c(
                                                  "li",
                                                  {
                                                    class: [
                                                      {
                                                        active:
                                                          _vm.tiktokOptions
                                                            .comment_disabled,
                                                      },
                                                      "w50",
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.tiktokOptions.comment_disabled =
                                                          !_vm.tiktokOptions
                                                            .comment_disabled
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.posts.tiktok_options.comment_disabled"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c(
                                                  "li",
                                                  {
                                                    class: [
                                                      {
                                                        active:
                                                          _vm.tiktokOptions
                                                            .duet_disabled,
                                                      },
                                                      "w50",
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.tiktokOptions.duet_disabled =
                                                          !_vm.tiktokOptions
                                                            .duet_disabled
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            "dash.posts.tiktok_options.duet_disabled.detail"
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.posts.tiktok_options.duet_disabled"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          "\n                             \n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "li",
                                                  {
                                                    class: [
                                                      {
                                                        active:
                                                          _vm.tiktokOptions
                                                            .stitch_disabled,
                                                      },
                                                      "w50",
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.tiktokOptions.stitch_disabled =
                                                          !_vm.tiktokOptions
                                                            .stitch_disabled
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            "dash.posts.tiktok_options.stitch_disabled.detail"
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.posts.tiktok_options.stitch_disabled"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          "\n                             \n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _c("li", { staticClass: "clearBoth" }, [
                                          _c(
                                            "span",
                                            { staticClass: "select-title" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    `dash.post.privacy-level.opt.title`
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm.tiktokRequirements &&
                                          _vm.tiktokRequirements
                                            .privacy_level_options
                                            ? _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.tiktokOptions
                                                          .privacy_level,
                                                      expression:
                                                        "tiktokOptions.privacy_level",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "privacy-level-input",
                                                  on: {
                                                    change: function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        _vm.tiktokOptions,
                                                        "privacy_level",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.tiktokRequirements
                                                    .privacy_level_options,
                                                  function (opt, idx) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: idx,
                                                        domProps: {
                                                          value: opt,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `dash.post.privacy-level.opt.${opt}`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.atLeastFacebookSelected() &&
                              _vm.state !== "edit-posted"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "options-wrapper type-video",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "options-wrapper-tilte",
                                        },
                                        [
                                          _c("vs-avatar", {
                                            attrs: {
                                              color: "transparent",
                                              size: "18px",
                                              src: require("../../../assets/img/icon_fb.png"),
                                            },
                                          }),
                                          _vm._v(
                                            "\n                  Facebook\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("ul", [
                                        _c("li", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "checkboxes",
                                              class: [
                                                { disabled: _vm.onUpload },
                                              ],
                                            },
                                            [
                                              _c("ul", [
                                                _c(
                                                  "li",
                                                  {
                                                    class: [
                                                      {
                                                        active:
                                                          !_vm.videoReelFB,
                                                      },
                                                      "w50",
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.videoReelFB =
                                                          !_vm.onUpload
                                                            ? false
                                                            : _vm.videoReelFB
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.posts.video"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c(
                                                  "li",
                                                  {
                                                    class: [
                                                      {
                                                        active: _vm.videoReelFB,
                                                      },
                                                      "w50",
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.videoReelFB =
                                                          !_vm.onUpload
                                                            ? true
                                                            : _vm.videoReelFB
                                                      },
                                                    },
                                                  },
                                                  [_c("span", [_vm._v("Reel")])]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.typePost === "poll"
                      ? _c("div", { staticClass: "poll" }, [
                          _c("div", { staticClass: "poll-question" }, [
                            _c(
                              "label",
                              {
                                staticClass: "poll-label",
                                attrs: { for: "poll-question" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("dash.post.poll.question.label")
                                  )
                                ),
                              ]
                            ),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.poll.question,
                                  expression: "poll.question",
                                },
                              ],
                              staticClass: "poll-input",
                              attrs: { maxlength: "140", id: "poll-question" },
                              domProps: { value: _vm.poll.question },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.poll,
                                    "question",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _c("span", { staticClass: "poll-nb-char" }, [
                              _vm._v(_vm._s(_vm.poll.question.length) + "/140"),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "poll-options" },
                            [
                              _vm._l(_vm.poll.options, function (opt, idx) {
                                return _c(
                                  "span",
                                  { key: idx, staticClass: "poll-option" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "poll-label",
                                        attrs: { for: `poll-option${idx}` },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.post.poll.option.label"
                                            ) +
                                              " " +
                                              (idx + 1)
                                          )
                                        ),
                                      ]
                                    ),
                                    idx > 1
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "poll-option-delete",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removePollOption(idx)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.post.poll.option.remove"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.poll.options[idx],
                                          expression: "poll.options[idx]",
                                        },
                                      ],
                                      staticClass: "poll-input",
                                      attrs: {
                                        maxlength: "30",
                                        id: `poll-option${idx}`,
                                      },
                                      domProps: {
                                        value: _vm.poll.options[idx],
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.poll.options,
                                            idx,
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "poll-nb-char" },
                                      [_vm._v(_vm._s(opt.length) + "/30")]
                                    ),
                                  ]
                                )
                              }),
                              _vm.poll.options.length < 4
                                ? _c(
                                    "vs-button",
                                    {
                                      staticClass: "poll-option-add",
                                      on: { click: _vm.addPollOption },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.post.poll.option.add")
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm.onlyLinkedinSelected()
                            ? _c("div", { staticClass: "poll-duration" }, [
                                _c(
                                  "label",
                                  { staticClass: "poll-duration-label" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.post.poll.duration.label")
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.poll.duration,
                                        expression: "poll.duration",
                                      },
                                    ],
                                    staticClass: "poll-duration-input",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.poll,
                                          "duration",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "86400" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.post.poll.duration.option1"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "option",
                                      { attrs: { value: "259200" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.post.poll.duration.option2"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "option",
                                      { attrs: { value: "604800" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.post.poll.duration.option3"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "option",
                                      { attrs: { value: "1209600" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dash.post.poll.duration.option4"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm.typePost === "document"
                      ? _c(
                          "div",
                          { style: { marginBottom: "15px" } },
                          [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("dash.post.title.document"))
                              ),
                            ]),
                            _c("vs-input", {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.form.documentTitle,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "documentTitle", $$v)
                                },
                                expression: "form.documentTitle",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.typePost === "story" &&
                    !_vm.storyVideo &&
                    !_vm.storyShare
                      ? _c("div", {}, [
                          _c("div", { staticClass: "custom-file-input" }, [
                            _c("div", { staticClass: "file-input" }, [
                              _c("div", { staticClass: "file-btn" }, [
                                _c("div", { staticClass: "vertical" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/icon_media.png"),
                                      alt: "media",
                                    },
                                  }),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.posts.form.story.layers")
                                      )
                                    ),
                                  ]),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "",
                                        expression: "''",
                                      },
                                    ],
                                    class: {
                                      input: true,
                                      "is-danger": _vm.errors.has("posts.file"),
                                    },
                                    attrs: {
                                      name: "file",
                                      type: "file",
                                      id: "file",
                                      accept: "image/*",
                                    },
                                    on: {
                                      change: (e) =>
                                        _vm.$store.dispatch(
                                          "addStorificationLayerDefault",
                                          e.target.files[0]
                                        ),
                                      click: _vm.initInputFile,
                                    },
                                  }),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "layers-preview" },
                                _vm._l(
                                  _vm.$store.getters.storificationLayers,
                                  function (layer, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "layer-preview" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "remove-layer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.$store.commit(
                                                  "removeStorificationLayer",
                                                  i
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("x")]
                                        ),
                                        _c("img", {
                                          attrs: {
                                            src: layer.reader || layer.url,
                                            alt: i,
                                          },
                                        }),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.typePost === "story"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "add-mention add-location-story tooltip",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "disable-story-btn",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return (() => {
                                      !_vm.onlyInstagramConciergerieSelected() &&
                                        _vm.showConciergerieForm()
                                    }).apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c(
                                  "Tooltip",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      active:
                                        !_vm.onlyInstagramConciergerieSelected(),
                                      text: _vm.$t("dash.bots.status_proxy"),
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        ref: "inputSearchMention",
                                        staticClass: "btn-add",
                                        attrs: {
                                          disabled:
                                            !_vm.onlyInstagramConciergerieSelected(),
                                          type: "button",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleShowMentions(
                                              "Location"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              "enable-background":
                                                "new 0 0 32 32",
                                              height: "20px",
                                              id: "Layer_1",
                                              version: "1.1",
                                              viewBox: "0 0 32 32",
                                              width: "20px",
                                              "xml:space": "preserve",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              "xmlns:xlink":
                                                "http://www.w3.org/1999/xlink",
                                            },
                                          },
                                          [
                                            _c(
                                              "g",
                                              { attrs: { id: "location" } },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    "clip-rule": "evenodd",
                                                    d: "M16.002,17.746c3.309,0,6-2.692,6-6s-2.691-6-6-6   c-3.309,0-6,2.691-6,6S12.693,17.746,16.002,17.746z M16.002,6.746c2.758,0,5,2.242,5,5s-2.242,5-5,5c-2.758,0-5-2.242-5-5   S13.244,6.746,16.002,6.746z",
                                                  },
                                                }),
                                                _c("path", {
                                                  attrs: {
                                                    "clip-rule": "evenodd",
                                                    d: "M16,0C9.382,0,4,5.316,4,12.001c0,7,6.001,14.161,10.376,19.194   C14.392,31.215,15.094,32,15.962,32c0.002,0,0.073,0,0.077,0c0.867,0,1.57-0.785,1.586-0.805   c4.377-5.033,10.377-12.193,10.377-19.194C28.002,5.316,22.619,0,16,0z M16.117,29.883c-0.021,0.02-0.082,0.064-0.135,0.098   c-0.01-0.027-0.084-0.086-0.129-0.133C12.188,25.631,6,18.514,6,12.001C6,6.487,10.487,2,16,2c5.516,0,10.002,4.487,10.002,10.002   C26.002,18.514,19.814,25.631,16.117,29.883z",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$store.getters
                                                .storificationLocation
                                                ? _vm.$t(
                                                    "dash.change-location.title"
                                                  )
                                                : _vm.$t(
                                                    "dash.add-location.title"
                                                  )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm.$store.getters.storificationLocation
                              ? _c("div", { staticClass: "location-string" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$store.getters.storificationLocation
                                          .name
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "remove-location",
                                      on: {
                                        click: (e) =>
                                          _vm.$store.commit(
                                            "removeStorificationLocation"
                                          ),
                                      },
                                    },
                                    [_vm._v("x")]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.openAutoLocations &&
                            _vm.searchLocation.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "auto-mentions row box",
                                    on: {
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "connected-pages" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "selected-page" },
                                          _vm._l(
                                            _vm.searchLocation,
                                            function (item, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "page",
                                                },
                                                [
                                                  _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: item.bot.page
                                                          .network,
                                                        position: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.selectedBotLocation,
                                                            expression:
                                                              "selectedBotLocation",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          id: `bot-index-${index}`,
                                                          name: "page",
                                                        },
                                                        domProps: {
                                                          value: index,
                                                          checked: _vm._q(
                                                            _vm.selectedBotLocation,
                                                            index
                                                          ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeMentionNetwork(
                                                              "Location",
                                                              index
                                                            )
                                                          },
                                                          change: function (
                                                            $event
                                                          ) {
                                                            _vm.selectedBotLocation =
                                                              index
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "page-wrapper",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "page-content",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "vertical-align",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "page-img-wrapper",
                                                                    },
                                                                    [
                                                                      item.bot
                                                                        .page
                                                                        .network ===
                                                                      "facebook"
                                                                        ? _c(
                                                                            "img",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  size: "25px",
                                                                                  src: require("../../../assets/img/icon_fb.png"),
                                                                                },
                                                                            }
                                                                          )
                                                                        : item
                                                                            .bot
                                                                            .page
                                                                            .network ===
                                                                          "twitter"
                                                                        ? _c(
                                                                            "img",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  size: "25px",
                                                                                  src: require("../../../assets/img/icon_tw.png"),
                                                                                },
                                                                            }
                                                                          )
                                                                        : item
                                                                            .bot
                                                                            .page
                                                                            .network ===
                                                                          "linkedin"
                                                                        ? _c(
                                                                            "img",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  size: "25px",
                                                                                  src: require("../../../assets/img/icon_linkedin.png"),
                                                                                },
                                                                            }
                                                                          )
                                                                        : item
                                                                            .bot
                                                                            .page
                                                                            .network ===
                                                                          "instagram"
                                                                        ? _c(
                                                                            "img",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  size: "25px",
                                                                                  src: require("../../../assets/img/icon_instagram.png"),
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "page-name",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .bot
                                                                            .page
                                                                            .network
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _c(
                                          "vs-button",
                                          {
                                            staticClass: "page-btn",
                                            attrs: {
                                              "vs-type": "filled",
                                              color: "#6a1f4c",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return ((e) => {
                                                  _vm.$store.commit(
                                                    "updateStorificationLocation",
                                                    _vm.searchLocation[
                                                      _vm.selectedBotLocation
                                                    ].selected
                                                  )
                                                  _vm.toggleShowMentions(
                                                    "Location"
                                                  )
                                                }).apply(null, arguments)
                                              },
                                            },
                                          },
                                          [_vm._v("OK")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("vs-input", {
                                      ref: "inputSearchMentionStory",
                                      staticClass: "inputx",
                                      attrs: {
                                        color: "#B20564",
                                        type: "text",
                                        name: "search-mention",
                                        placeholder: _vm.$t(
                                          `dash.posts.overlay.search_location_placeholder`
                                        ),
                                        autocomplete: "off",
                                      },
                                      on: {
                                        keyup: function ($event) {
                                          return _vm.searchMentions("Location")
                                        },
                                        click: function ($event) {
                                          return _vm.searchMentions("Location")
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.searchLocation[
                                            _vm.selectedBotLocation
                                          ].search,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchLocation[
                                              _vm.selectedBotLocation
                                            ],
                                            "search",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchLocation[selectedBotLocation].search",
                                      },
                                    }),
                                    _c(
                                      "ul",
                                      {
                                        attrs: {
                                          id: "loadableContent-list-mentions",
                                        },
                                      },
                                      _vm._l(
                                        _vm.searchLocation[
                                          _vm.selectedBotLocation
                                        ].results,
                                        function (mention, index) {
                                          return _c("div", { key: index }, [
                                            _c(
                                              "li",
                                              {
                                                class: {
                                                  select:
                                                    _vm.mentionIsSelected(
                                                      "Location",
                                                      mention
                                                    ) == true,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectMention(
                                                      "Location",
                                                      mention
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    class:
                                                      _vm.searchLocation[
                                                        _vm.selectedBotLocation
                                                      ].bot.page.network,
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "content",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "locations",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                mention.name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        mention.location
                                                          ? _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "locations infos",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    mention
                                                                      .location
                                                                      .street
                                                                  ) +
                                                                    _vm._s(
                                                                      mention
                                                                        .location
                                                                        .street &&
                                                                        ","
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      mention
                                                                        .location
                                                                        .zip
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      mention
                                                                        .location
                                                                        .city
                                                                    ) +
                                                                    _vm._s(
                                                                      mention
                                                                        .location
                                                                        .city &&
                                                                        ","
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      mention
                                                                        .location
                                                                        .country
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.mentionIsSelected(
                                                            "Location",
                                                            mention
                                                          ) == true,
                                                        expression:
                                                          "mentionIsSelected('Location', mention) == true",
                                                      },
                                                    ],
                                                    staticClass: "checkmark",
                                                  },
                                                  [
                                                    _c(
                                                      "i",
                                                      {
                                                        staticClass:
                                                          "material-icons",
                                                      },
                                                      [_vm._v("check")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                    _vm.isAddOrEditMentions("Location") ==
                                    "edit"
                                      ? _c(
                                          "vs-button",
                                          {
                                            staticClass: "cancel",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeMentions(
                                                  "Location"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("dash.button.cancel")
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    (_vm.typePost === "story" && !_vm.storyShare) ||
                    (_vm.videoReel &&
                      _vm.atLeastInstagramSelected() &&
                      _vm.typePost === "video" &&
                      _vm.state !== "edit-posted")
                      ? _c("GifSticker", {
                          staticClass: "music-btn",
                          attrs: {
                            pageId: _vm.bots.find(
                              (e) =>
                                _vm.bot.includes(e.id) &&
                                e.page &&
                                e.page.story_config
                            )
                              ? _vm.bots.find(
                                  (e) =>
                                    _vm.bot.includes(e.id) &&
                                    e.page &&
                                    e.page.story_config
                                ).page.id
                              : null,
                            disabled:
                              !_vm.form.video && _vm.typePost === "video",
                            isConciergerie:
                              _vm.onlyInstagramConciergerieSelected(),
                          },
                          on: {
                            insertGif: _vm.insertGif,
                            reconnect: _vm.showConciergerieForm,
                          },
                        })
                      : _vm._e(),
                    (_vm.typePost === "story" && !_vm.storyShare) ||
                    (_vm.videoReel &&
                      _vm.atLeastInstagramConciergerieSelected())
                      ? _c(
                          "div",
                          { staticClass: "layers-preview" },
                          _vm._l(
                            _vm.videoReel && _vm.typePost === "video"
                              ? _vm.$store.getters.storificationGifsReel
                              : _vm.$store.getters.storificationGifs,
                            function (gif) {
                              return _c(
                                "div",
                                { key: gif.id, staticClass: "layer-preview" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "remove-layer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeGif(gif.id)
                                        },
                                      },
                                    },
                                    [_vm._v("x")]
                                  ),
                                  _c("img", {
                                    attrs: {
                                      src: gif.images.preview_gif.url,
                                      alt: gif.name,
                                    },
                                  }),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    ((_vm.typePost === "story" && !_vm.storyShare) ||
                      (_vm.videoReel &&
                        _vm.atLeastInstagramSelected() &&
                        _vm.typePost === "video") ||
                      (_vm.atLeastInstagramSelected() &&
                        _vm.typePost === "image")) &&
                    _vm.state !== "edit-posted"
                      ? _c(
                          "div",
                          {
                            staticClass: "music-btn",
                            on: {
                              click: () => {
                                !_vm.onlyInstagramConciergerieSelected() &&
                                  _vm.showConciergerieForm()
                              },
                            },
                          },
                          [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  active:
                                    (!_vm.form.video &&
                                      _vm.typePost === "video") ||
                                    !_vm.onlyInstagramConciergerieSelected(),
                                  text: _vm.onlyInstagramConciergerieSelected()
                                    ? _vm.$t("dash.post.error.need_video.title")
                                    : _vm.$t("dash.bots.status_proxy"),
                                },
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "note select-music",
                                    attrs: {
                                      disabled:
                                        (!_vm.form.video &&
                                          _vm.typePost === "video") ||
                                        !_vm.onlyInstagramConciergerieSelected(),
                                      icon: "music_note",
                                    },
                                    on: {
                                      click: () =>
                                        _vm.toggleShowMentions("Music", 0),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.posts.form.story.music")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("br"),
                            _vm.selectedMusic && _vm.selectedMusic.track
                              ? _c(
                                  "div",
                                  { staticClass: "info-music" },
                                  [
                                    _c("vs-icon", { attrs: { icon: "album" } }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.selectedMusic.track.title) +
                                          "  (" +
                                          _vm._s(
                                            _vm.selectedMusic.track
                                              .display_artist
                                          ) +
                                          ")"
                                      ),
                                    ]),
                                    _vm.selectedMusic.config
                                      ? _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: "valider la configuration",
                                            },
                                          },
                                          [
                                            _c("vs-icon", {
                                              staticClass: "remove-music",
                                              attrs: { icon: "done" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.videoReel &&
                                                  _vm.typePost === "video"
                                                    ? _vm.$store.commit(
                                                        "updateStorificationMusicReel",
                                                        { config: false }
                                                      )
                                                    : _vm.$store.commit(
                                                        "updateStorificationMusic",
                                                        { config: false }
                                                      )
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              "\n               \n            "
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: "configurer la musique",
                                            },
                                          },
                                          [
                                            _c("vs-icon", {
                                              staticClass: "remove-music",
                                              attrs: { icon: "edit" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.videoReel &&
                                                  _vm.typePost === "video"
                                                    ? _vm.$store.commit(
                                                        "updateStorificationMusicReel",
                                                        { config: true }
                                                      )
                                                    : _vm.$store.commit(
                                                        "updateStorificationMusic",
                                                        { config: true }
                                                      )
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              "\n               \n            "
                                            ),
                                          ],
                                          1
                                        ),
                                    !_vm.selectedMusic.paused
                                      ? _c("vs-icon", {
                                          staticClass: "remove-music",
                                          attrs: { icon: "stop_circle" },
                                          on: {
                                            click: function ($event) {
                                              _vm.videoReel &&
                                              _vm.typePost === "video"
                                                ? _vm.$store.commit(
                                                    "updateStorificationMusicReel",
                                                    { paused: true }
                                                  )
                                                : _vm.$store.commit(
                                                    "updateStorificationMusic",
                                                    { paused: true }
                                                  )
                                            },
                                          },
                                        })
                                      : _c("vs-icon", {
                                          staticClass: "remove-music",
                                          attrs: { icon: "play_arrow" },
                                          on: {
                                            click: function ($event) {
                                              _vm.videoReel &&
                                              _vm.typePost === "video"
                                                ? _vm.$store.commit(
                                                    "updateStorificationMusicReel",
                                                    { paused: false }
                                                  )
                                                : _vm.$store.commit(
                                                    "updateStorificationMusic",
                                                    { paused: false }
                                                  )
                                            },
                                          },
                                        }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "remove-music",
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeMusic()
                                          },
                                        },
                                      },
                                      [_vm._v("x")]
                                    ),
                                    _vm.typePost === "image" &&
                                    !_vm.selectedMusic.paused
                                      ? _c("audio", {
                                          attrs: {
                                            autoplay: "",
                                            src: _vm.selectedMusic.track
                                              .fast_start_progressive_download_url,
                                          },
                                          on: {
                                            loadedmetadata: (e) =>
                                              (e.target.currentTime =
                                                _vm.selectedMusic.start / 1000),
                                            canplaythrough: (e) =>
                                              (e.target.volume = "0.5"),
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.checkActiveMusicSearch &&
                            (_vm.openAutoMusics || _vm.openAutoMusics === 0) &&
                            _vm.searchMusic.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "auto-mentions row box music-search",
                                    on: {
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "connected-pages" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "selected-page" },
                                          _vm._l(
                                            _vm.searchMusic,
                                            function (item, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "page",
                                                },
                                                [
                                                  _c(
                                                    "Tooltip",
                                                    {
                                                      attrs: {
                                                        text: item.bot.page
                                                          .network,
                                                        position: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.selectedBotMusic,
                                                            expression:
                                                              "selectedBotMusic",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "radio",
                                                          id: `bot-index-${index}`,
                                                          name: "page",
                                                        },
                                                        domProps: {
                                                          value: index,
                                                          checked: _vm._q(
                                                            _vm.selectedBotMusic,
                                                            index
                                                          ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeMentionNetwork(
                                                              "Music",
                                                              index
                                                            )
                                                          },
                                                          change: function (
                                                            $event
                                                          ) {
                                                            _vm.selectedBotMusic =
                                                              index
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "page-wrapper",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "page-content",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "vertical-align",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "page-img-wrapper",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              size: "25px",
                                                                              src: require("../../../assets/img/icon_instagram.png"),
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "page-name",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .bot
                                                                            .page
                                                                            .network
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _c(
                                          "vs-button",
                                          {
                                            staticClass: "page-btn",
                                            attrs: {
                                              "vs-type": "filled",
                                              color: "#6a1f4c",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.selectMusic(
                                                  _vm.searchMusic[
                                                    _vm.selectedBotMusic
                                                  ].selected
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("OK")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("vs-input", {
                                      ref: "inputSearchMentionStory",
                                      staticClass: "inputx",
                                      attrs: {
                                        color: "#B20564",
                                        type: "text",
                                        name: "search-mention",
                                        placeholder: _vm.$t(
                                          `dash.posts.overlay.search_music_placeholder`
                                        ),
                                        autocomplete: "off",
                                      },
                                      on: {
                                        keyup: function ($event) {
                                          return _vm.searchMentions("Music")
                                        },
                                        click: function ($event) {
                                          return _vm.searchMentions("Music")
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.searchMusic[_vm.selectedBotMusic]
                                            .search,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchMusic[
                                              _vm.selectedBotMusic
                                            ],
                                            "search",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchMusic[selectedBotMusic].search",
                                      },
                                    }),
                                    _c("audio", {
                                      ref: `music-preview-mention`,
                                      on: {
                                        canplaythrough: (e) =>
                                          (e.target.volume = "0.5"),
                                      },
                                    }),
                                    _c(
                                      "ul",
                                      {
                                        ref: "loadableContent-list-music",
                                        attrs: {
                                          id: "loadableContent-list-mentions",
                                        },
                                      },
                                      _vm._l(
                                        _vm.searchMusic[_vm.selectedBotMusic]
                                          .results,
                                        function (mention, index) {
                                          return _c("div", { key: index }, [
                                            mention.track
                                              ? _c(
                                                  "li",
                                                  {
                                                    class: {
                                                      select:
                                                        _vm.mentionIsSelected(
                                                          "Music",
                                                          mention
                                                        ) == true,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.selectMention(
                                                          "Music",
                                                          mention
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        class: `${
                                                          _vm.searchMusic[
                                                            _vm.selectedBotMusic
                                                          ].bot.page.network
                                                        } music-container`,
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: mention.track
                                                              .cover_artwork_thumbnail_uri,
                                                            alt: "cover",
                                                          },
                                                        }),
                                                        _vm.$refs[
                                                          `music-preview-mention`
                                                        ] &&
                                                        !_vm.$refs[
                                                          `music-preview-mention`
                                                        ].paused &&
                                                        _vm.$refs[
                                                          `music-preview-mention`
                                                        ].src ===
                                                          mention.track
                                                            .progressive_download_url
                                                          ? _c("vs-icon", {
                                                              staticClass:
                                                                "music-preview-mention",
                                                              attrs: {
                                                                icon: "pause",
                                                              },
                                                              on: {
                                                                click: (e) =>
                                                                  _vm.mentionMusicPreview(
                                                                    e,
                                                                    mention,
                                                                    "pause"
                                                                  ),
                                                              },
                                                            })
                                                          : _c("vs-icon", {
                                                              staticClass:
                                                                "music-preview-mention",
                                                              attrs: {
                                                                icon: "play_arrow",
                                                              },
                                                              on: {
                                                                click: (e) =>
                                                                  _vm.mentionMusicPreview(
                                                                    e,
                                                                    mention,
                                                                    "play"
                                                                  ),
                                                              },
                                                            }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "content",
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "musics",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    mention
                                                                      .track
                                                                      .title
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "musics infos",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    mention
                                                                      .track
                                                                      .display_artist
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.mentionIsSelected(
                                                                "Music",
                                                                mention
                                                              ) == true,
                                                            expression:
                                                              "mentionIsSelected('Music', mention) == true",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "checkmark",
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [_vm._v("check")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                    _vm.isAddOrEditMentions("Music", 0) ==
                                    "edit"
                                      ? _c(
                                          "vs-button",
                                          {
                                            staticClass: "cancel",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeMentions(
                                                  "Music",
                                                  0
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("dash.button.cancel")
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.typePost === "story" &&
                    !_vm.storyShare &&
                    !_vm.storyVideo &&
                    (_vm.url || _vm.form.url)
                      ? _c("div", { staticClass: "layer-background" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("dash.posts.background.colors.label")
                              ) +
                              "\n          "
                          ),
                          _c("input", {
                            attrs: { type: "color" },
                            domProps: {
                              value:
                                _vm.$store.getters.storificationBackgroundColor,
                            },
                            on: {
                              change: (e) =>
                                _vm.$store.commit(
                                  `updateStorificationBackgroundColor`,
                                  e.target.value
                                ),
                            },
                          }),
                          _c(
                            "button",
                            {
                              staticClass: "btn-add",
                              attrs: { type: "button" },
                              on: {
                                click: (e) =>
                                  _vm.$store.commit(
                                    `updateStorificationBackgroundColor`,
                                    null
                                  ),
                              },
                            },
                            [_vm._v("\n            Reset\n          ")]
                          ),
                        ])
                      : _vm._e(),
                    _vm.typePost === "story"
                      ? _c("ShopSticker", {
                          staticClass: "music-btn",
                          attrs: {
                            pageId: _vm.bots.find(
                              (e) =>
                                _vm.bot.includes(e.id) &&
                                e.page &&
                                e.page.story_config &&
                                e.page.network === "instagram"
                            )
                              ? _vm.bots.find(
                                  (e) =>
                                    _vm.bot.includes(e.id) &&
                                    e.page &&
                                    e.page.story_config &&
                                    e.page.network === "instagram"
                                ).page.id
                              : null,
                            isConciergerie:
                              _vm.onlyInstagramConciergerieSelected(),
                            products: _vm.$store.getters.storificationProduct
                              ? _vm.$store.getters.storificationProduct.items
                              : [],
                          },
                          on: {
                            reconnect: _vm.showConciergerieForm,
                            insertShop: (shop) =>
                              _vm.$store.commit("updateStorificationProduct", {
                                items: JSON.parse(JSON.stringify(shop)),
                              }),
                          },
                        })
                      : _vm._e(),
                    _vm.typePost === "story" &&
                    _vm.$store.getters.storificationProduct
                      ? _c(
                          "div",
                          { staticClass: "layers-preview" },
                          _vm._l(
                            _vm.$store.getters.storificationProduct.items,
                            function (product) {
                              return _c(
                                "div",
                                {
                                  key: product.id,
                                  staticClass: "layer-preview",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "remove-layer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeProduct(product.id)
                                        },
                                      },
                                    },
                                    [_vm._v("x")]
                                  ),
                                  _c("img", {
                                    attrs: {
                                      src: product.image,
                                      alt: product.text,
                                    },
                                  }),
                                  _c("p", [_vm._v(_vm._s(product.text))]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    _vm.typePost === "story"
                      ? _c("div", { staticClass: "poll-story" }, [
                          _c(
                            "div",
                            {
                              staticClass: "disable-story-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return (() => {
                                    !_vm.onlyInstagramConciergerieSelected() &&
                                      _vm.showConciergerieForm()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    active:
                                      !_vm.onlyInstagramConciergerieSelected(),
                                    text: _vm.$t("dash.bots.status_proxy"),
                                  },
                                },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticClass: "poll-story-check",
                                      attrs: {
                                        disabled:
                                          !_vm.onlyInstagramConciergerieSelected(),
                                        checked:
                                          _vm.$store.getters.storificationPoll,
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.$store.getters.storificationPoll
                                            ? _vm.$store.commit(
                                                "updateStorificationPoll",
                                                null
                                              )
                                            : _vm.$store.commit(
                                                "updateStorificationPoll",
                                                { question: "", options: [] }
                                              )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("dash.posts.poll")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.$store.getters.storificationPoll
                            ? _c(
                                "div",
                                { staticClass: "poll-story-inputs" },
                                [
                                  _c("vs-input", {
                                    staticClass: "poll-story-question",
                                    attrs: {
                                      maxlength: "50",
                                      label: _vm.$t(
                                        "dash.post.poll.question.label"
                                      ),
                                      placeholder: "Question ?",
                                      value:
                                        _vm.$store.getters.storificationPoll
                                          .question,
                                    },
                                    on: {
                                      input: (e) =>
                                        _vm.$store.commit(
                                          "updateStorificationPoll",
                                          { question: e }
                                        ),
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "poll-story-options" },
                                    [
                                      _c("vs-input", {
                                        staticClass: "poll-story-option",
                                        attrs: {
                                          maxlength: "40",
                                          label:
                                            _vm.$t(
                                              "dash.post.poll.option.label"
                                            ) + " 1",
                                          value:
                                            _vm.$store.getters.storificationPoll
                                              .options[0] || "",
                                          placeholder: "Oui",
                                        },
                                        on: {
                                          input: (e) =>
                                            _vm.$store.commit(
                                              "updateStorificationPollOption",
                                              { index: 0, option: e }
                                            ),
                                        },
                                      }),
                                      _c("vs-input", {
                                        staticClass: "poll-story-option",
                                        attrs: {
                                          maxlength: "40",
                                          label:
                                            _vm.$t(
                                              "dash.post.poll.option.label"
                                            ) + " 2",
                                          value:
                                            _vm.$store.getters.storificationPoll
                                              .options[1] || "",
                                          placeholder: "Non",
                                        },
                                        on: {
                                          input: (e) =>
                                            _vm.$store.commit(
                                              "updateStorificationPollOption",
                                              { index: 1, option: e }
                                            ),
                                        },
                                      }),
                                      _c("vs-input", {
                                        staticClass: "poll-story-option",
                                        attrs: {
                                          maxlength: "40",
                                          label:
                                            _vm.$t(
                                              "dash.post.poll.option.label"
                                            ) + " 3",
                                          value:
                                            _vm.$store.getters.storificationPoll
                                              .options[2] || "",
                                          placeholder: "Optional",
                                        },
                                        on: {
                                          input: (e) =>
                                            _vm.$store.commit(
                                              "updateStorificationPollOption",
                                              { index: 2, option: e }
                                            ),
                                        },
                                      }),
                                      _c("vs-input", {
                                        staticClass: "poll-story-option",
                                        attrs: {
                                          maxlength: "40",
                                          label:
                                            _vm.$t(
                                              "dash.post.poll.option.label"
                                            ) + " 4",
                                          value:
                                            _vm.$store.getters.storificationPoll
                                              .options[3] || "",
                                          placeholder: "Optional",
                                        },
                                        on: {
                                          input: (e) =>
                                            _vm.$store.commit(
                                              "updateStorificationPollOption",
                                              { index: 3, option: e }
                                            ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm.typePost === "story"
                      ? _c("div", { staticClass: "poll-story" }, [
                          _c(
                            "div",
                            {
                              staticClass: "disable-story-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return (() => {
                                    !_vm.onlyInstagramConciergerieSelected() &&
                                      _vm.showConciergerieForm()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    active:
                                      !_vm.onlyInstagramConciergerieSelected(),
                                    text: _vm.$t("dash.bots.status_proxy"),
                                  },
                                },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticClass: "poll-story-check",
                                      attrs: {
                                        disabled:
                                          !_vm.onlyInstagramConciergerieSelected(),
                                        checked:
                                          _vm.$store.getters
                                            .storificationSlider,
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.$store.getters.storificationSlider
                                            ? _vm.$store.commit(
                                                "updateStorificationSlider",
                                                null
                                              )
                                            : _vm.$store.commit(
                                                "updateStorificationSlider",
                                                {
                                                  question: "",
                                                  emoji: "😍",
                                                  color: 0,
                                                }
                                              )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("dash.posts.slider"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.$store.getters.storificationSlider
                            ? _c(
                                "div",
                                { staticClass: "slider-story-params" },
                                [
                                  _c("vs-input", {
                                    staticClass: "poll-story-question",
                                    attrs: {
                                      maxlength: "45",
                                      label: _vm.$t(
                                        "dash.post.poll.question.label"
                                      ),
                                      placeholder: "(Optionnel)",
                                      value:
                                        _vm.$store.getters.storificationSlider
                                          .question,
                                    },
                                    on: {
                                      input: (e) =>
                                        _vm.$store.commit(
                                          "updateStorificationSlider",
                                          { question: e }
                                        ),
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "click-outside",
                                          rawName: "v-click-outside",
                                          value: () =>
                                            (_vm.sliderEmojiPicker = false),
                                          expression:
                                            "() => sliderEmojiPicker = false",
                                        },
                                      ],
                                      staticClass: "textarea-emoji-picker",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "emoji",
                                          on: {
                                            click: () =>
                                              (_vm.sliderEmojiPicker =
                                                !_vm.sliderEmojiPicker),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$store.getters
                                                .storificationSlider.emoji
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("picker", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.sliderEmojiPicker,
                                            expression: "sliderEmojiPicker",
                                          },
                                        ],
                                        staticClass: "emoji-picker-slider",
                                        attrs: {
                                          data: _vm.emojiIndex,
                                          title: "Pick your emoji...",
                                          emoji: "point_up",
                                        },
                                        on: {
                                          select: (e) =>
                                            _vm.$store.commit(
                                              "updateStorificationSlider",
                                              { emoji: e.native }
                                            ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm.typePost === "story"
                      ? _c("div", { staticClass: "poll-story" }, [
                          _c(
                            "div",
                            {
                              staticClass: "disable-story-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return (() => {
                                    !_vm.onlyInstagramConciergerieSelected() &&
                                      _vm.showConciergerieForm()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    active:
                                      !_vm.onlyInstagramConciergerieSelected(),
                                    text: _vm.$t("dash.bots.status_proxy"),
                                  },
                                },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticClass: "poll-story-check",
                                      attrs: {
                                        disabled:
                                          !_vm.onlyInstagramConciergerieSelected(),
                                        checked:
                                          _vm.$store.getters
                                            .storificationQuestion,
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.$store.getters
                                            .storificationQuestion
                                            ? _vm.$store.commit(
                                                "updateStorificationQuestion",
                                                null
                                              )
                                            : _vm.$store.commit(
                                                "updateStorificationQuestion",
                                                {
                                                  text: "",
                                                  avatar: "",
                                                  color: 0,
                                                }
                                              )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.detail.history.difference.pollStory.question"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.$store.getters.storificationQuestion
                            ? _c(
                                "div",
                                { staticClass: "slider-story-params" },
                                [
                                  _c("vs-input", {
                                    staticClass: "poll-story-question",
                                    attrs: {
                                      maxlength: "45",
                                      label: _vm.$t(
                                        "dash.post.poll.question.label"
                                      ),
                                      placeholder: "Posez-moi une question",
                                      value:
                                        _vm.$store.getters.storificationQuestion
                                          .text,
                                    },
                                    on: {
                                      input: (e) =>
                                        _vm.$store.commit(
                                          "updateStorificationQuestion",
                                          { text: e }
                                        ),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm.typePost === "story"
                      ? _c("div", { staticClass: "mentions-story" }, [
                          _c(
                            "div",
                            {
                              staticClass: "disable-story-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return (() => {
                                    !_vm.onlyInstagramConciergerieSelected() &&
                                      _vm.showConciergerieForm()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    active:
                                      !_vm.onlyInstagramConciergerieSelected(),
                                    text: _vm.$t("dash.bots.status_proxy"),
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn-add",
                                      attrs: {
                                        disabled:
                                          !_vm.onlyInstagramConciergerieSelected(),
                                        type: "button",
                                      },
                                      on: {
                                        click: () => _vm.openMentionWidget(),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.bots.mention_name_placeholder"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.$store.getters.storificationMentions &&
                          _vm.$store.getters.storificationMentions.length
                            ? _c(
                                "p",
                                [
                                  _vm._v("Mentions :\n              "),
                                  _vm._l(
                                    _vm.$store.getters.storificationMentions,
                                    function (mention, idx) {
                                      return _c(
                                        "span",
                                        {
                                          key: mention.pk,
                                          staticClass: "location-string",
                                        },
                                        [
                                          mention.hide
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidder material-icons",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$store.commit(
                                                        "updateStorificationMention",
                                                        {
                                                          index: idx,
                                                          hide: false,
                                                        }
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("visibility")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidder material-icons",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$store.commit(
                                                        "updateStorificationMention",
                                                        {
                                                          index: idx,
                                                          hide: true,
                                                        }
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("visibility_off")]
                                              ),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(mention.id) +
                                              " \n                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "remove-location",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$store.commit(
                                                    "removeStorificationMention",
                                                    idx
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("x")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "dialog",
                            {
                              ref: "searchMentionWidget",
                              staticClass: "searchTag",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "auto-mentions",
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addMentionWidget()
                                        },
                                      },
                                    },
                                    [_vm._v("OK")]
                                  ),
                                  _vm.searchMention[_vm.selectedBotMention]
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ].search,
                                            expression:
                                              "searchMention[selectedBotMention].search",
                                          },
                                        ],
                                        ref: "inputSearchMentionTag",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            `dash.posts.overlay.search_mention_placeholder_instagram_direct`
                                          ),
                                        },
                                        domProps: {
                                          value:
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ].search,
                                        },
                                        on: {
                                          keyup: function ($event) {
                                            return _vm.searchMentions("Mention")
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ],
                                              "search",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.searchMention[_vm.selectedBotMention] &&
                                  _vm.searchMention[_vm.selectedBotMention]
                                    .results &&
                                  _vm.searchMention[_vm.selectedBotMention]
                                    .results.length
                                    ? _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        _vm._l(
                                          _vm.searchMention[
                                            _vm.selectedBotMention
                                          ].results.filter(
                                            (e) =>
                                              !_vm.userTags.list
                                                .map((ee) => ee.id)
                                                .includes(e.pk)
                                          ),
                                          function (mention, index) {
                                            return _c("div", { key: index }, [
                                              _vm.mentionIsSelected(
                                                "Mention",
                                                mention
                                              )
                                                ? _c(
                                                    "li",
                                                    {
                                                      class: {
                                                        select:
                                                          _vm.mentionIsSelected(
                                                            "Mention",
                                                            mention
                                                          ) == true,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectMention(
                                                            "Mention",
                                                            mention
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class:
                                                            _vm.searchMention[
                                                              _vm
                                                                .selectedBotMention
                                                            ].bot.page.network,
                                                        },
                                                        [
                                                          mention.image
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "image",
                                                                attrs: {
                                                                  alt: mention.name,
                                                                  src: mention.image,
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "content",
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "name",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      mention.name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "screen_name id",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "@" +
                                                                      _vm._s(
                                                                        mention.id
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                              mention.subtitle
                                                                ? _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "screen_name",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          mention.subtitle
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.mentionIsSelected(
                                                                  "Mention",
                                                                  mention
                                                                ) == true,
                                                              expression:
                                                                "mentionIsSelected('Mention', mention) == true",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "checkmark",
                                                        },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "material-icons",
                                                            },
                                                            [_vm._v("check")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm.searchMention[
                                        _vm.selectedBotMention
                                      ] &&
                                      _vm.searchMention[_vm.selectedBotMention]
                                        .results
                                    ? _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        [_vm._m(11)]
                                      )
                                    : _c("ul", {
                                        staticClass: "empty",
                                        attrs: {
                                          id: "loadableContent-list-mentions",
                                        },
                                      }),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.typePost === "story"
                      ? _c("div", { staticClass: "mentions-story" }, [
                          _c(
                            "div",
                            {
                              staticClass: "disable-story-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return (() => {
                                    !_vm.onlyInstagramConciergerieSelected() &&
                                      _vm.showConciergerieForm()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    active:
                                      !_vm.onlyInstagramConciergerieSelected(),
                                    text: _vm.$t("dash.bots.status_proxy"),
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn-add",
                                      attrs: {
                                        disabled:
                                          !_vm.onlyInstagramConciergerieSelected(),
                                        type: "button",
                                      },
                                      on: {
                                        click: () => _vm.openHashtagWidget(),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.bots.hashtags_name_placeholder"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.$store.getters.storificationHashtags &&
                          _vm.$store.getters.storificationHashtags.length
                            ? _c(
                                "p",
                                [
                                  _vm._v("Hashtags :\n              "),
                                  _vm._l(
                                    _vm.$store.getters.storificationHashtags,
                                    function (mention, idx) {
                                      return _c(
                                        "span",
                                        {
                                          key: mention.pk,
                                          staticClass: "location-string",
                                        },
                                        [
                                          mention.hide
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidder material-icons",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$store.commit(
                                                        "updateStorificationHashtag",
                                                        {
                                                          index: idx,
                                                          hide: false,
                                                        }
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("visibility")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hidder material-icons",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$store.commit(
                                                        "updateStorificationHashtag",
                                                        {
                                                          index: idx,
                                                          hide: true,
                                                        }
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("visibility_off")]
                                              ),
                                          _vm._v(
                                            "\n                #" +
                                              _vm._s(mention.hashtag) +
                                              " \n                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "remove-location",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$store.commit(
                                                    "removeStorificationHashtag",
                                                    idx
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("x")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "dialog",
                            {
                              ref: "searchHashtagWidget",
                              staticClass: "searchTag",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "auto-mentions",
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addHashtagWidget()
                                        },
                                      },
                                    },
                                    [_vm._v("OK")]
                                  ),
                                  _vm.searchHashtag[_vm.selectedBotHashtag]
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.searchHashtag[
                                                _vm.selectedBotHashtag
                                              ].search,
                                            expression:
                                              "searchHashtag[selectedBotHashtag].search",
                                          },
                                        ],
                                        ref: "inputSearchMentionTag",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            `dash.posts.overlay.search_hashtag_placeholder`
                                          ),
                                        },
                                        domProps: {
                                          value:
                                            _vm.searchHashtag[
                                              _vm.selectedBotHashtag
                                            ].search,
                                        },
                                        on: {
                                          keyup: function ($event) {
                                            return _vm.searchMentions("Hashtag")
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.searchHashtag[
                                                _vm.selectedBotHashtag
                                              ],
                                              "search",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.searchHashtag[_vm.selectedBotHashtag] &&
                                  _vm.searchHashtag[_vm.selectedBotHashtag]
                                    .results &&
                                  _vm.searchHashtag[_vm.selectedBotHashtag]
                                    .results.length
                                    ? _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        _vm._l(
                                          _vm.searchHashtag[
                                            _vm.selectedBotHashtag
                                          ].results,
                                          function (mention, index) {
                                            return _c("div", { key: index }, [
                                              _c(
                                                "li",
                                                {
                                                  class: {
                                                    select:
                                                      _vm.mentionIsSelected(
                                                        "Hashtag",
                                                        mention
                                                      ) == true,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectMention(
                                                        "Hashtag",
                                                        mention
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      class:
                                                        _vm.searchHashtag[
                                                          _vm.selectedBotHashtag
                                                        ].bot.page.network,
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "content",
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  `#${mention.hashtag}`
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "count",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  `${
                                                                    mention.count
                                                                  } ${"Post"}${
                                                                    mention.count >
                                                                    1
                                                                      ? "s"
                                                                      : ""
                                                                  }`
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.mentionIsSelected(
                                                              "Hashtag",
                                                              mention
                                                            ) == true,
                                                          expression:
                                                            "mentionIsSelected('Hashtag', mention) == true",
                                                        },
                                                      ],
                                                      staticClass: "checkmark",
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("check")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm.searchHashtag[
                                        _vm.selectedBotHashtag
                                      ] &&
                                      _vm.searchHashtag[_vm.selectedBotHashtag]
                                        .results
                                    ? _c(
                                        "ul",
                                        {
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        },
                                        [_vm._m(12)]
                                      )
                                    : _c("ul", {
                                        staticClass: "empty",
                                        attrs: {
                                          id: "loadableContent-list-mentions",
                                        },
                                      }),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm.typePost == "image" &&
                    _vm.carouselPossible() &&
                    _vm.multipleImages.length > 1
                      ? _c(
                          "span",
                          [
                            _c(
                              "draggable",
                              {
                                attrs: {
                                  move: _vm.moveCarousel,
                                  options: {
                                    handle: ".drag-only-this",
                                    filter: ".no-drag",
                                    disabled: _vm.state === "edit-posted",
                                  },
                                },
                                model: {
                                  value: _vm.multipleImages,
                                  callback: function ($$v) {
                                    _vm.multipleImages = $$v
                                  },
                                  expression: "multipleImages",
                                },
                              },
                              _vm._l(_vm.multipleImages, function (obj) {
                                return _c(
                                  "div",
                                  {
                                    key: obj.id,
                                    class: `input-wrapper`,
                                    attrs: { id: obj.id },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "custom-file-input" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "file-input" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class: `file-name ${
                                                  obj.file
                                                    ? "drag-only-this"
                                                    : "no-drag"
                                                }`,
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "vertical carousel-files",
                                                  },
                                                  [
                                                    obj.filename
                                                      ? _c("p", [
                                                          _vm._v(
                                                            _vm._s(obj.filename)
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.url
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "del-img-wrapper",
                                                          },
                                                          [
                                                            obj.url
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "carousel-thumb",
                                                                  attrs: {
                                                                    src: obj.url,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            obj.url &&
                                                            _vm.state !==
                                                              "edit-posted"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "delete-img-thumb",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.removeMultipleImages(
                                                                            obj.id
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [_vm._v("𝗫")]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    obj.file &&
                                                    _vm.state !== "edit-posted"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "drag-icon-carousel",
                                                          attrs: {
                                                            src: require("../../../assets/img/drag-list2.svg"),
                                                            alt: "",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("posts.file"),
                                          expression:
                                            "errors.has('posts.file')",
                                        },
                                      ],
                                      staticClass: "fa fa-warning",
                                    }),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has("posts.file"),
                                            expression:
                                              "errors.has('posts.file')",
                                          },
                                        ],
                                        staticClass: "help is-danger",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("posts.file"))
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.multipleMedias.length > 1
                      ? _c(
                          "span",
                          [
                            _c(
                              "draggable",
                              {
                                attrs: {
                                  options: {
                                    handle: ".drag-only-this",
                                    filter: ".no-drag",
                                    disabled: _vm.state === "edit-posted",
                                  },
                                },
                                model: {
                                  value: _vm.multipleMedias,
                                  callback: function ($$v) {
                                    _vm.multipleMedias = $$v
                                  },
                                  expression: "multipleMedias",
                                },
                              },
                              _vm._l(_vm.multipleMedias, function (obj) {
                                return _c(
                                  "div",
                                  {
                                    key: obj.id,
                                    class: `input-wrapper`,
                                    attrs: { id: obj.id },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "custom-file-input" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "file-input" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class: `file-name ${
                                                  obj.file
                                                    ? "drag-only-this"
                                                    : "no-drag"
                                                }`,
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "vertical carousel-files",
                                                  },
                                                  [
                                                    obj.url
                                                      ? _c("p", [
                                                          _vm._v(
                                                            _vm._s(obj.name)
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    obj.url
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "del-img-wrapper",
                                                          },
                                                          [
                                                            obj.type.includes(
                                                              "image"
                                                            )
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "carousel-thumb",
                                                                  attrs: {
                                                                    src: obj.url,
                                                                  },
                                                                })
                                                              : obj.type.includes(
                                                                  "video"
                                                                )
                                                              ? _c("video", {
                                                                  staticClass:
                                                                    "video-thumb",
                                                                  attrs: {
                                                                    width: "37",
                                                                    height:
                                                                      "70",
                                                                    src: obj.url,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            obj.url &&
                                                            _vm.state !==
                                                              "edit-posted"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "delete-img-thumb",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.removeMultipleMedias(
                                                                            obj.id
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [_vm._v("𝗫")]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    obj.url &&
                                                    _vm.state !== "edit-posted"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "drag-icon-carousel",
                                                          attrs: {
                                                            src: require("../../../assets/img/drag-list2.svg"),
                                                            alt: "",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.typePost === "story" &&
                    !_vm.storyVideo &&
                    !_vm.storyShare
                      ? _c(
                          "div",
                          { staticClass: "layer-background" },
                          [
                            _c(
                              "vs-select",
                              {
                                on: {
                                  change: (e) =>
                                    _vm.$store.commit(
                                      "updateStorificationTemplate",
                                      e
                                    ),
                                },
                                model: {
                                  value: _vm.templateManual,
                                  callback: function ($$v) {
                                    _vm.templateManual = $$v
                                  },
                                  expression: "templateManual",
                                },
                              },
                              [
                                _c("vs-select-item", {
                                  attrs: {
                                    text: _vm.$t(
                                      "dash.post.story.select-template.no_template"
                                    ),
                                    value: null,
                                  },
                                }),
                                _vm.getPageInfoByBot(_vm.bot[0]).name ===
                                "nextplzofficiel"
                                  ? _c("vs-select-item", {
                                      attrs: {
                                        text: "Template NextPlz",
                                        value: "template_nextplz",
                                      },
                                    })
                                  : _c("vs-select-item", {
                                      attrs: {
                                        text: "Template 1",
                                        value: "template1",
                                      },
                                    }),
                                _c("vs-select-item", {
                                  attrs: {
                                    text: "Template 2",
                                    value: "template2",
                                  },
                                }),
                                _vm.hasStoryTemplate
                                  ? _c("vs-select-item", {
                                      attrs: {
                                        text: _vm.$t(
                                          "dash.post.story.select-template.custom_template"
                                        ),
                                        value: "custom",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.typePost === "story" && !_vm.storyVideo
                      ? _c("div", { staticClass: "input-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass: "disable-story-btn",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return (() => {
                                    !_vm.onlyInstagramConciergerieSelected() &&
                                      _vm.showConciergerieForm()
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    active:
                                      !_vm.onlyInstagramConciergerieSelected(),
                                    text: _vm.$t("dash.bots.status_proxy"),
                                  },
                                },
                                [
                                  _c("vs-input", {
                                    staticClass: "shared-story-url",
                                    attrs: {
                                      disabled:
                                        !_vm.onlyInstagramConciergerieSelected(),
                                      size: "large",
                                      label: _vm.$t("dash.post.shared_story"),
                                      placeholder:
                                        "ex: https://www.instagram.com/p/CkZKETvycAf/",
                                    },
                                    model: {
                                      value: _vm.sharedStoryUrl,
                                      callback: function ($$v) {
                                        _vm.sharedStoryUrl = $$v
                                      },
                                      expression: "sharedStoryUrl",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.typePost == "image" &&
                    _vm.carouselPossible() &&
                    _vm.atLeastInstagramSelected() &&
                    _vm.multipleImages.length > 1 &&
                    _vm.state !== "edit-posted"
                      ? _c("span", { staticClass: "ratio-carousel" }, [
                          _vm._v("\n          Ratio: \n          "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.carrouselRatio,
                                expression: "carrouselRatio",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "ratio",
                              id: "original",
                            },
                            domProps: {
                              value: 0,
                              checked: _vm._q(_vm.carrouselRatio, 0),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  _vm.carrouselRatio = 0
                                },
                                _vm.changeCarrouselRatio,
                              ],
                            },
                          }),
                          _vm._v(" Original\n          "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.carrouselRatio,
                                expression: "carrouselRatio",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "ratio",
                              id: "landscape",
                            },
                            domProps: {
                              value: 1.91 / 1,
                              checked: _vm._q(_vm.carrouselRatio, 1.91 / 1),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  _vm.carrouselRatio = 1.91 / 1
                                },
                                _vm.changeCarrouselRatio,
                              ],
                            },
                          }),
                          _vm._v(" 16:9\n          "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.carrouselRatio,
                                expression: "carrouselRatio",
                              },
                            ],
                            attrs: {
                              checked: "",
                              type: "radio",
                              name: "ratio",
                              id: "square",
                            },
                            domProps: {
                              value: 1,
                              checked: _vm._q(_vm.carrouselRatio, 1),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  _vm.carrouselRatio = 1
                                },
                                _vm.changeCarrouselRatio,
                              ],
                            },
                          }),
                          _vm._v(" 1:1\n          "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.carrouselRatio,
                                expression: "carrouselRatio",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "ratio",
                              id: "vertical",
                            },
                            domProps: {
                              value: 4 / 5,
                              checked: _vm._q(_vm.carrouselRatio, 4 / 5),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  _vm.carrouselRatio = 4 / 5
                                },
                                _vm.changeCarrouselRatio,
                              ],
                            },
                          }),
                          _vm._v(" 4:5\n        "),
                        ])
                      : _vm._e(),
                    ["image", "video"].includes(_vm.typePost) &&
                    ((_vm.atLeastInstagramConciergerieSelected() &&
                      _vm.multipleMedias.length <= 1) ||
                      (_vm.atLeastFacebookSelected() &&
                        _vm.videoReelFB &&
                        _vm.typePost === "video" &&
                        !_vm.atLeastInstagramSelected()))
                      ? _c(
                          "div",
                          { staticClass: "tag-buttons" },
                          [
                            _vm.atLeastInstagramConciergerieSelected()
                              ? _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      active:
                                        (_vm.typePost === "image" &&
                                          !_vm.url &&
                                          !_vm.form.url) ||
                                        (_vm.typePost === "video" &&
                                          !_vm.form.video),
                                      text:
                                        _vm.typePost === "video"
                                          ? _vm.$t(
                                              "dash.post.error.need_video.title"
                                            )
                                          : _vm.$t(
                                              "dash.post.error.need_image.title"
                                            ),
                                      position: "top",
                                    },
                                  },
                                  [
                                    _vm._v("\n             \n            "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn-add",
                                        attrs: {
                                          type: "button",
                                          disabled:
                                            (_vm.typePost === "image" &&
                                              !_vm.url &&
                                              !_vm.form.url) ||
                                            (_vm.typePost === "video" &&
                                              !_vm.form.video),
                                        },
                                        on: { click: () => _vm.openTag() },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("dash.posts.form.add_tag")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  active:
                                    (_vm.typePost === "image" &&
                                      !_vm.url &&
                                      !_vm.form.url) ||
                                    (_vm.typePost === "video" &&
                                      !_vm.form.video) ||
                                    (_vm.userTags &&
                                      _vm.userTags.collab &&
                                      _vm.userTags.collab.length >= 5),
                                  text:
                                    _vm.userTags &&
                                    _vm.userTags.collab &&
                                    _vm.userTags.collab.length >= 5
                                      ? _vm.$t("dash.post.collab.limit")
                                      : _vm.typePost === "video"
                                      ? _vm.$t(
                                          "dash.post.error.need_video.title"
                                        )
                                      : _vm.$t(
                                          "dash.post.error.need_image.title"
                                        ),
                                  position: "top",
                                },
                              },
                              [
                                _vm._v("\n           \n            "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-add",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        (_vm.typePost === "image" &&
                                          !_vm.url &&
                                          !_vm.form.url) ||
                                        (_vm.typePost === "video" &&
                                          !_vm.form.video) ||
                                        (_vm.userTags &&
                                          _vm.userTags.collab &&
                                          _vm.userTags.collab.length >= 5),
                                    },
                                    on: { click: () => _vm.openTag(true) },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dash.posts.form.add_colab")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm.userTags.list.filter(
                              (e) => !_vm.userTags.collab.includes(e.id)
                            ).length
                              ? _c(
                                  "p",
                                  [
                                    _vm._v("Tags :\n            "),
                                    _vm._l(
                                      _vm.userTags.list.filter(
                                        (e) =>
                                          e.id !== _vm.userTags.collab &&
                                          !_vm.userTags.collab.includes(e.id)
                                      ),
                                      function (tag) {
                                        return _c(
                                          "span",
                                          {
                                            key: tag.id,
                                            staticClass: "location-string",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(tag.username) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "remove-location",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeTag(tag.id)
                                                  },
                                                },
                                              },
                                              [_vm._v("x")]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.userTags.collab && _vm.userTags.collab.length
                              ? _c(
                                  "p",
                                  [
                                    _vm._v("Collab :\n            "),
                                    _vm._l(
                                      _vm.userTags.list.filter((e) =>
                                        _vm.userTags.collab.includes(e.id)
                                      ),
                                      function (collab) {
                                        return _c(
                                          "span",
                                          {
                                            key: collab.id,
                                            staticClass: "location-string",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(collab.username) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "remove-location",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeTag(
                                                      collab.id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("x")]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.atLeastInstagramConciergerieSelected()
                              ? _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      active:
                                        (_vm.typePost === "image" &&
                                          !_vm.url &&
                                          !_vm.form.url) ||
                                        (_vm.typePost === "video" &&
                                          !_vm.form.video),
                                      text:
                                        _vm.typePost === "video"
                                          ? _vm.$t(
                                              "dash.post.error.need_video.title"
                                            )
                                          : _vm.$t(
                                              "dash.post.error.need_image.title"
                                            ),
                                      position: "top",
                                    },
                                  },
                                  [
                                    _vm._v("\n           \n            "),
                                    _c("ShopSticker", {
                                      ref: "shop-tag",
                                      staticClass: "btn-add product",
                                      attrs: {
                                        pageId: _vm.bots.find(
                                          (e) =>
                                            _vm.bot.includes(e.id) &&
                                            e.page &&
                                            e.page.story_config &&
                                            e.page.network === "instagram"
                                        )
                                          ? _vm.bots.find(
                                              (e) =>
                                                _vm.bot.includes(e.id) &&
                                                e.page &&
                                                e.page.story_config &&
                                                e.page.network === "instagram"
                                            ).page.id
                                          : null,
                                        isConciergerie:
                                          _vm.atLeastInstagramConciergerieSelected(),
                                        disabled:
                                          (_vm.typePost === "image" &&
                                            !_vm.url &&
                                            !_vm.form.url) ||
                                          (_vm.typePost === "video" &&
                                            !_vm.form.video),
                                        tagUse:
                                          _vm.typePost === "image"
                                            ? "image"
                                            : "video",
                                        products: _vm.productTags,
                                      },
                                      on: {
                                        click: () => _vm.openTag(false, true),
                                        reconnect: _vm.showConciergerieForm,
                                        insertShop: (shop) =>
                                          _vm.typePost === "image"
                                            ? _vm.addTagProduct(shop)
                                            : _vm.$store.commit(
                                                "updateStorificationProduct",
                                                { items: shop }
                                              ),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.atLeastInstagramConciergerieSelected() &&
                            _vm.productTags
                              ? _c(
                                  "div",
                                  { staticClass: "layers-preview" },
                                  _vm._l(_vm.productTags, function (product) {
                                    return _c(
                                      "div",
                                      {
                                        key: product.id,
                                        staticClass: "layer-preview",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "remove-layer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeTagProduct(
                                                  product.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("x")]
                                        ),
                                        _c("img", {
                                          attrs: {
                                            src: product.image,
                                            alt: product.text,
                                          },
                                        }),
                                        _c("p", [_vm._v(_vm._s(product.text))]),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                            _c(
                              "dialog",
                              {
                                ref: "tagImage",
                                staticClass: "tag-img-container",
                                on: { click: _vm.cheekDialogOutsideClose },
                              },
                              [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(_vm.$t("dash.posts.text.tag_img")) +
                                      " "
                                  ),
                                  _c(
                                    "span",
                                    { on: { click: _vm.closeTagImage } },
                                    [_vm._v("✕")]
                                  ),
                                ]),
                                !_vm.multipleImages ||
                                _vm.multipleImages.length < 2
                                  ? _c("img", {
                                      class:
                                        _vm.userTags &&
                                        _vm.userTags.collab &&
                                        _vm.userTags.collab.length >= 5 &&
                                        "disabled",
                                      attrs: {
                                        src:
                                          _vm.url ||
                                          (_vm.meta &&
                                            _vm.meta.og &&
                                            _vm.meta.og.image),
                                      },
                                      on: { click: _vm.tagImageLocation },
                                    })
                                  : _c(
                                      "carousel",
                                      {
                                        class:
                                          _vm.userTags &&
                                          _vm.userTags.collab &&
                                          _vm.userTags.collab.length >= 5 &&
                                          "disabled",
                                        attrs: {
                                          perPage: 1,
                                          scrollPerPage: true,
                                          paginationEnabled: true,
                                          adjustableHeight: true,
                                          centerMode: true,
                                        },
                                        model: {
                                          value: _vm.userTagPage,
                                          callback: function ($$v) {
                                            _vm.userTagPage = $$v
                                          },
                                          expression: "userTagPage",
                                        },
                                      },
                                      _vm._l(
                                        _vm.multipleImages.filter(
                                          (e) => e.file
                                        ),
                                        function (media, index) {
                                          return _c(
                                            "slide",
                                            {
                                              key: media.id,
                                              attrs: { "data-index": index },
                                              on: {
                                                slideClick:
                                                  _vm.tagImageLocation,
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _c("img", {
                                                  staticClass:
                                                    "carrousel-image",
                                                  class:
                                                    _vm.userTags &&
                                                    _vm.userTags.collab &&
                                                    _vm.userTags.collab
                                                      .length >= 5 &&
                                                    "disabled",
                                                  style: `aspect-ratio: ${
                                                    media.ratio === 0
                                                      ? _vm.firstImageAspectRatio
                                                      : media.ratio
                                                  } ;width: 494px; object-fit: 'cover';`,
                                                  attrs: {
                                                    id: `tagImg${index}`,
                                                    src: media.url,
                                                  },
                                                  on: {
                                                    mousemove: (e) => {
                                                      e.target.setAttribute(
                                                        "data-offsetX",
                                                        e.offsetX
                                                      )
                                                      e.target.setAttribute(
                                                        "data-offsetY",
                                                        e.offsetY
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                _vm.userTags &&
                                _vm.userTags.collab &&
                                _vm.userTags.collab.length >= 5
                                  ? _c(
                                      "p",
                                      { attrs: { id: "tooltip-collab" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("dash.post.collab.limit")
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._l(_vm.userTags.list, function (tag) {
                                  return _c(
                                    "span",
                                    {
                                      key: tag.id,
                                      staticClass: "tag-label",
                                      style: {
                                        display:
                                          !_vm.multipleImages ||
                                          _vm.multipleImages.length < 2 ||
                                          tag.index === _vm.userTagPage
                                            ? "inline"
                                            : "none",
                                        top: `${tag.y * 100}%`,
                                        left: `${tag.x * 100}%`,
                                        fontWeight: `${
                                          _vm.userTags.collab.includes(tag.id)
                                            ? "bold"
                                            : "normal"
                                        }`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(tag.username) +
                                          " \n              "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "remove-tag",
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeTag(tag.id)
                                            },
                                          },
                                        },
                                        [_vm._v("✕")]
                                      ),
                                    ]
                                  )
                                }),
                                _vm._l(_vm.productTags, function (tag) {
                                  return _c(
                                    "span",
                                    {
                                      key: tag.id,
                                      staticClass: "tag-label shop-label",
                                      style: {
                                        display:
                                          !_vm.multipleImages ||
                                          _vm.multipleImages.length < 2 ||
                                          tag.index === _vm.userTagPage
                                            ? "flex"
                                            : "none",
                                        top: `${tag.y * 100}%`,
                                        left: `${tag.x * 100}%`,
                                      },
                                    },
                                    [
                                      _c("img", { attrs: { src: tag.image } }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            tag.text &&
                                              tag.text.slice(0, 10) + "..."
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "remove-tag",
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeTagProduct(
                                                tag.id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("✕")]
                                      ),
                                    ]
                                  )
                                }),
                                _c(
                                  "dialog",
                                  {
                                    ref: "searchTagImg",
                                    staticClass: "searchTag",
                                  },
                                  [
                                    _vm.dialogImageTagIsOpen
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "auto-mentions",
                                            on: {
                                              keydown: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addTag(
                                                      "searchTagImg"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("OK")]
                                            ),
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ]
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.searchMention[
                                                          _vm.selectedBotMention
                                                        ].search,
                                                      expression:
                                                        "searchMention[selectedBotMention].search",
                                                    },
                                                  ],
                                                  ref: "inputSearchMentionTagImage",
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      `dash.posts.overlay.search_mention_placeholder_instagram_direct`
                                                    ),
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.searchMention[
                                                        _vm.selectedBotMention
                                                      ].search,
                                                  },
                                                  on: {
                                                    keyup: function ($event) {
                                                      return _vm.searchMentions(
                                                        "Mention"
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.searchMention[
                                                          _vm.selectedBotMention
                                                        ],
                                                        "search",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ] &&
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ].results &&
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ].results.length
                                              ? _c(
                                                  "ul",
                                                  {
                                                    attrs: {
                                                      id: "loadableContent-list-mentions",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.searchMention[
                                                      _vm.selectedBotMention
                                                    ].results.filter(
                                                      (e) =>
                                                        !_vm.userTags.list
                                                          .map((ee) => ee.id)
                                                          .includes(e.pk)
                                                    ),
                                                    function (mention, index) {
                                                      return _c(
                                                        "div",
                                                        { key: index },
                                                        [
                                                          _vm.mentionIsSelected(
                                                            "Mention",
                                                            mention
                                                          )
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  class: {
                                                                    select:
                                                                      _vm.mentionIsSelected(
                                                                        "Mention",
                                                                        mention
                                                                      ) == true,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectMention(
                                                                          "Mention",
                                                                          mention
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class:
                                                                        _vm
                                                                          .searchMention[
                                                                          _vm
                                                                            .selectedBotMention
                                                                        ].bot
                                                                          .page
                                                                          .network,
                                                                    },
                                                                    [
                                                                      mention.image
                                                                        ? _c(
                                                                            "img",
                                                                            {
                                                                              staticClass:
                                                                                "image",
                                                                              attrs:
                                                                                {
                                                                                  alt: mention.name,
                                                                                  src: mention.image,
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "content",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "name",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  mention.name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "name",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  mention.id
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              _vm.mentionIsSelected(
                                                                                "Mention",
                                                                                mention
                                                                              ) ==
                                                                              true,
                                                                            expression:
                                                                              "mentionIsSelected('Mention', mention) == true",
                                                                          },
                                                                        ],
                                                                      staticClass:
                                                                        "checkmark",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "material-icons",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "check"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm.searchMention[
                                                  _vm.selectedBotMention
                                                ] &&
                                                _vm.searchMention[
                                                  _vm.selectedBotMention
                                                ].results
                                              ? _c(
                                                  "ul",
                                                  {
                                                    attrs: {
                                                      id: "loadableContent-list-mentions",
                                                    },
                                                  },
                                                  [_vm._m(13)]
                                                )
                                              : _c("ul", {
                                                  staticClass: "empty",
                                                  attrs: {
                                                    id: "loadableContent-list-mentions",
                                                  },
                                                }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _c(
                              "dialog",
                              { ref: "searchTag", staticClass: "searchTag" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "auto-mentions",
                                    on: {
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addTag("searchTag")
                                          },
                                        },
                                      },
                                      [_vm._v("OK")]
                                    ),
                                    _vm.searchMention[_vm.selectedBotMention]
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.searchMention[
                                                  _vm.selectedBotMention
                                                ].search,
                                              expression:
                                                "searchMention[selectedBotMention].search",
                                            },
                                          ],
                                          ref: "inputSearchMentionTag",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              `dash.posts.overlay.search_mention_placeholder_instagram_direct`
                                            ),
                                          },
                                          domProps: {
                                            value:
                                              _vm.searchMention[
                                                _vm.selectedBotMention
                                              ].search,
                                          },
                                          on: {
                                            keyup: function ($event) {
                                              return _vm.searchMentions(
                                                "Mention"
                                              )
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.searchMention[
                                                  _vm.selectedBotMention
                                                ],
                                                "search",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.searchMention[_vm.selectedBotMention] &&
                                    _vm.searchMention[_vm.selectedBotMention]
                                      .results &&
                                    _vm.searchMention[_vm.selectedBotMention]
                                      .results.length
                                      ? _c(
                                          "ul",
                                          {
                                            attrs: {
                                              id: "loadableContent-list-mentions",
                                            },
                                          },
                                          _vm._l(
                                            _vm.searchMention[
                                              _vm.selectedBotMention
                                            ].results.filter(
                                              (e) =>
                                                !_vm.userTags.list
                                                  .map((ee) => ee.id)
                                                  .includes(e.pk)
                                            ),
                                            function (mention, index) {
                                              return _c("div", { key: index }, [
                                                _vm.mentionIsSelected(
                                                  "Mention",
                                                  mention
                                                )
                                                  ? _c(
                                                      "li",
                                                      {
                                                        class: {
                                                          select:
                                                            _vm.mentionIsSelected(
                                                              "Mention",
                                                              mention
                                                            ) == true,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.selectMention(
                                                              "Mention",
                                                              mention
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.searchMention[
                                                                _vm
                                                                  .selectedBotMention
                                                              ].bot.page
                                                                .network,
                                                          },
                                                          [
                                                            mention.image
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "image",
                                                                  attrs: {
                                                                    alt: mention.name,
                                                                    src: mention.image,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "content",
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "name",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        mention.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "screen_name id",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "@" +
                                                                        _vm._s(
                                                                          mention.id
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                                mention.subtitle
                                                                  ? _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "screen_name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            mention.subtitle
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm.mentionIsSelected(
                                                                    "Mention",
                                                                    mention
                                                                  ) == true,
                                                                expression:
                                                                  "mentionIsSelected('Mention', mention) == true",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "checkmark",
                                                          },
                                                          [
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [_vm._v("check")]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      : _vm.searchMention[
                                          _vm.selectedBotMention
                                        ] &&
                                        _vm.searchMention[
                                          _vm.selectedBotMention
                                        ].results
                                      ? _c(
                                          "ul",
                                          {
                                            attrs: {
                                              id: "loadableContent-list-mentions",
                                            },
                                          },
                                          [_vm._m(14)]
                                        )
                                      : _c("ul", {
                                          staticClass: "empty",
                                          attrs: {
                                            id: "loadableContent-list-mentions",
                                          },
                                        }),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.checkActiveLocationSearch
                      ? _c("div", { staticClass: "location" }, [
                          _c(
                            "div",
                            { staticClass: "container-location" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("dash.posts.location")) +
                                  " \n            "
                              ),
                              _vm.searchLocationInput
                                ? [
                                    _vm.searchLocationInput &&
                                    _vm.searchLocationInput.facebook &&
                                    _vm.atLeastNetworkSelected("facebook")
                                      ? _c(
                                          "div",
                                          { staticClass: "location-string" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.searchLocationInput
                                                    .facebook
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "remove-location",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeLocation(
                                                      "facebook"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("x")]
                                            ),
                                            _c("img", {
                                              attrs: {
                                                size: "25px",
                                                src: require("../../../assets/img/icon_fb.png"),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.searchLocationInput &&
                                    _vm.searchLocationInput.instagram &&
                                    _vm.atLeastNetworkSelected("instagram")
                                      ? _c(
                                          "div",
                                          { staticClass: "location-string" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.searchLocationInput
                                                    .instagram
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "remove-location",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeLocation(
                                                      "instagram"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("x")]
                                            ),
                                            _c("img", {
                                              attrs: {
                                                size: "25px",
                                                src: require("../../../assets/img/icon_instagram.png"),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("dash.bot.sources.none")
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "vs-popup",
                      {
                        attrs: {
                          active: _vm.carouselPopupMessage,
                          title: "Voulez vous continuer ?",
                        },
                        on: {
                          "update:active": function ($event) {
                            _vm.carouselPopupMessage = $event
                          },
                        },
                      },
                      [
                        _c("p", { staticClass: "popup-content" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.carouselPopupMessage) +
                              "\n          "
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            style: {
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "40px",
                            },
                          },
                          [
                            _c(
                              "vs-button",
                              {
                                style: { marginRight: "30px" },
                                on: {
                                  click: function ($event) {
                                    _vm.carouselPopupMessage = null
                                  },
                                },
                              },
                              [_vm._v("Annuler")]
                            ),
                            _c(
                              "vs-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.validate("posts")
                                  },
                                },
                              },
                              [_vm._v("Continuer")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm.getBoardPagePinterest
                      ? _c("div", { staticClass: "options-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "options-wrapper-tilte" },
                            [
                              _c("vs-avatar", {
                                attrs: {
                                  color: "transparent",
                                  size: "18px",
                                  src: require("../../../assets/img/ico-pinterest-circle.png"),
                                },
                              }),
                              _vm._v("\n            Pinterest\n          "),
                            ],
                            1
                          ),
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _vm.boards &&
                            _vm.boards.board &&
                            _vm.boards.board.items
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.boardSelected,
                                        expression: "form.boardSelected",
                                      },
                                    ],
                                    staticStyle: {
                                      "margin-top": "15px",
                                      "min-width": "175px",
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.form,
                                            "boardSelected",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                        function ($event) {
                                          return _vm.checkChildsBoard()
                                        },
                                      ],
                                    },
                                  },
                                  _vm._l(
                                    _vm.boards.board.items,
                                    function (item, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: item },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(item.name) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            _vm.form.boardSelected &&
                            _vm.form.boardSelected.childs &&
                            _vm.form.boardSelected.childs.board &&
                            _vm.form.boardSelected.childs.board.items.length
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.form.boardSelected.childs
                                            .selected,
                                        expression:
                                          "form.boardSelected.childs.selected",
                                      },
                                    ],
                                    staticStyle: {
                                      "margin-top": "15px",
                                      "min-width": "175px",
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.form.boardSelected.childs,
                                          "selected",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("dash.post.board.choice")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.form.boardSelected.childs.board.items,
                                      function (item, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: { value: item },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(item.name) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-left": "10px",
                                },
                              },
                              [
                                _c("vs-input", {
                                  attrs: {
                                    label: "Créer un nouveau tableau",
                                    placeholder: "",
                                  },
                                  model: {
                                    value: _vm.newBoardName,
                                    callback: function ($$v) {
                                      _vm.newBoardName = $$v
                                    },
                                    expression: "newBoardName",
                                  },
                                }),
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "page-btn",
                                    staticStyle: {
                                      padding: "0px",
                                      height: "30px !important",
                                      width: "70px",
                                      "padding-left": "10px",
                                      "padding-right": "10px",
                                      "margin-left": "5px",
                                      "margin-top": "15px",
                                    },
                                    attrs: {
                                      "vs-type": "filled",
                                      color: "#6a1f4c",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.newBoardofPinterest()
                                      },
                                    },
                                  },
                                  [_vm._v("créer")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.bot.length > 0
                  ? _c(
                      "vs-collapse",
                      {
                        key: _vm.keyRefresh,
                        class: [{ screenshot: _vm.hideToScreenshot }],
                      },
                      _vm._l(_vm.reverseBot, function (item, index) {
                        return _c(
                          "vs-collapse-item",
                          {
                            key: index,
                            staticClass: "open-item",
                            class: _vm.getPageInfoByBot(item)
                              ? _vm.getPageInfoByBot(item).network
                              : "",
                            attrs: { open: true },
                          },
                          [
                            _vm.getPageInfoByBot(item)
                              ? _c(
                                  "div",
                                  { attrs: { slot: "header" }, slot: "header" },
                                  [
                                    _c("page-image-avatar", {
                                      attrs: {
                                        page: _vm.getPageInfoByBot(item),
                                      },
                                    }),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getPageInfoByBot(item).name
                                        ) +
                                        "\n          "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                ref: `preview-post-${item}`,
                                refInFor: true,
                                staticClass: "preview",
                                attrs: { id: `preview-post-${item}` },
                              },
                              [
                                _vm.getPageInfoByBot(item) &&
                                _vm.getPageInfoByBot(item).network
                                  ? _c("preview-post", {
                                      attrs: {
                                        page:
                                          _vm.state == "retweet"
                                            ? _vm.getPageInfo
                                            : _vm.getPageInfoByBot(item),
                                        post: {
                                          ..._vm.form,
                                          title: _vm.formTitleCopy,
                                          video:
                                            _vm.videos[_vm.videoType(item)] ||
                                            _vm.form.video ||
                                            null,
                                        },
                                        retweet:
                                          _vm.state == "retweet"
                                            ? _vm.getPageInfoByBot(item)
                                            : null,
                                        resharePage:
                                          _vm.state == "reshare"
                                            ? _vm.getPageInfo
                                            : null,
                                        reshare:
                                          _vm.state == "reshare"
                                            ? _vm.post
                                            : null,
                                        image: _vm.url,
                                        activeMentionsAutoReplace:
                                          _vm.activeMentionsAutoReplace,
                                        activeHashtagsAutoAdd:
                                          _vm.activeHashtagsAutoAdd,
                                        activePrefixSuffix:
                                          _vm.activePrefixSuffix,
                                        validMentions: _vm.validMentions,
                                        validHashtags: _vm.validHashtags,
                                        typePost: _vm.typePost,
                                        live: true,
                                        doScreenshot: _vm.doScreenshot,
                                        editPostValue: _vm.editPostValue,
                                        schedulingOverlay: _vm.scheduling,
                                        currentPostFieldEdit:
                                          _vm.currentPostFieldEdit,
                                        pdfTitle: _vm.form.documentTitle,
                                        poll: _vm.poll,
                                        multipleImages: _vm.multipleImages,
                                        multipleMedias: _vm.multipleMedias,
                                        injectedSnippetTitle: _vm.snippetTitle,
                                        injectedSnippet: _vm.snippet,
                                        previewEdited: _vm.previewEdited,
                                        videoReel:
                                          _vm.getPageInfoByBot(item).network ==
                                          "facebook"
                                            ? _vm.videoReelFB
                                            : _vm.videoReel &&
                                              _vm.getPageInfoByBot(item)
                                                .network == "instagram",
                                        shareAfterPost: _vm.shareAfterPost,
                                        storyShareToFacebook:
                                          _vm.storyShareToFacebook,
                                        storificationObject:
                                          _vm.storificationObject,
                                        location: _vm.selectedLocation
                                          ? _vm.selectedLocation[
                                              _vm.getPageInfoByBot(item).network
                                            ]
                                          : null,
                                        compressedImages: _vm.compressedImages,
                                        highlightStoryEnable:
                                          _vm.reverseBot.length < 2,
                                        userTags:
                                          _vm.userTags &&
                                          _vm.userTags.list &&
                                          _vm.userTags.list.length > 0
                                            ? _vm.userTags
                                            : null,
                                        productTags: _vm.productTags,
                                        index: index,
                                      },
                                      on: {
                                        editPostLive: _vm.editPostLive,
                                        removeCustomized: _vm.removeCustomized,
                                        currentPostLive: _vm.currentPostLive,
                                        updateMultipleImages:
                                          _vm.updateMultipleImages,
                                        changeSnippetTitle: (snippet_title) => {
                                          _vm.snippetTitle = snippet_title
                                        },
                                        changeSnippet: _vm.modifySnippetLink,
                                        closeAutoMentions:
                                          _vm.closeAutoMentions,
                                        editMention: _vm.editMention,
                                        addMention: _vm.addMention,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _vm.optimalTimes && _vm.activeOptimalTimes
                  ? _c(
                      "div",
                      { staticClass: "planning" },
                      [
                        _c("component-optimal-posts-planning", {
                          attrs: {
                            interaction: true,
                            network: this.getPageInfoByBot(this.bot).network,
                            optimalTimes: this.optimalTimes,
                          },
                          on: {
                            setScheduleDate: _vm.changeScheduleDate,
                            refreshData: _vm.refreshOptimalTimes,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !(_vm.localStorage && _vm.localStorage.preview_overlay)
                  ? _c(
                      "div",
                      {
                        staticClass: "button-wrapper",
                        class: _vm.tabsIsMinimize ? "large" : "",
                      },
                      [
                        ["Admin", "Editor", "Writter"].includes(_vm.getUserRole)
                          ? [
                              _vm.scheduling.show === false &&
                              _vm.state == "edit"
                                ? _c(
                                    "vs-button",
                                    {
                                      staticClass: "page-btn",
                                      attrs: {
                                        "vs-type": "filled",
                                        color: "#6a1f4c",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.deleteScheduled.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("dash.button.delete"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              ["Admin", "Editor"].includes(_vm.getUserRole)
                                ? [
                                    _vm.cantConnect
                                      ? _c(
                                          "Tooltip",
                                          {
                                            staticStyle: { float: "right" },
                                            attrs: {
                                              text: _vm.$t(
                                                _vm.onUpload
                                                  ? "dash.tooltip.upload_media"
                                                  : "dash.post.error.need_image.title"
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "page-btn",
                                                attrs: {
                                                  disabled: true,
                                                  "vs-type": "filled",
                                                  color: "#6a1f4c",
                                                  "data-qa": "form-post-submit",
                                                },
                                                on: { click: _vm.confirmPost },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.state == "retweet"
                                                        ? "dash.button.retweet"
                                                        : "dash.button.post"
                                                    )
                                                  ) +
                                                    " (" +
                                                    _vm._s(_vm.bot.length) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n             \n          "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm.scheduling.show === false &&
                                        !(
                                          (!_vm.haveContentToPost &&
                                            _vm.typePost !== "story" &&
                                            !(
                                              _vm.onlyTiktokSelected() &&
                                              _vm.videos.tiktok
                                            )) ||
                                          _vm.onUpload
                                        )
                                      ? _c(
                                          "vs-button",
                                          {
                                            staticClass: "page-btn",
                                            attrs: {
                                              disabled: _vm.showConfirmPost,
                                              "vs-type": "filled",
                                              color: "#6a1f4c",
                                              "data-qa": "form-post-submit",
                                            },
                                            on: { click: _vm.confirmPost },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.state == "retweet"
                                                    ? "dash.button.retweet"
                                                    : _vm.state == "edit-posted"
                                                    ? "dash.button.edit"
                                                    : "dash.button.post"
                                                )
                                              ) +
                                                " (" +
                                                _vm._s(_vm.bot.length) +
                                                ")"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              _c(
                                "vs-prompt",
                                {
                                  staticClass: "confirm-post",
                                  attrs: {
                                    title: _vm.$t("dash.confirm.post.title"),
                                    "accept-text": _vm.$t("dash.confirm"),
                                    "cancel-text": _vm.$t("dash.cancel"),
                                    active: _vm.showConfirmPost,
                                  },
                                  on: {
                                    accept: function ($event) {
                                      _vm.storyMultiple.length > 1
                                        ? _vm.validateMultipleStory("post")
                                        : _vm.validate("posts")
                                    },
                                    "update:active": function ($event) {
                                      _vm.showConfirmPost = $event
                                    },
                                  },
                                },
                                [
                                  _vm.typePost === "standard" &&
                                  (!_vm.form.url || _vm.form.url == "")
                                    ? _c(
                                        "div",
                                        { staticClass: "warning-no-media" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.confirm.post.warning_standard_without_url"
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.bot.length > 0
                                    ? _c(
                                        "vs-collapse",
                                        _vm._l(
                                          _vm.reverseBot,
                                          function (item, index) {
                                            return _c(
                                              "vs-collapse-item",
                                              {
                                                key: index,
                                                staticClass: "open-item",
                                                class: _vm.getPageInfoByBot(
                                                  item
                                                )
                                                  ? _vm.getPageInfoByBot(item)
                                                      .network
                                                  : "",
                                                attrs: { open: true },
                                              },
                                              [
                                                _vm.getPageInfoByBot(item)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          slot: "header",
                                                        },
                                                        slot: "header",
                                                      },
                                                      [
                                                        _c(
                                                          "page-image-avatar",
                                                          {
                                                            attrs: {
                                                              page: _vm.getPageInfoByBot(
                                                                item
                                                              ),
                                                            },
                                                          }
                                                        ),
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              _vm.getPageInfoByBot(
                                                                item
                                                              ).name
                                                            ) +
                                                            "\n                "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  { staticClass: "preview" },
                                                  [
                                                    _vm.getPageInfoByBot(
                                                      item
                                                    ) &&
                                                    _vm.getPageInfoByBot(item)
                                                      .network
                                                      ? _c("preview-post", {
                                                          attrs: {
                                                            page:
                                                              _vm.state ==
                                                              "retweet"
                                                                ? _vm.getPageInfo
                                                                : _vm.getPageInfoByBot(
                                                                    item
                                                                  ),
                                                            post: {
                                                              ..._vm.form,
                                                              title:
                                                                _vm.formTitleCopy,
                                                              description:
                                                                _vm.getBoardPagePinterest ||
                                                                _vm.atLeastWonderpushSelected() ||
                                                                _vm.atLeastNetworkSelected(
                                                                  "youtube"
                                                                )
                                                                  ? _vm.form
                                                                      .description
                                                                  : _vm.formTitleCopy,
                                                              video:
                                                                _vm.videos[
                                                                  _vm.videoType(
                                                                    item
                                                                  )
                                                                ] ||
                                                                _vm.form
                                                                  .video ||
                                                                null,
                                                            },
                                                            retweet:
                                                              _vm.state ==
                                                              "retweet"
                                                                ? _vm.getPageInfoByBot(
                                                                    item
                                                                  )
                                                                : null,
                                                            resharePage:
                                                              _vm.state ==
                                                              "reshare"
                                                                ? _vm.getPageInfo
                                                                : null,
                                                            reshare:
                                                              _vm.state ==
                                                              "reshare"
                                                                ? _vm.post
                                                                : null,
                                                            image: _vm.url,
                                                            activeMentionsAutoReplace:
                                                              _vm.activeMentionsAutoReplace,
                                                            activeHashtagsAutoAdd:
                                                              _vm.activeHashtagsAutoAdd,
                                                            activePrefixSuffix:
                                                              _vm.activePrefixSuffix,
                                                            validMentions:
                                                              _vm.validMentions,
                                                            validHashtags:
                                                              _vm.validHashtags,
                                                            typePost:
                                                              _vm.typePost,
                                                            showLive: true,
                                                            editPostValue:
                                                              _vm.editPostValue,
                                                            schedulingOverlay:
                                                              _vm.scheduling,
                                                            pdfTitle:
                                                              _vm.form
                                                                .documentTitle,
                                                            poll: _vm.poll,
                                                            injectedSnippetTitle:
                                                              _vm.snippetTitle,
                                                            injectedSnippet:
                                                              _vm.snippet,
                                                            multipleImages:
                                                              _vm.multipleImages,
                                                            multipleMedias:
                                                              _vm.multipleMedias,
                                                            shareAfterPost:
                                                              _vm.shareAfterPost,
                                                            storyShareToFacebook:
                                                              _vm.storyShareToFacebook,
                                                            storificationObject:
                                                              _vm.storificationObject,
                                                            videoReel:
                                                              _vm.getPageInfoByBot(
                                                                item
                                                              ).network ==
                                                              "facebook"
                                                                ? _vm.videoReelFB
                                                                : _vm.videoReel,
                                                            location:
                                                              _vm.selectedLocation
                                                                ? _vm
                                                                    .selectedLocation[
                                                                    _vm.getPageInfoByBot(
                                                                      item
                                                                    ).network
                                                                  ]
                                                                : null,
                                                            userTags:
                                                              _vm.userTags &&
                                                              _vm.userTags
                                                                .list &&
                                                              _vm.userTags.list
                                                                .length > 0
                                                                ? _vm.userTags
                                                                : null,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "schedule" },
                                [
                                  _vm.scheduling.show !== false
                                    ? _c(
                                        "div",
                                        { staticClass: "schedule-wrapper" },
                                        [
                                          _c("component-datepicker", {
                                            staticClass: "posts-datepicker",
                                            attrs: {
                                              date: new Date(
                                                _vm.scheduling.date
                                              ),
                                              now: true,
                                            },
                                            on: { picked: _vm.picked },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "posts-timepicker" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/icon_time_black.svg"),
                                                  alt: "time",
                                                },
                                              }),
                                              _c("vue-timepicker", {
                                                key: _vm.scheduling.time.mm,
                                                attrs: {
                                                  "hour-range": _vm.rangeHour,
                                                  "minute-range":
                                                    _vm.rangeMinute,
                                                  "auto-scroll": "",
                                                  "minute-interval":
                                                    _vm.minuteInterval,
                                                },
                                                on: {
                                                  change:
                                                    _vm.changeRangeSchedulingTime,
                                                },
                                                model: {
                                                  value: _vm.scheduling.time,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.scheduling,
                                                      "time",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scheduling.time",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.scheduling.show === false &&
                                  ((!_vm.isUserPremiumActive &&
                                    !_vm.isUserPartner) ||
                                    !_vm.checkLock("planner")) &&
                                  _vm.state !== "edit-posted"
                                    ? _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.$t(
                                              "dash.plan.change_to_get_features"
                                            ),
                                            position: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "vs-button",
                                            {
                                              staticClass: "page-btn btn-img",
                                              attrs: {
                                                disabled: true,
                                                color: "#6a1f4c",
                                                "vs-type": "filled",
                                                "data-qa": "form-post-schedule",
                                              },
                                            },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.button.schedule"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/icon_time_white.svg"),
                                                  alt: "schedule",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v("\n             \n          "),
                                        ],
                                        1
                                      )
                                    : _vm.scheduling.show === false &&
                                      _vm.state !== "edit-posted"
                                    ? _c(
                                        "vs-button",
                                        {
                                          staticClass: "page-btn btn-img",
                                          attrs: {
                                            color: "#6a1f4c",
                                            "vs-type": "filled",
                                            "data-qa": "form-post-schedule",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              ;[
                                                _vm.schedule(),
                                                (_vm.isDisable = false),
                                                (_vm.activeOptimalTimes = false),
                                              ]
                                            },
                                          },
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("dash.button.schedule")
                                              )
                                            ),
                                          ]),
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../assets/img/icon_time_white.svg"),
                                              alt: "schedule",
                                            },
                                          }),
                                        ]
                                      )
                                    : ["Admin", "Editor"].includes(
                                        _vm.getUserRole
                                      ) &&
                                      ((!_vm.haveContentToPost &&
                                        _vm.typePost !== "story" &&
                                        !(
                                          _vm.onlyTiktokSelected() &&
                                          _vm.videos.tiktok
                                        )) ||
                                        _vm.onUpload ||
                                        _vm.missingDataToPost) &&
                                      _vm.state !== "edit-posted"
                                    ? _c(
                                        "Tooltip",
                                        {
                                          staticStyle: { float: "left" },
                                          attrs: {
                                            text: _vm.$t(
                                              _vm.onUpload
                                                ? "dash.tooltip.upload_media"
                                                : "dash.post.error.need_image.title"
                                            ),
                                            position: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "vs-button",
                                            {
                                              staticClass: "page-btn btn-img",
                                              attrs: {
                                                disabled: true,
                                                "vs-type": "filled",
                                                color: "#6a1f4c",
                                                "data-qa":
                                                  "form-post-submit-schedule",
                                              },
                                              on: { click: _vm.confirmPost },
                                            },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.state === "edit"
                                                        ? "dash.button.modify"
                                                        : "dash.button.schedule"
                                                    )
                                                  ) +
                                                    " (" +
                                                    _vm._s(_vm.bot.length) +
                                                    ")"
                                                ),
                                              ]),
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/icon_time_white.svg"),
                                                  alt: "schedule",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v("\n             \n          "),
                                        ],
                                        1
                                      )
                                    : ["Admin", "Editor"].includes(
                                        _vm.getUserRole
                                      ) && _vm.state !== "edit-posted"
                                    ? _c(
                                        "vs-button",
                                        {
                                          staticClass: "page-btn btn-img",
                                          attrs: {
                                            disabled: _vm.showConfirmPost,
                                            "vs-type": "filled",
                                            color: "#6a1f4c",
                                            "data-qa":
                                              "form-post-submit-schedule",
                                          },
                                          on: { click: _vm.confirmPost },
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.isAffectedPost()
                                                    ? "dash.button.validate"
                                                    : _vm.state === "edit"
                                                    ? "dash.button.modify"
                                                    : "dash.button.schedule"
                                                )
                                              ) +
                                                " (" +
                                                _vm._s(_vm.bot.length) +
                                                ")"
                                            ),
                                          ]),
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../assets/img/icon_time_white.svg"),
                                              alt: "schedule",
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm.scheduling.show === true
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "cancel-btn",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.scheduling.show = false
                                          _vm.activeOptimalTimes = false
                                          _vm.initTooltip()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "p",
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  "dash.tooltip.cancel_scheduled"
                                                ),
                                                position: "top",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dash.button.cancel")
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" \n            "),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "top-btn" },
                          [
                            _c(
                              "vs-button",
                              {
                                staticClass: "page-btn close",
                                attrs: {
                                  color: "#6a1f4c",
                                  "vs-type": "filled",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.close()
                                  },
                                },
                              },
                              [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.$t("dash.button.cancel"))),
                                ]),
                              ]
                            ),
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  text: _vm.$t(
                                    (!(
                                      _vm.haveContentToPost ||
                                      _vm.form.title.length
                                    ) &&
                                      _vm.typePost !== "story" &&
                                      !(
                                        _vm.onlyTiktokSelected() &&
                                        _vm.videos.tiktok
                                      )) ||
                                      _vm.onUpload
                                      ? _vm.onUpload
                                        ? "dash.tooltip.upload_media"
                                        : "dash.post.error.need_image.title"
                                      : "dash.tooltip.save_draft"
                                  ),
                                  position: "top",
                                },
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "page-btn",
                                    attrs: {
                                      "vs-type": "filled",
                                      color: "#6a1f4c",
                                      disabled:
                                        (!(
                                          _vm.haveContentToPost ||
                                          _vm.form.title.length
                                        ) &&
                                          _vm.typePost !== "story" &&
                                          !(
                                            _vm.onlyTiktokSelected() &&
                                            _vm.videos.tiktok
                                          )) ||
                                        _vm.onUpload,
                                      "data-qa": "save-post-draft",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveDraft(false)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          _vm.state === "edit"
                                            ? "dash.button.duplicate"
                                            : "dash.button.save"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v("\n             \n          "),
                              ],
                              1
                            ),
                            _vm.state === "new" &&
                            _vm.localStorage.last_post_draft
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "cancel-btn",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.fillFormWithDraft(true)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "p",
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.tooltip.restore_last_post"
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dash.button.restore")
                                                )
                                              ),
                                            ]),
                                            _vm._v(" \n              "),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.state === "edit-draft"
                              ? _c(
                                  "vs-button",
                                  {
                                    staticClass: "page-btn remove-draft",
                                    attrs: {
                                      "vs-type": "filled",
                                      color: "#6a1f4c",
                                      "data-qa": "delete-post-draft",
                                    },
                                    on: { click: _vm.removeDraft },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("dash.button.delete")))]
                                )
                              : _vm._e(),
                            _c(
                              "vs-button",
                              {
                                staticClass: "page-btn",
                                attrs: {
                                  color: "#6a1f4c",
                                  "vs-type": "filled",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.popupSelectUser = true
                                  },
                                },
                              },
                              [
                                _vm.affectedTo && _vm.affectedTo.users
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.post.affected_to.title"
                                          ) +
                                            ` : ${_vm.affectedTo.users
                                              .map(
                                                (u) =>
                                                  `${u.firstname} ${u.lastname}`
                                              )
                                              .join(", ")}`
                                        )
                                      ),
                                    ])
                                  : _vm.affectedTo && _vm.affectedTo.user
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.post.affected_to.title"
                                          ) +
                                            (_vm.affectedTo.user
                                              ? ` : ${_vm.affectedTo.user.firstname} ${_vm.affectedTo.user.lastname}`
                                              : "")
                                        )
                                      ),
                                    ])
                                  : _vm.affectedTo
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.post.affected_to.title"
                                          ) +
                                            (_vm.affectedTo
                                              ? ` : ${_vm.affectedTo.firstname} ${_vm.affectedTo.lastname}`
                                              : "")
                                        )
                                      ),
                                    ])
                                  : _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.post.affected_to.title")
                                        )
                                      ),
                                    ]),
                              ]
                            ),
                            _c(
                              "vs-popup",
                              {
                                staticClass:
                                  "overlay groups shared-planner affected_to post-sidebar",
                                attrs: {
                                  title: _vm.$t(
                                    "dash.inbox.event.affected_to.title"
                                  ),
                                  active: _vm.popupSelectUser,
                                },
                                on: {
                                  "update:active": function ($event) {
                                    _vm.popupSelectUser = $event
                                  },
                                },
                              },
                              [
                                _vm.popupSelectUser
                                  ? _c("component-users-selector", {
                                      attrs: {
                                        manager: true,
                                        usersAdded: _vm.affectedTo
                                          ? _vm.affectedTo.users
                                            ? _vm.affectedTo.users
                                            : [
                                                _vm.affectedTo.user ||
                                                  _vm.affectedTo,
                                              ]
                                          : [],
                                        type: "affected_to",
                                        editOptionValidation: _vm.affectedTo
                                          ? _vm.affectedTo.optionValidation
                                          : null,
                                      },
                                      on: { submit: _vm.addAffectedToPost },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "vs-popup",
        {
          staticClass: "overlay posts-overlay-change-plan-conciergerie",
          attrs: {
            title: _vm.$t("dash.plan.active_conciergerie_to_get_features"),
            active: _vm.changePlanConciergerie,
          },
          on: {
            "update:active": function ($event) {
              _vm.changePlanConciergerie = $event
            },
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("dash.plan.active_conciergerie_to_get_features.content")
              )
            ),
          ]),
          _c("br"),
          _c(
            "vs-button",
            {
              staticClass: "btn-large btn-img",
              attrs: { color: "#303030", "vs-type": "filled" },
              on: { click: _vm.goToSettings },
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.button.changeplan")))]),
              _c("img", {
                attrs: {
                  src: require("../../../assets/img/icon_unlock.svg"),
                  alt: "unlock",
                },
              }),
            ]
          ),
        ],
        1
      ),
      _vm.activeConciergerie
        ? _c("component-conciergerie-form", {
            attrs: {
              page: _vm.activeConciergerie,
              activeConciergerie: _vm.activeConciergerie,
            },
            on: {
              getPagesEvent: _vm.getPagesEvent,
              closeActiveConciergerie: _vm.closeActiveConciergerie,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("p", [_vm._v("Aucun resultat")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("p", [_vm._v("Aucun resultat")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("p", [_vm._v("Aucun resultat")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("p", [_vm._v("Aucun resultat")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("p", [_vm._v("Aucun resultat")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("p", [_vm._v("Aucun resultat")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("p", [_vm._v("Aucun resultat")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("p", [_vm._v("Aucun resultat")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("p", [_vm._v("Aucun resultat")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }